export const data = [
  {
    id: "bitcoin",
    symbol: "btc",
    name: "Bitcoin",
    image:
      "https://assets.coingecko.com/coins/images/1/large/bitcoin.png?1547033579",
    current_price: 27209,
    market_cap: 525950346148,
    market_cap_rank: 1,
    fully_diluted_valuation: 571386659604,
    total_volume: 18581436885,
    high_24h: 28108,
    low_24h: 26720,
    price_change_24h: -887.6711344268733,
    price_change_percentage_24h: -3.15936,
    market_cap_change_24h: -17360003096.81067,
    market_cap_change_percentage_24h: -3.19523,
    circulating_supply: 19330093,
    total_supply: 21000000,
    max_supply: 21000000,
    ath: 69045,
    ath_change_percentage: -60.62817,
    ath_date: "2021-11-10T14:24:11.849Z",
    atl: 67.81,
    atl_change_percentage: 39989.35319,
    atl_date: "2013-07-06T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:30:58.704Z",
    price_change_percentage_14d_in_currency: 23.141027682805944,
    price_change_percentage_1h_in_currency: 0.024366650987030603,
    price_change_percentage_1y_in_currency: -38.87132668270908,
    price_change_percentage_200d_in_currency: 41.120362437319756,
    price_change_percentage_24h_in_currency: -3.159358812310631,
    price_change_percentage_30d_in_currency: 17.41995554869482,
    price_change_percentage_7d_in_currency: -3.4695411325901935,
  },
  {
    id: "ethereum",
    symbol: "eth",
    name: "Ethereum",
    image:
      "https://assets.coingecko.com/coins/images/279/large/ethereum.png?1595348880",
    current_price: 1716.62,
    market_cap: 206770394026,
    market_cap_rank: 2,
    fully_diluted_valuation: 206770394026,
    total_volume: 9728666270,
    high_24h: 1783.57,
    low_24h: 1698.22,
    price_change_24h: -63.906183580294055,
    price_change_percentage_24h: -3.58918,
    market_cap_change_24h: -7686569960.6432495,
    market_cap_change_percentage_24h: -3.5842,
    circulating_supply: 120452174.606695,
    total_supply: 120452174.606695,
    max_supply: null,
    ath: 4878.26,
    ath_change_percentage: -64.84741,
    ath_date: "2021-11-10T14:24:19.604Z",
    atl: 0.432979,
    atl_change_percentage: 395955.08949,
    atl_date: "2015-10-20T00:00:00.000Z",
    roi: {
      times: 83.41913630296052,
      currency: "btc",
      percentage: 8341.913630296052,
    },
    last_updated: "2023-03-27T23:31:33.592Z",
    price_change_percentage_14d_in_currency: 8.08598709981368,
    price_change_percentage_1h_in_currency: 0.17416803471927617,
    price_change_percentage_1y_in_currency: -45.34587329118097,
    price_change_percentage_200d_in_currency: 5.321544375981865,
    price_change_percentage_24h_in_currency: -3.589177688746427,
    price_change_percentage_30d_in_currency: 6.747992113760841,
    price_change_percentage_7d_in_currency: -4.704716402123936,
  },
  {
    id: "tether",
    symbol: "usdt",
    name: "Tether",
    image:
      "https://assets.coingecko.com/coins/images/325/large/Tether.png?1668148663",
    current_price: 1.002,
    market_cap: 79323285096,
    market_cap_rank: 3,
    fully_diluted_valuation: 79323285096,
    total_volume: 29462216744,
    high_24h: 1.005,
    low_24h: 0.997468,
    price_change_24h: 0.0006569,
    price_change_percentage_24h: 0.06558,
    market_cap_change_24h: 117414483,
    market_cap_change_percentage_24h: 0.14824,
    circulating_supply: 79180415495.4371,
    total_supply: 79180415495.4371,
    max_supply: null,
    ath: 1.32,
    ath_change_percentage: -24.28328,
    ath_date: "2018-07-24T00:00:00.000Z",
    atl: 0.572521,
    atl_change_percentage: 74.98124,
    atl_date: "2015-03-02T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:30:21.647Z",
    price_change_percentage_14d_in_currency: -0.4954452557566607,
    price_change_percentage_1h_in_currency: 0.10468570581174037,
    price_change_percentage_1y_in_currency: 0.27975406680072384,
    price_change_percentage_200d_in_currency: 0.21684956093211216,
    price_change_percentage_24h_in_currency: 0.06558135930843187,
    price_change_percentage_30d_in_currency: 0.24891958946888482,
    price_change_percentage_7d_in_currency: -0.4121020179778349,
  },
  {
    id: "binancecoin",
    symbol: "bnb",
    name: "BNB",
    image:
      "https://assets.coingecko.com/coins/images/825/large/bnb-icon2_2x.png?1644979850",
    current_price: 309.58,
    market_cap: 48879031540,
    market_cap_rank: 4,
    fully_diluted_valuation: 61913245007,
    total_volume: 939222773,
    high_24h: 329.72,
    low_24h: 306.46,
    price_change_24h: -19.849070591117766,
    price_change_percentage_24h: -6.02538,
    market_cap_change_24h: -3149733123.721611,
    market_cap_change_percentage_24h: -6.05383,
    circulating_supply: 157895234,
    total_supply: 157900174,
    max_supply: 200000000,
    ath: 686.31,
    ath_change_percentage: -54.91751,
    ath_date: "2021-05-10T07:24:17.097Z",
    atl: 0.0398177,
    atl_change_percentage: 776951.7482,
    atl_date: "2017-10-19T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:24.767Z",
    price_change_percentage_14d_in_currency: 6.827309358682291,
    price_change_percentage_1h_in_currency: 0.3791568912421092,
    price_change_percentage_1y_in_currency: -25.518600901166423,
    price_change_percentage_200d_in_currency: 11.049159265753584,
    price_change_percentage_24h_in_currency: -6.025383273403202,
    price_change_percentage_30d_in_currency: 2.56604698327521,
    price_change_percentage_7d_in_currency: -8.261029248075143,
  },
  {
    id: "usd-coin",
    symbol: "usdc",
    name: "USD Coin",
    image:
      "https://assets.coingecko.com/coins/images/6319/large/USD_Coin_icon.png?1547042389",
    current_price: 1.001,
    market_cap: 33497243060,
    market_cap_rank: 5,
    fully_diluted_valuation: 33497243060,
    total_volume: 4583731201,
    high_24h: 1.004,
    low_24h: 0.997619,
    price_change_24h: 0.0007402,
    price_change_percentage_24h: 0.07397,
    market_cap_change_24h: -438292530.17009735,
    market_cap_change_percentage_24h: -1.29154,
    circulating_supply: 33471771277.0073,
    total_supply: 33471771277.0073,
    max_supply: null,
    ath: 1.17,
    ath_change_percentage: -14.67022,
    ath_date: "2019-05-08T00:40:28.300Z",
    atl: 0.877647,
    atl_change_percentage: 14.01714,
    atl_date: "2023-03-11T08:02:13.981Z",
    roi: null,
    last_updated: "2023-03-27T23:31:36.883Z",
    price_change_percentage_14d_in_currency: 0.7848712050713538,
    price_change_percentage_1h_in_currency: 0.1088742092976854,
    price_change_percentage_1y_in_currency: 0.2181631293306381,
    price_change_percentage_200d_in_currency: 0.16133357894130865,
    price_change_percentage_24h_in_currency: 0.07396700610620463,
    price_change_percentage_30d_in_currency: 0.15766397719728678,
    price_change_percentage_7d_in_currency: 0.02205080953719188,
  },
  {
    id: "ripple",
    symbol: "xrp",
    name: "XRP",
    image:
      "https://assets.coingecko.com/coins/images/44/large/xrp-symbol-white-128.png?1605778731",
    current_price: 0.480924,
    market_cap: 24898558910,
    market_cap_rank: 6,
    fully_diluted_valuation: 48180015599,
    total_volume: 3376710573,
    high_24h: 0.488844,
    low_24h: 0.445064,
    price_change_24h: 0.02908701,
    price_change_percentage_24h: 6.4375,
    market_cap_change_24h: 1808239508,
    market_cap_change_percentage_24h: 7.83116,
    circulating_supply: 51678187732,
    total_supply: 99989057196,
    max_supply: 100000000000,
    ath: 3.4,
    ath_change_percentage: -85.82473,
    ath_date: "2018-01-07T00:00:00.000Z",
    atl: 0.00268621,
    atl_change_percentage: 17833.81367,
    atl_date: "2014-05-22T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:49.289Z",
    price_change_percentage_14d_in_currency: 29.117581707789626,
    price_change_percentage_1h_in_currency: 0.829073294899757,
    price_change_percentage_1y_in_currency: -42.127172788970555,
    price_change_percentage_200d_in_currency: 42.36414557254996,
    price_change_percentage_24h_in_currency: 6.437499492336025,
    price_change_percentage_30d_in_currency: 26.860985531251647,
    price_change_percentage_7d_in_currency: 23.539851050772636,
  },
  {
    id: "cardano",
    symbol: "ada",
    name: "Cardano",
    image:
      "https://assets.coingecko.com/coins/images/975/large/cardano.png?1547034860",
    current_price: 0.346284,
    market_cap: 12127769041,
    market_cap_rank: 7,
    fully_diluted_valuation: 15572814452,
    total_volume: 336713097,
    high_24h: 0.358105,
    low_24h: 0.338976,
    price_change_24h: -0.011313191805663536,
    price_change_percentage_24h: -3.16367,
    market_cap_change_24h: -403380578.31451225,
    market_cap_change_percentage_24h: -3.21902,
    circulating_supply: 35045020830.3234,
    total_supply: 45000000000,
    max_supply: 45000000000,
    ath: 3.09,
    ath_change_percentage: -88.79145,
    ath_date: "2021-09-02T06:00:10.474Z",
    atl: 0.01925275,
    atl_change_percentage: 1697.13615,
    atl_date: "2020-03-13T02:22:55.044Z",
    roi: null,
    last_updated: "2023-03-27T23:31:46.168Z",
    price_change_percentage_14d_in_currency: 4.6130513505425785,
    price_change_percentage_1h_in_currency: 0.340255923525307,
    price_change_percentage_1y_in_currency: -69.89859348767585,
    price_change_percentage_200d_in_currency: -27.83222092849452,
    price_change_percentage_24h_in_currency: -3.1636697862684207,
    price_change_percentage_30d_in_currency: -5.369343987945837,
    price_change_percentage_7d_in_currency: -0.6457229397968359,
  },
  {
    id: "dogecoin",
    symbol: "doge",
    name: "Dogecoin",
    image:
      "https://assets.coingecko.com/coins/images/5/large/dogecoin.png?1547792256",
    current_price: 0.073064,
    market_cap: 10133896581,
    market_cap_rank: 8,
    fully_diluted_valuation: null,
    total_volume: 557168244,
    high_24h: 0.076206,
    low_24h: 0.071986,
    price_change_24h: -0.001609845148068251,
    price_change_percentage_24h: -2.15583,
    market_cap_change_24h: -225939700.79639435,
    market_cap_change_percentage_24h: -2.18092,
    circulating_supply: 138698336383.705,
    total_supply: null,
    max_supply: null,
    ath: 0.731578,
    ath_change_percentage: -90.01378,
    ath_date: "2021-05-08T05:08:23.458Z",
    atl: 0.0000869,
    atl_change_percentage: 83966.59188,
    atl_date: "2015-05-06T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:39.609Z",
    price_change_percentage_14d_in_currency: 2.89093081302212,
    price_change_percentage_1h_in_currency: -0.1649662222368522,
    price_change_percentage_1y_in_currency: -46.25837281212192,
    price_change_percentage_200d_in_currency: 19.428225856653942,
    price_change_percentage_24h_in_currency: -2.155826743205662,
    price_change_percentage_30d_in_currency: -9.824386654310011,
    price_change_percentage_7d_in_currency: -2.938585113797039,
  },
  {
    id: "staked-ether",
    symbol: "steth",
    name: "Lido Staked Ether",
    image:
      "https://assets.coingecko.com/coins/images/13442/large/steth_logo.png?1608607546",
    current_price: 1711.57,
    market_cap: 10098705019,
    market_cap_rank: 9,
    fully_diluted_valuation: 10098705019,
    total_volume: 19969578,
    high_24h: 1778.37,
    low_24h: 1650.07,
    price_change_24h: -65.94826237805705,
    price_change_percentage_24h: -3.71013,
    market_cap_change_24h: -348206822.1697521,
    market_cap_change_percentage_24h: -3.33311,
    circulating_supply: 5873522.4254239,
    total_supply: 5873538.07452691,
    max_supply: 5873522.4254239,
    ath: 4829.57,
    ath_change_percentage: -64.39888,
    ath_date: "2021-11-10T14:40:47.256Z",
    atl: 482.9,
    atl_change_percentage: 256.05606,
    atl_date: "2020-12-22T04:08:21.854Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.203Z",
    price_change_percentage_14d_in_currency: 8.330754686022642,
    price_change_percentage_1h_in_currency: -0.026926028564894205,
    price_change_percentage_1y_in_currency: -45.464681708442804,
    price_change_percentage_200d_in_currency: 9.37766910839483,
    price_change_percentage_24h_in_currency: -3.7101252256642723,
    price_change_percentage_30d_in_currency: 6.586097975237585,
    price_change_percentage_7d_in_currency: -5.13301547605253,
  },
  {
    id: "matic-network",
    symbol: "matic",
    name: "Polygon",
    image:
      "https://assets.coingecko.com/coins/images/4713/large/matic-token-icon.png?1624446912",
    current_price: 1.046,
    market_cap: 9494580147,
    market_cap_rank: 10,
    fully_diluted_valuation: 10456045910,
    total_volume: 476876093,
    high_24h: 1.11,
    low_24h: 1.03,
    price_change_24h: -0.0642297589753642,
    price_change_percentage_24h: -5.78654,
    market_cap_change_24h: -588369922.9775696,
    market_cap_change_percentage_24h: -5.8353,
    circulating_supply: 9080469069.28493,
    total_supply: 10000000000,
    max_supply: 10000000000,
    ath: 2.92,
    ath_change_percentage: -64.14577,
    ath_date: "2021-12-27T02:08:34.307Z",
    atl: 0.00314376,
    atl_change_percentage: 33159.65087,
    atl_date: "2019-05-10T00:00:00.000Z",
    roi: {
      times: 396.62594466914527,
      currency: "usd",
      percentage: 39662.594466914525,
    },
    last_updated: "2023-03-27T23:31:28.759Z",
    price_change_percentage_14d_in_currency: -9.348147144336908,
    price_change_percentage_1h_in_currency: 0.04988560146395822,
    price_change_percentage_1y_in_currency: -35.010416212966575,
    price_change_percentage_200d_in_currency: 24.117964977663565,
    price_change_percentage_24h_in_currency: -5.7865377900334405,
    price_change_percentage_30d_in_currency: -17.309086884359743,
    price_change_percentage_7d_in_currency: -11.100605563802747,
  },
  {
    id: "binance-usd",
    symbol: "busd",
    name: "Binance USD",
    image:
      "https://assets.coingecko.com/coins/images/9576/large/BUSD.png?1568947766",
    current_price: 1.002,
    market_cap: 7844406521,
    market_cap_rank: 11,
    fully_diluted_valuation: 7844406521,
    total_volume: 4225182647,
    high_24h: 1.005,
    low_24h: 0.992752,
    price_change_24h: 0.00066857,
    price_change_percentage_24h: 0.06679,
    market_cap_change_24h: -188189811.3108816,
    market_cap_change_percentage_24h: -2.34283,
    circulating_supply: 7829888924.96,
    total_supply: 7829888924.96,
    max_supply: null,
    ath: 1.15,
    ath_change_percentage: -13.25761,
    ath_date: "2020-03-13T02:35:42.953Z",
    atl: 0.901127,
    atl_change_percentage: 11.10354,
    atl_date: "2021-05-19T13:04:37.445Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.498Z",
    price_change_percentage_14d_in_currency: -0.44684305480687775,
    price_change_percentage_1h_in_currency: 0.06626014993924347,
    price_change_percentage_1y_in_currency: 0.2365625244678014,
    price_change_percentage_200d_in_currency: 0.2614199870203972,
    price_change_percentage_24h_in_currency: 0.06679459070536603,
    price_change_percentage_30d_in_currency: 0.1669980893907154,
    price_change_percentage_7d_in_currency: 0.2444581538177349,
  },
  {
    id: "solana",
    symbol: "sol",
    name: "Solana",
    image:
      "https://assets.coingecko.com/coins/images/4128/large/solana.png?1640133422",
    current_price: 19.88,
    market_cap: 7625815243,
    market_cap_rank: 12,
    fully_diluted_valuation: 10800974966,
    total_volume: 401898992,
    high_24h: 21.06,
    low_24h: 19.61,
    price_change_24h: -1.1614697518504045,
    price_change_percentage_24h: -5.52121,
    market_cap_change_24h: -466229243.192914,
    market_cap_change_percentage_24h: -5.76158,
    circulating_supply: 384029024.632594,
    total_supply: 543927140.796505,
    max_supply: null,
    ath: 259.96,
    ath_change_percentage: -92.36233,
    ath_date: "2021-11-06T21:54:35.825Z",
    atl: 0.500801,
    atl_change_percentage: 3864.61239,
    atl_date: "2020-05-11T19:35:23.449Z",
    roi: null,
    last_updated: "2023-03-27T23:31:47.073Z",
    price_change_percentage_14d_in_currency: -2.2770319333134603,
    price_change_percentage_1h_in_currency: 0.001031455672567334,
    price_change_percentage_1y_in_currency: -80.44587380383395,
    price_change_percentage_200d_in_currency: -39.31727117500529,
    price_change_percentage_24h_in_currency: -5.521206621581582,
    price_change_percentage_30d_in_currency: -13.805418779398595,
    price_change_percentage_7d_in_currency: -9.749567876042141,
  },
  {
    id: "polkadot",
    symbol: "dot",
    name: "Polkadot",
    image:
      "https://assets.coingecko.com/coins/images/12171/large/polkadot.png?1639712644",
    current_price: 5.87,
    market_cap: 7132831213,
    market_cap_rank: 13,
    fully_diluted_valuation: 7607508891,
    total_volume: 164556256,
    high_24h: 6.11,
    low_24h: 5.78,
    price_change_24h: -0.20255876108092252,
    price_change_percentage_24h: -3.33815,
    market_cap_change_24h: -250379147.80832386,
    market_cap_change_percentage_24h: -3.3912,
    circulating_supply: 1216396997.45974,
    total_supply: 1297346130.37914,
    max_supply: null,
    ath: 54.98,
    ath_change_percentage: -89.33662,
    ath_date: "2021-11-04T14:10:09.301Z",
    atl: 2.7,
    atl_change_percentage: 117.34638,
    atl_date: "2020-08-20T05:48:11.359Z",
    roi: null,
    last_updated: "2023-03-27T23:31:40.641Z",
    price_change_percentage_14d_in_currency: -0.7538653981523956,
    price_change_percentage_1h_in_currency: 0.08168932619021436,
    price_change_percentage_1y_in_currency: -71.90070145615746,
    price_change_percentage_200d_in_currency: -18.561779479343123,
    price_change_percentage_24h_in_currency: -3.3381522167124005,
    price_change_percentage_30d_in_currency: -11.320413261889472,
    price_change_percentage_7d_in_currency: -9.881708687320966,
  },
  {
    id: "litecoin",
    symbol: "ltc",
    name: "Litecoin",
    image:
      "https://assets.coingecko.com/coins/images/2/large/litecoin.png?1547033580",
    current_price: 88.92,
    market_cap: 6457387520,
    market_cap_rank: 14,
    fully_diluted_valuation: 7473683132,
    total_volume: 619828629,
    high_24h: 93.96,
    low_24h: 88.02,
    price_change_24h: -4.963547641928599,
    price_change_percentage_24h: -5.28694,
    market_cap_change_24h: -378860566.57548237,
    market_cap_change_percentage_24h: -5.54194,
    circulating_supply: 72577408.2334713,
    total_supply: 84000000,
    max_supply: 84000000,
    ath: 410.26,
    ath_change_percentage: -78.31283,
    ath_date: "2021-05-10T03:13:07.904Z",
    atl: 1.15,
    atl_change_percentage: 7644.64237,
    atl_date: "2015-01-14T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:30:57.607Z",
    price_change_percentage_14d_in_currency: 16.858665266778985,
    price_change_percentage_1h_in_currency: 0.21117815246152843,
    price_change_percentage_1y_in_currency: -28.689163408914226,
    price_change_percentage_200d_in_currency: 54.67601482286242,
    price_change_percentage_24h_in_currency: -5.286936342483693,
    price_change_percentage_30d_in_currency: -2.850674193042445,
    price_change_percentage_7d_in_currency: 4.591611402095362,
  },
  {
    id: "shiba-inu",
    symbol: "shib",
    name: "Shiba Inu",
    image:
      "https://assets.coingecko.com/coins/images/11939/large/shiba.png?1622619446",
    current_price: 0.00001041,
    market_cap: 6137894674,
    market_cap_rank: 15,
    fully_diluted_valuation: null,
    total_volume: 315976347,
    high_24h: 0.00001095,
    low_24h: 0.00001031,
    price_change_24h: -2.55756826821e-7,
    price_change_percentage_24h: -2.398,
    market_cap_change_24h: -158996150.39073086,
    market_cap_change_percentage_24h: -2.52499,
    circulating_supply: 589359573480776.5,
    total_supply: 999990914207043,
    max_supply: null,
    ath: 0.00008616,
    ath_change_percentage: -87.91692,
    ath_date: "2021-10-28T03:54:55.568Z",
    atl: 5.6366e-11,
    atl_change_percentage: 18469488.94471,
    atl_date: "2020-11-28T11:26:25.838Z",
    roi: null,
    last_updated: "2023-03-27T23:31:47.593Z",
    price_change_percentage_14d_in_currency: -3.868605516294985,
    price_change_percentage_1h_in_currency: -0.05607594562234598,
    price_change_percentage_1y_in_currency: -57.3868481519621,
    price_change_percentage_200d_in_currency: -15.17317542850157,
    price_change_percentage_24h_in_currency: -2.3980012888243154,
    price_change_percentage_30d_in_currency: -17.125752207563334,
    price_change_percentage_7d_in_currency: -5.4140805180767595,
  },
  {
    id: "tron",
    symbol: "trx",
    name: "TRON",
    image:
      "https://assets.coingecko.com/coins/images/1094/large/tron-logo.png?1547035066",
    current_price: 0.063719,
    market_cap: 5804788509,
    market_cap_rank: 16,
    fully_diluted_valuation: 5804792168,
    total_volume: 372628801,
    high_24h: 0.064565,
    low_24h: 0.062159,
    price_change_24h: -0.000789409768945704,
    price_change_percentage_24h: -1.22373,
    market_cap_change_24h: -77694248.70201302,
    market_cap_change_percentage_24h: -1.32077,
    circulating_supply: 91083368622.6561,
    total_supply: 91083426036.761,
    max_supply: null,
    ath: 0.231673,
    ath_change_percentage: -72.50184,
    ath_date: "2018-01-05T00:00:00.000Z",
    atl: 0.00180434,
    atl_change_percentage: 3430.69224,
    atl_date: "2017-11-12T00:00:00.000Z",
    roi: {
      times: 32.53636709656383,
      currency: "usd",
      percentage: 3253.6367096563827,
    },
    last_updated: "2023-03-27T23:31:50.888Z",
    price_change_percentage_14d_in_currency: -1.1067759721874617,
    price_change_percentage_1h_in_currency: 0.08156722453052108,
    price_change_percentage_1y_in_currency: -3.6028785743099054,
    price_change_percentage_200d_in_currency: 2.936777700863582,
    price_change_percentage_24h_in_currency: -1.2237297103416176,
    price_change_percentage_30d_in_currency: -6.241220510960799,
    price_change_percentage_7d_in_currency: -5.111919834950469,
  },
  {
    id: "avalanche-2",
    symbol: "avax",
    name: "Avalanche",
    image:
      "https://assets.coingecko.com/coins/images/12559/large/Avalanche_Circle_RedWhite_Trans.png?1670992574",
    current_price: 16.49,
    market_cap: 5370136175,
    market_cap_rank: 17,
    fully_diluted_valuation: 11867699866,
    total_volume: 180856706,
    high_24h: 17.19,
    low_24h: 16.2,
    price_change_24h: -0.6742471243758459,
    price_change_percentage_24h: -3.92891,
    market_cap_change_24h: -218797929.55434608,
    market_cap_change_percentage_24h: -3.91484,
    circulating_supply: 325800120.475962,
    total_supply: 421862814.131524,
    max_supply: 720000000,
    ath: 144.96,
    ath_change_percentage: -88.63071,
    ath_date: "2021-11-21T14:18:56.538Z",
    atl: 2.8,
    atl_change_percentage: 488.38567,
    atl_date: "2020-12-31T13:15:21.540Z",
    roi: null,
    last_updated: "2023-03-27T23:31:40.594Z",
    price_change_percentage_14d_in_currency: 1.1638264888208814,
    price_change_percentage_1h_in_currency: 0.028940047390783163,
    price_change_percentage_1y_in_currency: -80.84241337027572,
    price_change_percentage_200d_in_currency: -13.324707111199634,
    price_change_percentage_24h_in_currency: -3.928905628325258,
    price_change_percentage_30d_in_currency: -10.261906536821607,
    price_change_percentage_7d_in_currency: -6.825685694996269,
  },
  {
    id: "dai",
    symbol: "dai",
    name: "Dai",
    image:
      "https://assets.coingecko.com/coins/images/9956/large/4943.png?1636636734",
    current_price: 1,
    market_cap: 5151773471,
    market_cap_rank: 18,
    fully_diluted_valuation: 5151773471,
    total_volume: 135630974,
    high_24h: 1.006,
    low_24h: 0.992142,
    price_change_24h: 0.0002599,
    price_change_percentage_24h: 0.02599,
    market_cap_change_24h: -84499776.7612524,
    market_cap_change_percentage_24h: -1.61374,
    circulating_supply: 5149634786.62321,
    total_supply: 5157210428.39042,
    max_supply: 5149634786.62321,
    ath: 1.22,
    ath_change_percentage: -18.03383,
    ath_date: "2020-03-13T03:02:50.373Z",
    atl: 0.88196,
    atl_change_percentage: 13.28301,
    atl_date: "2023-03-11T07:50:50.514Z",
    roi: null,
    last_updated: "2023-03-27T23:30:56.468Z",
    price_change_percentage_14d_in_currency: 0.5883500534059599,
    price_change_percentage_1h_in_currency: 0.02934973298862812,
    price_change_percentage_1y_in_currency: 0.15277492972544962,
    price_change_percentage_200d_in_currency: 0.08134790050196986,
    price_change_percentage_24h_in_currency: 0.02598547203491592,
    price_change_percentage_30d_in_currency: 0.05171580733686597,
    price_change_percentage_7d_in_currency: 0.04498080235165454,
  },
  {
    id: "uniswap",
    symbol: "uni",
    name: "Uniswap",
    image:
      "https://assets.coingecko.com/coins/images/12504/large/uniswap-uni.png?1600306604",
    current_price: 5.62,
    market_cap: 4236805907,
    market_cap_rank: 19,
    fully_diluted_valuation: 5620845405,
    total_volume: 59298369,
    high_24h: 5.82,
    low_24h: 5.54,
    price_change_24h: -0.18715089155116615,
    price_change_percentage_24h: -3.22495,
    market_cap_change_24h: -144245616.48525953,
    market_cap_change_percentage_24h: -3.29249,
    circulating_supply: 753766667,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 44.92,
    ath_change_percentage: -87.49121,
    ath_date: "2021-05-03T05:25:04.822Z",
    atl: 1.03,
    atl_change_percentage: 445.41505,
    atl_date: "2020-09-17T01:20:38.214Z",
    roi: null,
    last_updated: "2023-03-27T23:31:29.845Z",
    price_change_percentage_14d_in_currency: -5.1485372780555725,
    price_change_percentage_1h_in_currency: 0.3470185279924826,
    price_change_percentage_1y_in_currency: -46.96975067856044,
    price_change_percentage_200d_in_currency: -8.358901815486746,
    price_change_percentage_24h_in_currency: -3.2249530251861365,
    price_change_percentage_30d_in_currency: -14.502079123328887,
    price_change_percentage_7d_in_currency: -14.174082070588662,
  },
  {
    id: "wrapped-bitcoin",
    symbol: "wbtc",
    name: "Wrapped Bitcoin",
    image:
      "https://assets.coingecko.com/coins/images/7598/large/wrapped_bitcoin_wbtc.png?1548822744",
    current_price: 27247,
    market_cap: 4100670296,
    market_cap_rank: 20,
    fully_diluted_valuation: 4100670296,
    total_volume: 171518556,
    high_24h: 28167,
    low_24h: 26764,
    price_change_24h: -909.9586374324972,
    price_change_percentage_24h: -3.23172,
    market_cap_change_24h: -130417381.18166971,
    market_cap_change_percentage_24h: -3.08236,
    circulating_supply: 150150.6542473,
    total_supply: 150150.6542473,
    max_supply: 150150.6542473,
    ath: 70643,
    ath_change_percentage: -61.34052,
    ath_date: "2021-11-10T14:40:19.650Z",
    atl: 3139.17,
    atl_change_percentage: 769.98614,
    atl_date: "2019-04-02T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.115Z",
    price_change_percentage_14d_in_currency: 23.294045622765047,
    price_change_percentage_1h_in_currency: 0.17947274351845327,
    price_change_percentage_1y_in_currency: -38.721544939916946,
    price_change_percentage_200d_in_currency: 41.37379763534622,
    price_change_percentage_24h_in_currency: -3.2317174373971365,
    price_change_percentage_30d_in_currency: 17.52050165758438,
    price_change_percentage_7d_in_currency: -3.522318320980808,
  },
  {
    id: "chainlink",
    symbol: "link",
    name: "Chainlink",
    image:
      "https://assets.coingecko.com/coins/images/877/large/chainlink-new-logo.png?1547034700",
    current_price: 6.87,
    market_cap: 3376880475,
    market_cap_rank: 21,
    fully_diluted_valuation: 6869163289,
    total_volume: 253016713,
    high_24h: 7.29,
    low_24h: 6.8,
    price_change_24h: -0.4107687643421478,
    price_change_percentage_24h: -5.64216,
    market_cap_change_24h: -203224551.04619646,
    market_cap_change_percentage_24h: -5.6765,
    circulating_supply: 491599971.2305644,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 52.7,
    ath_change_percentage: -86.9709,
    ath_date: "2021-05-10T00:13:57.214Z",
    atl: 0.148183,
    atl_change_percentage: 4533.37976,
    atl_date: "2017-11-29T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.762Z",
    price_change_percentage_14d_in_currency: 4.215836583510265,
    price_change_percentage_1h_in_currency: 0.268646340017536,
    price_change_percentage_1y_in_currency: -56.527835671262814,
    price_change_percentage_200d_in_currency: -3.0955772977788336,
    price_change_percentage_24h_in_currency: -5.642163968866896,
    price_change_percentage_30d_in_currency: -7.796916639941899,
    price_change_percentage_7d_in_currency: -3.57941493523581,
  },
  {
    id: "cosmos",
    symbol: "atom",
    name: "Cosmos Hub",
    image:
      "https://assets.coingecko.com/coins/images/1481/large/cosmos_hub.png?1555657960",
    current_price: 10.82,
    market_cap: 3166454392,
    market_cap_rank: 22,
    fully_diluted_valuation: null,
    total_volume: 110624149,
    high_24h: 11.37,
    low_24h: 10.66,
    price_change_24h: -0.5165841259447674,
    price_change_percentage_24h: -4.5555,
    market_cap_change_24h: -152549072.04875994,
    market_cap_change_percentage_24h: -4.59623,
    circulating_supply: 292586163.827428,
    total_supply: null,
    max_supply: null,
    ath: 44.45,
    ath_change_percentage: -75.64461,
    ath_date: "2022-01-17T00:34:41.497Z",
    atl: 1.16,
    atl_change_percentage: 833.18446,
    atl_date: "2020-03-13T02:27:44.591Z",
    roi: {
      times: 107.2319829080095,
      currency: "usd",
      percentage: 10723.19829080095,
    },
    last_updated: "2023-03-27T23:31:41.185Z",
    price_change_percentage_14d_in_currency: -7.9240755739737905,
    price_change_percentage_1h_in_currency: 0.21913881842422653,
    price_change_percentage_1y_in_currency: -62.40462705350771,
    price_change_percentage_200d_in_currency: -16.5658789240476,
    price_change_percentage_24h_in_currency: -4.555502980215173,
    price_change_percentage_30d_in_currency: -17.27368612772817,
    price_change_percentage_7d_in_currency: -13.05657122886271,
  },
  {
    id: "leo-token",
    symbol: "leo",
    name: "LEO Token",
    image:
      "https://assets.coingecko.com/coins/images/8418/large/leo-token.png?1558326215",
    current_price: 3.39,
    market_cap: 3153425396,
    market_cap_rank: 23,
    fully_diluted_valuation: null,
    total_volume: 665447,
    high_24h: 3.48,
    low_24h: 3.37,
    price_change_24h: -0.09338559159050552,
    price_change_percentage_24h: -2.68253,
    market_cap_change_24h: -70000928.97000217,
    market_cap_change_percentage_24h: -2.17163,
    circulating_supply: 930986845.9,
    total_supply: 985239504,
    max_supply: null,
    ath: 8.14,
    ath_change_percentage: -58.36457,
    ath_date: "2022-02-08T17:40:10.285Z",
    atl: 0.799859,
    atl_change_percentage: 323.47275,
    atl_date: "2019-12-24T15:14:35.376Z",
    roi: null,
    last_updated: "2023-03-27T23:31:43.331Z",
    price_change_percentage_14d_in_currency: -9.121890073706878,
    price_change_percentage_1h_in_currency: 0.299899732865151,
    price_change_percentage_1y_in_currency: -41.429980667771986,
    price_change_percentage_200d_in_currency: -34.02591803119159,
    price_change_percentage_24h_in_currency: -2.6825345958288613,
    price_change_percentage_30d_in_currency: 0.2555369512154526,
    price_change_percentage_7d_in_currency: 0.10090589093697305,
  },
  {
    id: "the-open-network",
    symbol: "ton",
    name: "Toncoin",
    image:
      "https://assets.coingecko.com/coins/images/17980/large/ton_symbol.png?1670498136",
    current_price: 2.1,
    market_cap: 3085141831,
    market_cap_rank: 24,
    fully_diluted_valuation: 10588200594,
    total_volume: 35555175,
    high_24h: 2.16,
    low_24h: 2.07,
    price_change_24h: -0.029335769691723357,
    price_change_percentage_24h: -1.38027,
    market_cap_change_24h: -53908364.024638176,
    market_cap_change_percentage_24h: -1.71735,
    circulating_supply: 1473591410.74313,
    total_supply: 5057362773.99687,
    max_supply: null,
    ath: 5.29,
    ath_change_percentage: -60.44063,
    ath_date: "2021-11-12T06:50:02.476Z",
    atl: 0.519364,
    atl_change_percentage: 302.99409,
    atl_date: "2021-09-21T00:33:11.092Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.578Z",
    price_change_percentage_14d_in_currency: -11.773833892295544,
    price_change_percentage_1h_in_currency: -0.20300121682305886,
    price_change_percentage_1y_in_currency: 10.613669387170761,
    price_change_percentage_200d_in_currency: 12.761513640197158,
    price_change_percentage_24h_in_currency: -1.3802703878673226,
    price_change_percentage_30d_in_currency: -10.820672154663209,
    price_change_percentage_7d_in_currency: -12.835005010597792,
  },
  {
    id: "monero",
    symbol: "xmr",
    name: "Monero",
    image:
      "https://assets.coingecko.com/coins/images/69/large/monero_logo.png?1547033729",
    current_price: 152.22,
    market_cap: 2760176838,
    market_cap_rank: 25,
    fully_diluted_valuation: null,
    total_volume: 129681847,
    high_24h: 165.08,
    low_24h: 151.93,
    price_change_24h: -10.010800531780177,
    price_change_percentage_24h: -6.17071,
    market_cap_change_24h: -179864718.05464697,
    market_cap_change_percentage_24h: -6.11776,
    circulating_supply: 18147820.3764146,
    total_supply: null,
    max_supply: null,
    ath: 542.33,
    ath_change_percentage: -71.9558,
    ath_date: "2018-01-09T00:00:00.000Z",
    atl: 0.216177,
    atl_change_percentage: 70254.8912,
    atl_date: "2015-01-14T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:39.585Z",
    price_change_percentage_14d_in_currency: 0.9203470904313257,
    price_change_percentage_1h_in_currency: -0.5492201058088984,
    price_change_percentage_1y_in_currency: -26.502113336709986,
    price_change_percentage_200d_in_currency: 1.919643875888313,
    price_change_percentage_24h_in_currency: -6.170707311968755,
    price_change_percentage_30d_in_currency: 1.1722164357924618,
    price_change_percentage_7d_in_currency: -1.5939892829135833,
  },
  {
    id: "ethereum-classic",
    symbol: "etc",
    name: "Ethereum Classic",
    image:
      "https://assets.coingecko.com/coins/images/453/large/ethereum-classic-logo.png?1547034169",
    current_price: 19.67,
    market_cap: 2755814898,
    market_cap_rank: 26,
    fully_diluted_valuation: 4143903992,
    total_volume: 131571965,
    high_24h: 20.43,
    low_24h: 19.15,
    price_change_24h: -0.7516249432188928,
    price_change_percentage_24h: -3.68102,
    market_cap_change_24h: -105711671.93838406,
    market_cap_change_percentage_24h: -3.69424,
    circulating_supply: 140121537.578996,
    total_supply: 210700000,
    max_supply: 210700000,
    ath: 167.09,
    ath_change_percentage: -88.22111,
    ath_date: "2021-05-06T18:34:22.133Z",
    atl: 0.615038,
    atl_change_percentage: 3099.93196,
    atl_date: "2016-07-25T00:00:00.000Z",
    roi: {
      times: 42.70515205557578,
      currency: "usd",
      percentage: 4270.515205557578,
    },
    last_updated: "2023-03-27T23:31:38.520Z",
    price_change_percentage_14d_in_currency: 4.59504549243791,
    price_change_percentage_1h_in_currency: -0.7093663612147684,
    price_change_percentage_1y_in_currency: -58.23385743879582,
    price_change_percentage_200d_in_currency: -47.37781848826103,
    price_change_percentage_24h_in_currency: -3.681017815977815,
    price_change_percentage_30d_in_currency: -6.834402767473749,
    price_change_percentage_7d_in_currency: -7.897093851546094,
  },
  {
    id: "okb",
    symbol: "okb",
    name: "OKB",
    image:
      "https://assets.coingecko.com/coins/images/4463/large/WeChat_Image_20220118095654.png?1642471050",
    current_price: 42.14,
    market_cap: 2530539020,
    market_cap_rank: 27,
    fully_diluted_valuation: 12652695101,
    total_volume: 45567239,
    high_24h: 43.98,
    low_24h: 41.48,
    price_change_24h: 0.01452847,
    price_change_percentage_24h: 0.03449,
    market_cap_change_24h: 5032286,
    market_cap_change_percentage_24h: 0.19926,
    circulating_supply: 60000000,
    total_supply: 246638974,
    max_supply: 300000000,
    ath: 58.66,
    ath_change_percentage: -28.11331,
    ath_date: "2023-02-18T01:21:37.582Z",
    atl: 0.580608,
    atl_change_percentage: 7162.68808,
    atl_date: "2019-01-14T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:32.925Z",
    price_change_percentage_14d_in_currency: -1.4599533513852567,
    price_change_percentage_1h_in_currency: 0.16850102109570972,
    price_change_percentage_1y_in_currency: 91.39883695459028,
    price_change_percentage_200d_in_currency: 198.90586594672703,
    price_change_percentage_24h_in_currency: 0.03448975027191019,
    price_change_percentage_30d_in_currency: -14.367475965358276,
    price_change_percentage_7d_in_currency: -12.851154551602423,
  },
  {
    id: "stellar",
    symbol: "xlm",
    name: "Stellar",
    image:
      "https://assets.coingecko.com/coins/images/100/large/Stellar_symbol_black_RGB.png?1552356157",
    current_price: 0.092833,
    market_cap: 2469955699,
    market_cap_rank: 28,
    fully_diluted_valuation: 4646381686,
    total_volume: 112883500,
    high_24h: 0.095058,
    low_24h: 0.090495,
    price_change_24h: 0.00034971,
    price_change_percentage_24h: 0.37814,
    market_cap_change_24h: 10255030,
    market_cap_change_percentage_24h: 0.41692,
    circulating_supply: 26580295842.2238,
    total_supply: 50001787418.757,
    max_supply: 50001787418.757,
    ath: 0.875563,
    ath_change_percentage: -89.38809,
    ath_date: "2018-01-03T00:00:00.000Z",
    atl: 0.00047612,
    atl_change_percentage: 19414.67882,
    atl_date: "2015-03-05T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:41.732Z",
    price_change_percentage_14d_in_currency: 11.901525633705914,
    price_change_percentage_1h_in_currency: 0.369554155327041,
    price_change_percentage_1y_in_currency: -56.89149718824047,
    price_change_percentage_200d_in_currency: -9.933172406393574,
    price_change_percentage_24h_in_currency: 0.37813725162603423,
    price_change_percentage_30d_in_currency: 3.927878774482669,
    price_change_percentage_7d_in_currency: 5.38490804901043,
  },
  {
    id: "bitcoin-cash",
    symbol: "bch",
    name: "Bitcoin Cash",
    image:
      "https://assets.coingecko.com/coins/images/780/large/bitcoin-cash-circle.png?1594689492",
    current_price: 120.13,
    market_cap: 2324252873,
    market_cap_rank: 29,
    fully_diluted_valuation: 2522626693,
    total_volume: 253056039,
    high_24h: 125.32,
    low_24h: 118.45,
    price_change_24h: -4.762087924371329,
    price_change_percentage_24h: -3.81284,
    market_cap_change_24h: -93123201.41834354,
    market_cap_change_percentage_24h: -3.85224,
    circulating_supply: 19348606.1466508,
    total_supply: 21000000,
    max_supply: 21000000,
    ath: 3785.82,
    ath_change_percentage: -96.82655,
    ath_date: "2017-12-20T00:00:00.000Z",
    atl: 76.93,
    atl_change_percentage: 56.15943,
    atl_date: "2018-12-16T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.808Z",
    price_change_percentage_14d_in_currency: -0.5767048484198805,
    price_change_percentage_1h_in_currency: 0.34957024517655083,
    price_change_percentage_1y_in_currency: -66.7792211839061,
    price_change_percentage_200d_in_currency: 1.2169111103032373,
    price_change_percentage_24h_in_currency: -3.812835927794277,
    price_change_percentage_30d_in_currency: -9.50625175870578,
    price_change_percentage_7d_in_currency: -12.221507535232947,
  },
  {
    id: "filecoin",
    symbol: "fil",
    name: "Filecoin",
    image:
      "https://assets.coingecko.com/coins/images/12817/large/filecoin.png?1602753933",
    current_price: 5.32,
    market_cap: 2181479432,
    market_cap_rank: 30,
    fully_diluted_valuation: 10449159508,
    total_volume: 193551074,
    high_24h: 5.73,
    low_24h: 5.24,
    price_change_24h: -0.40317216636787734,
    price_change_percentage_24h: -7.0464,
    market_cap_change_24h: -164992420.82162666,
    market_cap_change_percentage_24h: -7.03151,
    circulating_supply: 410167779,
    total_supply: 1964679788,
    max_supply: 1964679788,
    ath: 236.84,
    ath_change_percentage: -97.75834,
    ath_date: "2021-04-01T13:29:41.564Z",
    atl: 2.64,
    atl_change_percentage: 101.03095,
    atl_date: "2022-12-16T22:45:28.552Z",
    roi: null,
    last_updated: "2023-03-27T23:31:31.963Z",
    price_change_percentage_14d_in_currency: -7.050697419990409,
    price_change_percentage_1h_in_currency: 0.35883504946537775,
    price_change_percentage_1y_in_currency: -72.57453928473848,
    price_change_percentage_200d_in_currency: -9.202183953698288,
    price_change_percentage_24h_in_currency: -7.046398220428197,
    price_change_percentage_30d_in_currency: -22.298937994903977,
    price_change_percentage_7d_in_currency: -16.019330374635963,
  },
  {
    id: "true-usd",
    symbol: "tusd",
    name: "TrueUSD",
    image:
      "https://assets.coingecko.com/coins/images/3449/large/tusd.png?1618395665",
    current_price: 1.003,
    market_cap: 2047239926,
    market_cap_rank: 31,
    fully_diluted_valuation: null,
    total_volume: 491682083,
    high_24h: 1.006,
    low_24h: 0.985773,
    price_change_24h: 0.00196462,
    price_change_percentage_24h: 0.19623,
    market_cap_change_24h: 2228775,
    market_cap_change_percentage_24h: 0.10899,
    circulating_supply: 2041446767.12,
    total_supply: 2041446767.12,
    max_supply: null,
    ath: 1.62,
    ath_change_percentage: -38.04469,
    ath_date: "2018-08-26T20:41:09.375Z",
    atl: 0.88355,
    atl_change_percentage: 13.49157,
    atl_date: "2020-03-12T10:47:51.380Z",
    roi: null,
    last_updated: "2023-03-27T23:31:35.499Z",
    price_change_percentage_14d_in_currency: -0.25130831551483224,
    price_change_percentage_1h_in_currency: 0.3487408465728512,
    price_change_percentage_1y_in_currency: 0.4047917646309509,
    price_change_percentage_200d_in_currency: 0.3774227990962702,
    price_change_percentage_24h_in_currency: 0.196227156029013,
    price_change_percentage_30d_in_currency: 0.4457124729809954,
    price_change_percentage_7d_in_currency: 0.1894351383791442,
  },
  {
    id: "aptos",
    symbol: "apt",
    name: "Aptos",
    image:
      "https://assets.coingecko.com/coins/images/26455/large/aptos_round.png?1666839629",
    current_price: 11.08,
    market_cap: 1986003172,
    market_cap_rank: 32,
    fully_diluted_valuation: 11373390529,
    total_volume: 117803974,
    high_24h: 12.02,
    low_24h: 10.88,
    price_change_24h: -0.8340304305826542,
    price_change_percentage_24h: -6.9985,
    market_cap_change_24h: -148978631.72392273,
    market_cap_change_percentage_24h: -6.97798,
    circulating_supply: 179248925.545375,
    total_supply: 1026518014.3995,
    max_supply: null,
    ath: 19.92,
    ath_change_percentage: -44.44717,
    ath_date: "2023-01-26T14:25:17.390Z",
    atl: 3.08,
    atl_change_percentage: 259.32074,
    atl_date: "2022-12-29T21:35:14.796Z",
    roi: null,
    last_updated: "2023-03-27T23:31:42.120Z",
    price_change_percentage_14d_in_currency: -7.2312482471027755,
    price_change_percentage_1h_in_currency: 0.22836301940278372,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: -6.99849894517247,
    price_change_percentage_30d_in_currency: -13.570413663108354,
    price_change_percentage_7d_in_currency: -15.838468915031005,
  },
  {
    id: "lido-dao",
    symbol: "ldo",
    name: "Lido DAO",
    image:
      "https://assets.coingecko.com/coins/images/13573/large/Lido_DAO.png?1609873644",
    current_price: 2.1,
    market_cap: 1801378334,
    market_cap_rank: 33,
    fully_diluted_valuation: 2092197807,
    total_volume: 112481207,
    high_24h: 2.22,
    low_24h: 2.06,
    price_change_24h: -0.07010793992792008,
    price_change_percentage_24h: -3.23451,
    market_cap_change_24h: -64737272.87618399,
    market_cap_change_percentage_24h: -3.46909,
    circulating_supply: 860998098.635123,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 7.3,
    ath_change_percentage: -71.34996,
    ath_date: "2021-08-20T08:35:20.158Z",
    atl: 0.40615,
    atl_change_percentage: 415.14884,
    atl_date: "2022-06-18T20:55:12.035Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.066Z",
    price_change_percentage_14d_in_currency: -14.175349579669195,
    price_change_percentage_1h_in_currency: 0.4181629027289615,
    price_change_percentage_1y_in_currency: -35.03464555341021,
    price_change_percentage_200d_in_currency: 7.217563313929218,
    price_change_percentage_24h_in_currency: -3.2345138906136834,
    price_change_percentage_30d_in_currency: -27.127220591581892,
    price_change_percentage_7d_in_currency: -15.750107773965691,
  },
  {
    id: "hedera-hashgraph",
    symbol: "hbar",
    name: "Hedera",
    image:
      "https://assets.coingecko.com/coins/images/3688/large/hbar.png?1637045634",
    current_price: 0.059302,
    market_cap: 1788703777,
    market_cap_rank: 34,
    fully_diluted_valuation: 2965122095,
    total_volume: 37280831,
    high_24h: 0.062492,
    low_24h: 0.057504,
    price_change_24h: -0.003055083933248729,
    price_change_percentage_24h: -4.8993,
    market_cap_change_24h: -92016045.61473012,
    market_cap_change_percentage_24h: -4.8926,
    circulating_supply: 30162396685.1788,
    total_supply: 50000000000,
    max_supply: 50000000000,
    ath: 0.569229,
    ath_change_percentage: -89.58583,
    ath_date: "2021-09-15T10:40:28.318Z",
    atl: 0.00986111,
    atl_change_percentage: 501.15387,
    atl_date: "2020-01-02T17:30:24.852Z",
    roi: null,
    last_updated: "2023-03-27T23:31:50.929Z",
    price_change_percentage_14d_in_currency: -4.567738814050979,
    price_change_percentage_1h_in_currency: 0.3414766714180772,
    price_change_percentage_1y_in_currency: -73.84950902985521,
    price_change_percentage_200d_in_currency: -2.726196213856506,
    price_change_percentage_24h_in_currency: -4.899302678284675,
    price_change_percentage_30d_in_currency: -23.22696029767987,
    price_change_percentage_7d_in_currency: -9.373675598866608,
  },
  {
    id: "quant-network",
    symbol: "qnt",
    name: "Quant",
    image:
      "https://assets.coingecko.com/coins/images/3370/large/5ZOu7brX_400x400.jpg?1612437252",
    current_price: 118.83,
    market_cap: 1727138590,
    market_cap_rank: 35,
    fully_diluted_valuation: 1735251297,
    total_volume: 23894321,
    high_24h: 124.15,
    low_24h: 116.26,
    price_change_24h: -4.139404975647523,
    price_change_percentage_24h: -3.36612,
    market_cap_change_24h: -61932844.67819929,
    market_cap_change_percentage_24h: -3.46173,
    circulating_supply: 14544176.164091088,
    total_supply: 14612493,
    max_supply: 14612493,
    ath: 427.42,
    ath_change_percentage: -72.20932,
    ath_date: "2021-09-11T09:15:00.668Z",
    atl: 0.215773,
    atl_change_percentage: 54950.16717,
    atl_date: "2018-08-23T00:00:00.000Z",
    roi: {
      times: 28.76812611652991,
      currency: "eth",
      percentage: 2876.8126116529907,
    },
    last_updated: "2023-03-27T23:31:53.745Z",
    price_change_percentage_14d_in_currency: -5.8260314870642995,
    price_change_percentage_1h_in_currency: 0.41220202495260333,
    price_change_percentage_1y_in_currency: -15.868465320991929,
    price_change_percentage_200d_in_currency: 24.77116095659289,
    price_change_percentage_24h_in_currency: -3.3661199341091375,
    price_change_percentage_30d_in_currency: -9.3076883019274,
    price_change_percentage_7d_in_currency: -9.844520366860205,
  },
  {
    id: "crypto-com-chain",
    symbol: "cro",
    name: "Cronos",
    image:
      "https://assets.coingecko.com/coins/images/7310/large/cro_token_logo.png?1669699773",
    current_price: 0.066496,
    market_cap: 1679905571,
    market_cap_rank: 36,
    fully_diluted_valuation: null,
    total_volume: 11872680,
    high_24h: 0.069436,
    low_24h: 0.066181,
    price_change_24h: -0.002919703346712544,
    price_change_percentage_24h: -4.20614,
    market_cap_change_24h: -71480334.38110352,
    market_cap_change_percentage_24h: -4.08136,
    circulating_supply: 25263013692,
    total_supply: 30263013692,
    max_supply: null,
    ath: 0.965407,
    ath_change_percentage: -93.11463,
    ath_date: "2021-11-24T15:53:54.855Z",
    atl: 0.0121196,
    atl_change_percentage: 448.46614,
    atl_date: "2019-02-08T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:50.644Z",
    price_change_percentage_14d_in_currency: -2.7026639623874753,
    price_change_percentage_1h_in_currency: 0.006644370489164948,
    price_change_percentage_1y_in_currency: -85.46738736895824,
    price_change_percentage_200d_in_currency: -41.50785649103773,
    price_change_percentage_24h_in_currency: -4.206136411060603,
    price_change_percentage_30d_in_currency: -17.461485173087503,
    price_change_percentage_7d_in_currency: -7.840265169779208,
  },
  {
    id: "vechain",
    symbol: "vet",
    name: "VeChain",
    image:
      "https://assets.coingecko.com/coins/images/1167/large/VeChain-Logo-768x725.png?1547035194",
    current_price: 0.02205263,
    market_cap: 1600363024,
    market_cap_rank: 37,
    fully_diluted_valuation: 1913798095,
    total_volume: 63153804,
    high_24h: 0.02300518,
    low_24h: 0.02162876,
    price_change_24h: -0.000949444035987752,
    price_change_percentage_24h: -4.12765,
    market_cap_change_24h: -69344894.30353594,
    market_cap_change_percentage_24h: -4.15312,
    circulating_supply: 72511146418,
    total_supply: 85985041177,
    max_supply: 86712634466,
    ath: 0.280991,
    ath_change_percentage: -92.1438,
    ath_date: "2021-04-19T01:08:21.675Z",
    atl: 0.00191713,
    atl_change_percentage: 1051.46993,
    atl_date: "2020-03-13T02:29:59.652Z",
    roi: {
      times: 3.4964905755084446,
      currency: "eth",
      percentage: 349.6490575508445,
    },
    last_updated: "2023-03-27T23:31:43.529Z",
    price_change_percentage_14d_in_currency: 0.02000014834589233,
    price_change_percentage_1h_in_currency: 0.28770638865927806,
    price_change_percentage_1y_in_currency: -65.68227493635163,
    price_change_percentage_200d_in_currency: -7.525364637464108,
    price_change_percentage_24h_in_currency: -4.1276456976395615,
    price_change_percentage_30d_in_currency: -20.480633493335194,
    price_change_percentage_7d_in_currency: -10.727314643455516,
  },
  {
    id: "near",
    symbol: "near",
    name: "NEAR Protocol",
    image:
      "https://assets.coingecko.com/coins/images/10365/large/near.png?1677061777",
    current_price: 1.84,
    market_cap: 1592370115,
    market_cap_rank: 38,
    fully_diluted_valuation: 1838719916,
    total_volume: 90448263,
    high_24h: 1.97,
    low_24h: 1.82,
    price_change_24h: -0.1256993817364731,
    price_change_percentage_24h: -6.39468,
    market_cap_change_24h: -111847050.14714575,
    market_cap_change_percentage_24h: -6.56296,
    circulating_supply: 866021029.720309,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 20.44,
    ath_change_percentage: -91.01202,
    ath_date: "2022-01-16T22:09:45.873Z",
    atl: 0.526762,
    atl_change_percentage: 248.72901,
    atl_date: "2020-11-04T16:09:15.137Z",
    roi: null,
    last_updated: "2023-03-27T23:31:54.556Z",
    price_change_percentage_14d_in_currency: -5.700018060579803,
    price_change_percentage_1h_in_currency: -0.18785770873380253,
    price_change_percentage_1y_in_currency: -85.52818856137827,
    price_change_percentage_200d_in_currency: -57.966981972263454,
    price_change_percentage_24h_in_currency: -6.3946817444465776,
    price_change_percentage_30d_in_currency: -20.459718930889718,
    price_change_percentage_7d_in_currency: -14.825837055322639,
  },
  {
    id: "arbitrum",
    symbol: "arb",
    name: "Arbitrum",
    image:
      "https://assets.coingecko.com/coins/images/16547/large/AF_logomark.png?1679671868",
    current_price: 1.16,
    market_cap: 1481299664,
    market_cap_rank: 39,
    fully_diluted_valuation: 11618036582,
    total_volume: 820884000,
    high_24h: 1.32,
    low_24h: 1.13,
    price_change_24h: -0.1245854874303287,
    price_change_percentage_24h: -9.67792,
    market_cap_change_24h: -160102266.73165703,
    market_cap_change_percentage_24h: -9.754,
    circulating_supply: 1275000000,
    total_supply: 10000000000,
    max_supply: 10000000000,
    ath: 8.67,
    ath_change_percentage: -86.62866,
    ath_date: "2023-03-23T13:10:03.106Z",
    atl: 1.11,
    atl_change_percentage: 4.88357,
    atl_date: "2023-03-23T14:35:24.485Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.796Z",
    price_change_percentage_14d_in_currency: null,
    price_change_percentage_1h_in_currency: 1.2606004614516195,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: -9.677924833460136,
    price_change_percentage_30d_in_currency: null,
    price_change_percentage_7d_in_currency: null,
  },
  {
    id: "apecoin",
    symbol: "ape",
    name: "ApeCoin",
    image:
      "https://assets.coingecko.com/coins/images/24383/large/apecoin.jpg?1647476455",
    current_price: 3.91,
    market_cap: 1440155760,
    market_cap_rank: 40,
    fully_diluted_valuation: 3907162724,
    total_volume: 131492439,
    high_24h: 4.13,
    low_24h: 3.84,
    price_change_24h: -0.22145936257535048,
    price_change_percentage_24h: -5.36269,
    market_cap_change_24h: -81817300.85358143,
    market_cap_change_percentage_24h: -5.37574,
    circulating_supply: 368593750,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 26.7,
    ath_change_percentage: -85.40346,
    ath_date: "2022-04-28T21:44:21.164Z",
    atl: 2.63,
    atl_change_percentage: 48.39098,
    atl_date: "2022-11-14T04:22:00.792Z",
    roi: null,
    last_updated: "2023-03-27T23:31:36.913Z",
    price_change_percentage_14d_in_currency: -13.091353827153037,
    price_change_percentage_1h_in_currency: -0.1174312798403355,
    price_change_percentage_1y_in_currency: -71.77605499495428,
    price_change_percentage_200d_in_currency: -11.745325759387883,
    price_change_percentage_24h_in_currency: -5.362686063342865,
    price_change_percentage_30d_in_currency: -24.299794135238997,
    price_change_percentage_7d_in_currency: -9.552553208393439,
  },
  {
    id: "algorand",
    symbol: "algo",
    name: "Algorand",
    image:
      "https://assets.coingecko.com/coins/images/4380/large/download.png?1547039725",
    current_price: 0.201093,
    market_cap: 1432121545,
    market_cap_rank: 41,
    fully_diluted_valuation: 2011018960,
    total_volume: 63393872,
    high_24h: 0.212318,
    low_24h: 0.197764,
    price_change_24h: -0.011057803134958384,
    price_change_percentage_24h: -5.21225,
    market_cap_change_24h: -80179797.525213,
    market_cap_change_percentage_24h: -5.30184,
    circulating_supply: 7121372664.72713,
    total_supply: 7328935031.92591,
    max_supply: 10000000000,
    ath: 3.56,
    ath_change_percentage: -94.34837,
    ath_date: "2019-06-20T14:51:19.480Z",
    atl: 0.105336,
    atl_change_percentage: 91.06866,
    atl_date: "2020-03-13T02:20:48.438Z",
    roi: {
      times: -0.9162113881167463,
      currency: "usd",
      percentage: -91.62113881167463,
    },
    last_updated: "2023-03-27T23:31:54.737Z",
    price_change_percentage_14d_in_currency: -0.7452182617690452,
    price_change_percentage_1h_in_currency: -0.11873217424335124,
    price_change_percentage_1y_in_currency: -78.00024971724514,
    price_change_percentage_200d_in_currency: -33.02895419646692,
    price_change_percentage_24h_in_currency: -5.212245369387046,
    price_change_percentage_30d_in_currency: -21.848372737758183,
    price_change_percentage_7d_in_currency: -9.462594592992406,
  },
  {
    id: "internet-computer",
    symbol: "icp",
    name: "Internet Computer",
    image:
      "https://assets.coingecko.com/coins/images/14495/large/Internet_Computer_logo.png?1620703073",
    current_price: 4.75,
    market_cap: 1415048370,
    market_cap_rank: 42,
    fully_diluted_valuation: 2227750884,
    total_volume: 34711265,
    high_24h: 5.03,
    low_24h: 4.69,
    price_change_24h: -0.26561352347851663,
    price_change_percentage_24h: -5.29802,
    market_cap_change_24h: -77943786.86019015,
    market_cap_change_percentage_24h: -5.22064,
    circulating_supply: 298040548.499956,
    total_supply: 497173164.127629,
    max_supply: 469213710,
    ath: 700.65,
    ath_change_percentage: -99.32341,
    ath_date: "2021-05-10T16:05:53.653Z",
    atl: 3.4,
    atl_change_percentage: 39.46697,
    atl_date: "2022-12-19T22:45:01.729Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.605Z",
    price_change_percentage_14d_in_currency: -9.258101877701998,
    price_change_percentage_1h_in_currency: 0.1462437932428398,
    price_change_percentage_1y_in_currency: -75.41728764274832,
    price_change_percentage_200d_in_currency: -26.636632107392757,
    price_change_percentage_24h_in_currency: -5.298016734510544,
    price_change_percentage_30d_in_currency: -24.491932821849396,
    price_change_percentage_7d_in_currency: -13.092044951342954,
  },
  {
    id: "blockstack",
    symbol: "stx",
    name: "Stacks",
    image:
      "https://assets.coingecko.com/coins/images/2069/large/Stacks_logo_full.png?1604112510",
    current_price: 0.904836,
    market_cap: 1237157409,
    market_cap_rank: 43,
    fully_diluted_valuation: 1644050577,
    total_volume: 74975168,
    high_24h: 1.027,
    low_24h: 0.892054,
    price_change_24h: -0.10764034310053239,
    price_change_percentage_24h: -10.63139,
    market_cap_change_24h: -146727714.7251377,
    market_cap_change_percentage_24h: -10.60259,
    circulating_supply: 1368055339.43384,
    total_supply: 1818000000,
    max_supply: 1818000000,
    ath: 3.39,
    ath_change_percentage: -72.68995,
    ath_date: "2021-12-01T01:32:34.725Z",
    atl: 0.04559639,
    atl_change_percentage: 1930.22923,
    atl_date: "2020-03-13T02:29:26.415Z",
    roi: {
      times: 6.540302633071486,
      currency: "usd",
      percentage: 654.0302633071486,
    },
    last_updated: "2023-03-27T23:31:49.948Z",
    price_change_percentage_14d_in_currency: 21.470146437254815,
    price_change_percentage_1h_in_currency: 0.2602345519700663,
    price_change_percentage_1y_in_currency: -33.70758322073647,
    price_change_percentage_200d_in_currency: 157.29764505302197,
    price_change_percentage_24h_in_currency: -10.631390080587028,
    price_change_percentage_30d_in_currency: 23.30555975054449,
    price_change_percentage_7d_in_currency: -21.84266587009295,
  },
  {
    id: "eos",
    symbol: "eos",
    name: "EOS",
    image:
      "https://assets.coingecko.com/coins/images/738/large/eos-eos-logo.png?1547034481",
    current_price: 1.086,
    market_cap: 1193559301,
    market_cap_rank: 44,
    fully_diluted_valuation: null,
    total_volume: 153855334,
    high_24h: 1.15,
    low_24h: 1.074,
    price_change_24h: -0.059472335022835665,
    price_change_percentage_24h: -5.19391,
    market_cap_change_24h: -64804963.876190424,
    market_cap_change_percentage_24h: -5.14994,
    circulating_supply: 1099606269.8888,
    total_supply: null,
    max_supply: null,
    ath: 22.71,
    ath_change_percentage: -95.22271,
    ath_date: "2018-04-29T07:50:33.540Z",
    atl: 0.5024,
    atl_change_percentage: 115.96008,
    atl_date: "2017-10-23T00:00:00.000Z",
    roi: {
      times: 0.09653350334148889,
      currency: "usd",
      percentage: 9.65335033414889,
    },
    last_updated: "2023-03-27T23:31:58.849Z",
    price_change_percentage_14d_in_currency: 3.153570293007796,
    price_change_percentage_1h_in_currency: -0.15145635051313194,
    price_change_percentage_1y_in_currency: -56.704672901093275,
    price_change_percentage_200d_in_currency: -34.77585494006654,
    price_change_percentage_24h_in_currency: -5.193906665295363,
    price_change_percentage_30d_in_currency: -2.9894541426392274,
    price_change_percentage_7d_in_currency: -6.99275884279324,
  },
  {
    id: "the-graph",
    symbol: "grt",
    name: "The Graph",
    image:
      "https://assets.coingecko.com/coins/images/13397/large/Graph_Token.png?1608145566",
    current_price: 0.134072,
    market_cap: 1187845157,
    market_cap_rank: 45,
    fully_diluted_valuation: 1336897459,
    total_volume: 71489061,
    high_24h: 0.142622,
    low_24h: 0.130781,
    price_change_24h: -0.008299817199349718,
    price_change_percentage_24h: -5.82969,
    market_cap_change_24h: -78519607.40262365,
    market_cap_change_percentage_24h: -6.20039,
    circulating_supply: 8885087997.66558,
    total_supply: 10000000000,
    max_supply: null,
    ath: 2.84,
    ath_change_percentage: -95.29532,
    ath_date: "2021-02-12T07:28:45.775Z",
    atl: 0.052051,
    atl_change_percentage: 156.83207,
    atl_date: "2022-11-22T10:05:03.503Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.278Z",
    price_change_percentage_14d_in_currency: 1.9025980162319749,
    price_change_percentage_1h_in_currency: 0.32182194711743983,
    price_change_percentage_1y_in_currency: -67.34588587296871,
    price_change_percentage_200d_in_currency: 28.475409108986337,
    price_change_percentage_24h_in_currency: -5.829693336043651,
    price_change_percentage_30d_in_currency: -13.588942287105073,
    price_change_percentage_7d_in_currency: -14.624814892705619,
  },
  {
    id: "fantom",
    symbol: "ftm",
    name: "Fantom",
    image:
      "https://assets.coingecko.com/coins/images/4001/large/Fantom_round.png?1669652346",
    current_price: 0.410322,
    market_cap: 1142176981,
    market_cap_rank: 46,
    fully_diluted_valuation: 1302767912,
    total_volume: 308959324,
    high_24h: 0.450044,
    low_24h: 0.408112,
    price_change_24h: -0.03925749308768822,
    price_change_percentage_24h: -8.73205,
    market_cap_change_24h: -109713373.92553806,
    market_cap_change_percentage_24h: -8.76382,
    circulating_supply: 2783620845.07619,
    total_supply: 3175000000,
    max_supply: 3175000000,
    ath: 3.46,
    ath_change_percentage: -88.14609,
    ath_date: "2021-10-28T05:19:39.845Z",
    atl: 0.00190227,
    atl_change_percentage: 21451.94031,
    atl_date: "2020-03-13T02:25:38.280Z",
    roi: {
      times: 12.677386878532173,
      currency: "usd",
      percentage: 1267.7386878532172,
    },
    last_updated: "2023-03-27T23:31:53.676Z",
    price_change_percentage_14d_in_currency: 3.9539948959512223,
    price_change_percentage_1h_in_currency: -0.9353707496141341,
    price_change_percentage_1y_in_currency: -70.67179044833519,
    price_change_percentage_200d_in_currency: 61.74659099589355,
    price_change_percentage_24h_in_currency: -8.732054745487213,
    price_change_percentage_30d_in_currency: -11.221182408616867,
    price_change_percentage_7d_in_currency: -16.807618205680193,
  },
  {
    id: "the-sandbox",
    symbol: "sand",
    name: "The Sandbox",
    image:
      "https://assets.coingecko.com/coins/images/12129/large/sandbox_logo.jpg?1597397942",
    current_price: 0.59742,
    market_cap: 1086467698,
    market_cap_rank: 47,
    fully_diluted_valuation: 1790603448,
    total_volume: 169864971,
    high_24h: 0.638425,
    low_24h: 0.581824,
    price_change_24h: -0.039559061847188826,
    price_change_percentage_24h: -6.21042,
    market_cap_change_24h: -73188865.17603683,
    market_cap_change_percentage_24h: -6.31125,
    circulating_supply: 1820281926.2233226,
    total_supply: 3000000000,
    max_supply: 3000000000,
    ath: 8.4,
    ath_change_percentage: -92.89293,
    ath_date: "2021-11-25T06:04:40.957Z",
    atl: 0.02897764,
    atl_change_percentage: 1959.40159,
    atl_date: "2020-11-04T15:59:14.441Z",
    roi: null,
    last_updated: "2023-03-27T23:31:49.691Z",
    price_change_percentage_14d_in_currency: 1.874953369076095,
    price_change_percentage_1h_in_currency: 0.13152300193987512,
    price_change_percentage_1y_in_currency: -82.36508665660345,
    price_change_percentage_200d_in_currency: -34.01189243829558,
    price_change_percentage_24h_in_currency: -6.210415453644343,
    price_change_percentage_30d_in_currency: -17.450775448205714,
    price_change_percentage_7d_in_currency: -13.638328025290889,
  },
  {
    id: "frax",
    symbol: "frax",
    name: "Frax",
    image:
      "https://assets.coingecko.com/coins/images/13422/large/FRAX_icon.png?1679886922",
    current_price: 0.999886,
    market_cap: 1044743388,
    market_cap_rank: 48,
    fully_diluted_valuation: 1044743388,
    total_volume: 10744503,
    high_24h: 1.004,
    low_24h: 0.989164,
    price_change_24h: 0.00106763,
    price_change_percentage_24h: 0.10689,
    market_cap_change_24h: 947774,
    market_cap_change_percentage_24h: 0.0908,
    circulating_supply: 1044853133.25878,
    total_supply: 1044853133.25878,
    max_supply: 1044853133.25878,
    ath: 1.14,
    ath_change_percentage: -12.42802,
    ath_date: "2021-02-07T12:55:35.766Z",
    atl: 0.874536,
    atl_change_percentage: 14.19946,
    atl_date: "2023-03-11T07:50:39.316Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.776Z",
    price_change_percentage_14d_in_currency: 0.5189484805716077,
    price_change_percentage_1h_in_currency: 0.11821236088306868,
    price_change_percentage_1y_in_currency: 0.1106264080760137,
    price_change_percentage_200d_in_currency: 0.16731477289107535,
    price_change_percentage_24h_in_currency: 0.10688982871412038,
    price_change_percentage_30d_in_currency: -0.01563203136427098,
    price_change_percentage_7d_in_currency: -0.14899907806548138,
  },
  {
    id: "elrond-erd-2",
    symbol: "egld",
    name: "MultiversX",
    image:
      "https://assets.coingecko.com/coins/images/12335/large/egld-token-logo.png?1673490885",
    current_price: 41.04,
    market_cap: 1033634422,
    market_cap_rank: 49,
    fully_diluted_valuation: 1289006310,
    total_volume: 22639297,
    high_24h: 42.91,
    low_24h: 40.65,
    price_change_24h: -1.8220605279872473,
    price_change_percentage_24h: -4.25144,
    market_cap_change_24h: -46321273.93625152,
    market_cap_change_percentage_24h: -4.28918,
    circulating_supply: 25191950,
    total_supply: 25197102,
    max_supply: 31415926,
    ath: 545.64,
    ath_change_percentage: -92.47893,
    ath_date: "2021-11-23T10:33:26.737Z",
    atl: 6.51,
    atl_change_percentage: 530.70656,
    atl_date: "2020-10-07T01:44:53.554Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.747Z",
    price_change_percentage_14d_in_currency: -0.05594286087526237,
    price_change_percentage_1h_in_currency: -0.3263286925888072,
    price_change_percentage_1y_in_currency: -78.28945571066994,
    price_change_percentage_200d_in_currency: -19.71210249654031,
    price_change_percentage_24h_in_currency: -4.251440973588563,
    price_change_percentage_30d_in_currency: -16.10336882551408,
    price_change_percentage_7d_in_currency: -7.173703498908949,
  },
  {
    id: "decentraland",
    symbol: "mana",
    name: "Decentraland",
    image:
      "https://assets.coingecko.com/coins/images/878/large/decentraland-mana.png?1550108745",
    current_price: 0.563857,
    market_cap: 1028624774,
    market_cap_rank: 50,
    fully_diluted_valuation: 1236561025,
    total_volume: 82189896,
    high_24h: 0.595383,
    low_24h: 0.550063,
    price_change_24h: -0.029556722153425863,
    price_change_percentage_24h: -4.98079,
    market_cap_change_24h: -53625308.833851576,
    market_cap_change_percentage_24h: -4.95498,
    circulating_supply: 1824388192.6415346,
    total_supply: 2193187827.32015,
    max_supply: 2193187827.32015,
    ath: 5.85,
    ath_change_percentage: -90.3619,
    ath_date: "2021-11-25T10:04:18.534Z",
    atl: 0.00923681,
    atl_change_percentage: 6005.0084,
    atl_date: "2017-10-31T00:00:00.000Z",
    roi: {
      times: 27.19286575580253,
      currency: "usd",
      percentage: 2719.286575580253,
    },
    last_updated: "2023-03-27T23:31:52.926Z",
    price_change_percentage_14d_in_currency: -1.2139674016552635,
    price_change_percentage_1h_in_currency: -0.06466081502741393,
    price_change_percentage_1y_in_currency: -78.43244026722932,
    price_change_percentage_200d_in_currency: -26.312993432531982,
    price_change_percentage_24h_in_currency: -4.980792549065333,
    price_change_percentage_30d_in_currency: -15.827848838790787,
    price_change_percentage_7d_in_currency: -11.559388887336382,
  },
  {
    id: "aave",
    symbol: "aave",
    name: "Aave",
    image:
      "https://assets.coingecko.com/coins/images/12645/large/AAVE.png?1601374110",
    current_price: 69.69,
    market_cap: 998731922,
    market_cap_rank: 51,
    fully_diluted_valuation: 1114828068,
    total_volume: 64632709,
    high_24h: 73.63,
    low_24h: 68.88,
    price_change_24h: -3.326176328331016,
    price_change_percentage_24h: -4.5553,
    market_cap_change_24h: -48275745.09134185,
    market_cap_change_percentage_24h: -4.61083,
    circulating_supply: 14333789.399862107,
    total_supply: 16000000,
    max_supply: 16000000,
    ath: 661.69,
    ath_change_percentage: -89.47402,
    ath_date: "2021-05-18T21:19:59.514Z",
    atl: 26.02,
    atl_change_percentage: 167.64385,
    atl_date: "2020-11-05T09:20:11.928Z",
    roi: null,
    last_updated: "2023-03-27T23:31:33.994Z",
    price_change_percentage_14d_in_currency: -4.602657130124954,
    price_change_percentage_1h_in_currency: 0.16250537842641222,
    price_change_percentage_1y_in_currency: -57.282141136786294,
    price_change_percentage_200d_in_currency: -20.428255619120254,
    price_change_percentage_24h_in_currency: -4.555297864801849,
    price_change_percentage_30d_in_currency: -14.463951515521142,
    price_change_percentage_7d_in_currency: -13.184996257780165,
  },
  {
    id: "tezos",
    symbol: "xtz",
    name: "Tezos",
    image:
      "https://assets.coingecko.com/coins/images/976/large/Tezos-logo.png?1547034862",
    current_price: 1.079,
    market_cap: 997541050,
    market_cap_rank: 52,
    fully_diluted_valuation: null,
    total_volume: 33711563,
    high_24h: 1.16,
    low_24h: 1.068,
    price_change_24h: -0.06920670078979563,
    price_change_percentage_24h: -6.02736,
    market_cap_change_24h: -64735911.979542375,
    market_cap_change_percentage_24h: -6.09407,
    circulating_supply: 924145001.359305,
    total_supply: null,
    max_supply: null,
    ath: 9.12,
    ath_change_percentage: -88.15484,
    ath_date: "2021-10-04T00:41:18.025Z",
    atl: 0.350476,
    atl_change_percentage: 208.09886,
    atl_date: "2018-12-07T00:00:00.000Z",
    roi: {
      times: 1.2957489819828574,
      currency: "usd",
      percentage: 129.57489819828575,
    },
    last_updated: "2023-03-27T23:31:31.162Z",
    price_change_percentage_14d_in_currency: 1.948081902895633,
    price_change_percentage_1h_in_currency: -0.19359121423767117,
    price_change_percentage_1y_in_currency: -70.43608474382059,
    price_change_percentage_200d_in_currency: -27.750099239310366,
    price_change_percentage_24h_in_currency: -6.027362398872568,
    price_change_percentage_30d_in_currency: -12.959076804700928,
    price_change_percentage_7d_in_currency: -13.964138566018299,
  },
  {
    id: "theta-token",
    symbol: "theta",
    name: "Theta Network",
    image:
      "https://assets.coingecko.com/coins/images/2538/large/theta-token-logo.png?1548387191",
    current_price: 0.969756,
    market_cap: 969071460,
    market_cap_rank: 53,
    fully_diluted_valuation: 969071460,
    total_volume: 20591592,
    high_24h: 1.025,
    low_24h: 0.948483,
    price_change_24h: -0.05189976095240456,
    price_change_percentage_24h: -5.07996,
    market_cap_change_24h: -54296162.59953201,
    market_cap_change_percentage_24h: -5.30564,
    circulating_supply: 1000000000,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 15.72,
    ath_change_percentage: -93.83743,
    ath_date: "2021-04-16T13:15:11.190Z",
    atl: 0.04039979,
    atl_change_percentage: 2297.8801,
    atl_date: "2020-03-13T02:24:16.483Z",
    roi: {
      times: 5.465041773845299,
      currency: "usd",
      percentage: 546.50417738453,
    },
    last_updated: "2023-03-27T23:31:43.698Z",
    price_change_percentage_14d_in_currency: -1.1366516973189302,
    price_change_percentage_1h_in_currency: 0.015784402752669287,
    price_change_percentage_1y_in_currency: -70.54324983890461,
    price_change_percentage_200d_in_currency: -12.786826118018213,
    price_change_percentage_24h_in_currency: -5.079964252089832,
    price_change_percentage_30d_in_currency: -17.473389335954145,
    price_change_percentage_7d_in_currency: -9.595527361616613,
  },
  {
    id: "flow",
    symbol: "flow",
    name: "Flow",
    image:
      "https://assets.coingecko.com/coins/images/13446/large/5f6294c0c7a8cda55cb1c936_Flow_Wordmark.png?1631696776",
    current_price: 0.917144,
    market_cap: 957610764,
    market_cap_rank: 54,
    fully_diluted_valuation: 1315180316,
    total_volume: 18486807,
    high_24h: 0.987038,
    low_24h: 0.906464,
    price_change_24h: -0.06122192576014207,
    price_change_percentage_24h: -6.25757,
    market_cap_change_24h: -56364945.64159167,
    market_cap_change_percentage_24h: -5.55881,
    circulating_supply: 1036200000,
    total_supply: 1423114582.65768,
    max_supply: 1423114582.65768,
    ath: 42.4,
    ath_change_percentage: -97.81799,
    ath_date: "2021-04-05T13:49:10.098Z",
    atl: 0.646701,
    atl_change_percentage: 43.05085,
    atl_date: "2023-01-02T02:01:06.327Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.296Z",
    price_change_percentage_14d_in_currency: -1.7841212460812976,
    price_change_percentage_1h_in_currency: -1.0469817604627996,
    price_change_percentage_1y_in_currency: -86.04715545947194,
    price_change_percentage_200d_in_currency: -50.870906847771,
    price_change_percentage_24h_in_currency: -6.2575666120728055,
    price_change_percentage_30d_in_currency: -22.207917967827374,
    price_change_percentage_7d_in_currency: -16.183616557251153,
  },
  {
    id: "immutable-x",
    symbol: "imx",
    name: "ImmutableX",
    image:
      "https://assets.coingecko.com/coins/images/17233/large/immutableX-symbol-BLK-RGB.png?1665110648",
    current_price: 1.018,
    market_cap: 930511303,
    market_cap_rank: 55,
    fully_diluted_valuation: 2035765498,
    total_volume: 42041470,
    high_24h: 1.11,
    low_24h: 0.996808,
    price_change_24h: -0.09363960762997814,
    price_change_percentage_24h: -8.42445,
    market_cap_change_24h: -86112450.66245615,
    market_cap_change_percentage_24h: -8.47043,
    circulating_supply: 914163545.5400242,
    total_supply: 2000000000,
    max_supply: 2000000000,
    ath: 9.52,
    ath_change_percentage: -89.3309,
    ath_date: "2021-11-26T01:03:01.536Z",
    atl: 0.378055,
    atl_change_percentage: 168.66258,
    atl_date: "2022-12-31T07:36:37.649Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.260Z",
    price_change_percentage_14d_in_currency: 8.799388725763702,
    price_change_percentage_1h_in_currency: 0.3694967693153694,
    price_change_percentage_1y_in_currency: -53.71820358849679,
    price_change_percentage_200d_in_currency: 23.31756707291798,
    price_change_percentage_24h_in_currency: -8.424446623526855,
    price_change_percentage_30d_in_currency: 4.796137202174518,
    price_change_percentage_7d_in_currency: -30.532363812769425,
  },
  {
    id: "axie-infinity",
    symbol: "axs",
    name: "Axie Infinity",
    image:
      "https://assets.coingecko.com/coins/images/13029/large/axie_infinity_logo.png?1604471082",
    current_price: 8.01,
    market_cap: 926481387,
    market_cap_rank: 56,
    fully_diluted_valuation: 2162779148,
    total_volume: 40664117,
    high_24h: 8.45,
    low_24h: 7.87,
    price_change_24h: -0.42134750684013866,
    price_change_percentage_24h: -4.99653,
    market_cap_change_24h: -49048755.432646155,
    market_cap_change_percentage_24h: -5.02791,
    circulating_supply: 115661358.61362292,
    total_supply: 270000000,
    max_supply: 270000000,
    ath: 164.9,
    ath_change_percentage: -95.15381,
    ath_date: "2021-11-06T19:29:29.482Z",
    atl: 0.123718,
    atl_change_percentage: 6359.24652,
    atl_date: "2020-11-06T08:05:43.662Z",
    roi: null,
    last_updated: "2023-03-27T23:31:35.666Z",
    price_change_percentage_14d_in_currency: 1.2482234430570385,
    price_change_percentage_1h_in_currency: 0.32103391349354793,
    price_change_percentage_1y_in_currency: -87.98355468493787,
    price_change_percentage_200d_in_currency: -40.82869628424759,
    price_change_percentage_24h_in_currency: -4.9965322382737245,
    price_change_percentage_30d_in_currency: -20.155918562467512,
    price_change_percentage_7d_in_currency: -12.835620889478005,
  },
  {
    id: "neo",
    symbol: "neo",
    name: "NEO",
    image:
      "https://assets.coingecko.com/coins/images/480/large/NEO_512_512.png?1594357361",
    current_price: 12.64,
    market_cap: 885053331,
    market_cap_rank: 57,
    fully_diluted_valuation: null,
    total_volume: 85715951,
    high_24h: 12.96,
    low_24h: 11.99,
    price_change_24h: 0.280969,
    price_change_percentage_24h: 2.27388,
    market_cap_change_24h: 13388523,
    market_cap_change_percentage_24h: 1.53597,
    circulating_supply: 70530000,
    total_supply: 100000000,
    max_supply: null,
    ath: 198.38,
    ath_change_percentage: -93.67781,
    ath_date: "2018-01-15T00:00:00.000Z",
    atl: 0.078349,
    atl_change_percentage: 15907.83709,
    atl_date: "2016-10-21T00:00:00.000Z",
    roi: {
      times: 350.03634209032,
      currency: "usd",
      percentage: 35003.634209032,
    },
    last_updated: "2023-03-27T23:31:52.546Z",
    price_change_percentage_14d_in_currency: 22.45465559413689,
    price_change_percentage_1h_in_currency: 2.0688398023521746,
    price_change_percentage_1y_in_currency: -48.75965986809959,
    price_change_percentage_200d_in_currency: 42.42296477935426,
    price_change_percentage_24h_in_currency: 2.27388410064669,
    price_change_percentage_30d_in_currency: 8.543893622038633,
    price_change_percentage_7d_in_currency: -6.9468978965159,
  },
  {
    id: "kucoin-shares",
    symbol: "kcs",
    name: "KuCoin",
    image:
      "https://assets.coingecko.com/coins/images/1047/large/sa9z79.png?1610678720",
    current_price: 8.26,
    market_cap: 801280097,
    market_cap_rank: 58,
    fully_diluted_valuation: null,
    total_volume: 2393889,
    high_24h: 8.73,
    low_24h: 8.21,
    price_change_24h: -0.4659013923408377,
    price_change_percentage_24h: -5.34122,
    market_cap_change_24h: -48604337.742474794,
    market_cap_change_percentage_24h: -5.71893,
    circulating_supply: 97158831.4573204,
    total_supply: 144658831.457236,
    max_supply: null,
    ath: 28.83,
    ath_change_percentage: -71.393,
    ath_date: "2021-12-01T15:09:35.541Z",
    atl: 0.342863,
    atl_change_percentage: 2305.44042,
    atl_date: "2019-02-07T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:48.472Z",
    price_change_percentage_14d_in_currency: -4.937233943483223,
    price_change_percentage_1h_in_currency: 0.24283695928918317,
    price_change_percentage_1y_in_currency: -55.99113346083596,
    price_change_percentage_200d_in_currency: -10.298472646689795,
    price_change_percentage_24h_in_currency: -5.341216368729206,
    price_change_percentage_30d_in_currency: -4.346900990025444,
    price_change_percentage_7d_in_currency: -12.027188389321086,
  },
  {
    id: "rocket-pool",
    symbol: "rpl",
    name: "Rocket Pool",
    image:
      "https://assets.coingecko.com/coins/images/2090/large/rocket_pool_%28RPL%29.png?1637662441",
    current_price: 40.13,
    market_cap: 771324216,
    market_cap_rank: 59,
    fully_diluted_valuation: null,
    total_volume: 6141267,
    high_24h: 42.63,
    low_24h: 39.85,
    price_change_24h: -2.0819274467813003,
    price_change_percentage_24h: -4.93213,
    market_cap_change_24h: -40947462.14345157,
    market_cap_change_percentage_24h: -5.0411,
    circulating_supply: 19257025.5471179,
    total_supply: 19257025.5471179,
    max_supply: null,
    ath: 59.46,
    ath_change_percentage: -32.63286,
    ath_date: "2021-11-09T04:03:31.003Z",
    atl: 0.00884718,
    atl_change_percentage: 452628.37171,
    atl_date: "2018-08-28T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.796Z",
    price_change_percentage_14d_in_currency: 7.808544806751025,
    price_change_percentage_1h_in_currency: 0.2932334048230702,
    price_change_percentage_1y_in_currency: 17.39114169910872,
    price_change_percentage_200d_in_currency: 56.24348230094729,
    price_change_percentage_24h_in_currency: -4.93212764942249,
    price_change_percentage_30d_in_currency: -13.984631094212501,
    price_change_percentage_7d_in_currency: -7.059103579571932,
  },
  {
    id: "paxos-standard",
    symbol: "usdp",
    name: "Pax Dollar",
    image:
      "https://assets.coingecko.com/coins/images/6013/large/Pax_Dollar.png?1629877204",
    current_price: 1.001,
    market_cap: 758589718,
    market_cap_rank: 60,
    fully_diluted_valuation: 758589718,
    total_volume: 7760411,
    high_24h: 1.005,
    low_24h: 0.981043,
    price_change_24h: 0.00064741,
    price_change_percentage_24h: 0.06471,
    market_cap_change_24h: -14936286.881255865,
    market_cap_change_percentage_24h: -1.93094,
    circulating_supply: 757552716.460683,
    total_supply: 757552716.460683,
    max_supply: null,
    ath: 1.13,
    ath_change_percentage: -11.20051,
    ath_date: "2018-10-15T07:09:12.459Z",
    atl: 0.863529,
    atl_change_percentage: 15.96246,
    atl_date: "2021-05-19T13:14:42.046Z",
    roi: {
      times: 0.001184294192393,
      currency: "usd",
      percentage: 0.1184294192393,
    },
    last_updated: "2023-03-27T23:31:54.686Z",
    price_change_percentage_14d_in_currency: 0.828873693596373,
    price_change_percentage_1h_in_currency: 0.04321449513591447,
    price_change_percentage_1y_in_currency: 0.13049622883025722,
    price_change_percentage_200d_in_currency: 0.2893316302801141,
    price_change_percentage_24h_in_currency: 0.06470650395438948,
    price_change_percentage_30d_in_currency: 0.2960307396319438,
    price_change_percentage_7d_in_currency: 0.0075012209698446805,
  },
  {
    id: "bitdao",
    symbol: "bit",
    name: "BitDAO",
    image:
      "https://assets.coingecko.com/coins/images/17627/large/rI_YptK8.png?1653983088",
    current_price: 0.516076,
    market_cap: 740095926,
    market_cap_rank: 61,
    fully_diluted_valuation: 4960215356,
    total_volume: 4362334,
    high_24h: 0.526773,
    low_24h: 0.513457,
    price_change_24h: -0.009433222780698917,
    price_change_percentage_24h: -1.79506,
    market_cap_change_24h: -13654966.203555226,
    market_cap_change_percentage_24h: -1.8116,
    circulating_supply: 1433909320.2107098,
    total_supply: 9610239403,
    max_supply: 9610239403,
    ath: 3.1,
    ath_change_percentage: -83.37638,
    ath_date: "2021-11-12T04:54:56.433Z",
    atl: 0.270167,
    atl_change_percentage: 90.88054,
    atl_date: "2022-11-22T08:40:21.230Z",
    roi: null,
    last_updated: "2023-03-27T23:31:44.637Z",
    price_change_percentage_14d_in_currency: 3.5007041854808594,
    price_change_percentage_1h_in_currency: 0.2581813037373316,
    price_change_percentage_1y_in_currency: -58.240237639675364,
    price_change_percentage_200d_in_currency: -18.58267878939063,
    price_change_percentage_24h_in_currency: -1.7950638164948085,
    price_change_percentage_30d_in_currency: -9.466867877329447,
    price_change_percentage_7d_in_currency: -6.731040420082322,
  },
  {
    id: "havven",
    symbol: "snx",
    name: "Synthetix Network",
    image:
      "https://assets.coingecko.com/coins/images/3406/large/SNX.png?1598631139",
    current_price: 2.34,
    market_cap: 737323583,
    market_cap_rank: 62,
    fully_diluted_valuation: 739016578,
    total_volume: 75023334,
    high_24h: 2.54,
    low_24h: 2.3,
    price_change_24h: -0.14477995388411502,
    price_change_percentage_24h: -5.82975,
    market_cap_change_24h: -45766661.793571234,
    market_cap_change_percentage_24h: -5.84437,
    circulating_supply: 315272304.13952357,
    total_supply: 315996212.088774,
    max_supply: 315996212.088774,
    ath: 28.53,
    ath_change_percentage: -91.81373,
    ath_date: "2021-02-14T01:12:38.505Z",
    atl: 0.0347864,
    atl_change_percentage: 6614.49205,
    atl_date: "2019-01-06T00:00:00.000Z",
    roi: {
      times: 3.677376178969564,
      currency: "usd",
      percentage: 367.7376178969564,
    },
    last_updated: "2023-03-27T23:31:34.997Z",
    price_change_percentage_14d_in_currency: -15.200232007469577,
    price_change_percentage_1h_in_currency: 0.9145684466328932,
    price_change_percentage_1y_in_currency: -54.31519599310837,
    price_change_percentage_200d_in_currency: -21.69977145564182,
    price_change_percentage_24h_in_currency: -5.829749018542506,
    price_change_percentage_30d_in_currency: -11.351819344495768,
    price_change_percentage_7d_in_currency: -20.114745562766554,
  },
  {
    id: "whitebit",
    symbol: "wbt",
    name: "WhiteBIT Token",
    image:
      "https://assets.coingecko.com/coins/images/27045/large/wbt_token.png?1667923752",
    current_price: 5.1,
    market_cap: 729617388,
    market_cap_rank: 63,
    fully_diluted_valuation: 2025048279,
    total_volume: 8322288,
    high_24h: 5.12,
    low_24h: 4.82,
    price_change_24h: 0.05336,
    price_change_percentage_24h: 1.05685,
    market_cap_change_24h: 1240283,
    market_cap_change_percentage_24h: 0.17028,
    circulating_supply: 144118517.10815412,
    total_supply: 377982163,
    max_supply: 400000000,
    ath: 14.64,
    ath_change_percentage: -65.01508,
    ath_date: "2022-10-28T12:32:18.119Z",
    atl: 3.06,
    atl_change_percentage: 67.33777,
    atl_date: "2023-02-13T19:01:21.899Z",
    roi: null,
    last_updated: "2023-03-27T23:30:03.469Z",
    price_change_percentage_14d_in_currency: 36.506125830232165,
    price_change_percentage_1h_in_currency: 0.35850249809502827,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: -12.384498915239016,
    price_change_percentage_24h_in_currency: 1.0568452874065426,
    price_change_percentage_30d_in_currency: 34.39779753990751,
    price_change_percentage_7d_in_currency: 0.7230973487694282,
  },
  {
    id: "usdd",
    symbol: "usdd",
    name: "USDD",
    image:
      "https://assets.coingecko.com/coins/images/25380/large/UUSD.jpg?1651823371",
    current_price: 0.992421,
    market_cap: 719393622,
    market_cap_rank: 64,
    fully_diluted_valuation: null,
    total_volume: 21521021,
    high_24h: 0.994885,
    low_24h: 0.986064,
    price_change_24h: -0.000846772409399232,
    price_change_percentage_24h: -0.08525,
    market_cap_change_24h: -1047596.2671456337,
    market_cap_change_percentage_24h: -0.14541,
    circulating_supply: 725332035.842248,
    total_supply: null,
    max_supply: null,
    ath: 1.044,
    ath_change_percentage: -5.05468,
    ath_date: "2022-11-09T09:56:06.131Z",
    atl: 0.928067,
    atl_change_percentage: 6.79674,
    atl_date: "2022-06-19T16:15:11.558Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.658Z",
    price_change_percentage_14d_in_currency: 0.1699869039067207,
    price_change_percentage_1h_in_currency: 0.058884270768914636,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: -0.4027781454061887,
    price_change_percentage_24h_in_currency: -0.08525119502614854,
    price_change_percentage_30d_in_currency: -0.2688171964495245,
    price_change_percentage_7d_in_currency: -0.9287810425079411,
  },
  {
    id: "terra-luna",
    symbol: "lunc",
    name: "Terra Luna Classic",
    image:
      "https://assets.coingecko.com/coins/images/8284/large/01_LunaClassic_color.png?1653547790",
    current_price: 0.00012098,
    market_cap: 711921079,
    market_cap_rank: 65,
    fully_diluted_valuation: 828154540,
    total_volume: 45944573,
    high_24h: 0.00012553,
    low_24h: 0.00011896,
    price_change_24h: -0.000004529082471688,
    price_change_percentage_24h: -3.6085,
    market_cap_change_24h: -28479986.79357946,
    market_cap_change_percentage_24h: -3.84656,
    circulating_supply: 5895890452889.58,
    total_supply: 6858496802282.83,
    max_supply: null,
    ath: 119.18,
    ath_change_percentage: -99.9999,
    ath_date: "2022-04-05T12:24:58.854Z",
    atl: 9.99967e-7,
    atl_change_percentage: 11975.2703,
    atl_date: "2022-05-13T02:34:40.340Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.883Z",
    price_change_percentage_14d_in_currency: -6.220983082696631,
    price_change_percentage_1h_in_currency: -0.05153253575232757,
    price_change_percentage_1y_in_currency: -99.99986762720242,
    price_change_percentage_200d_in_currency: -72.73462982905131,
    price_change_percentage_24h_in_currency: -3.6085015362617776,
    price_change_percentage_30d_in_currency: -26.756315827108356,
    price_change_percentage_7d_in_currency: -10.55156232758506,
  },
  {
    id: "klay-token",
    symbol: "klay",
    name: "Klaytn",
    image:
      "https://assets.coingecko.com/coins/images/9672/large/klaytn.png?1660288824",
    current_price: 0.223642,
    market_cap: 688420481,
    market_cap_rank: 66,
    fully_diluted_valuation: null,
    total_volume: 35796292,
    high_24h: 0.231408,
    low_24h: 0.221297,
    price_change_24h: -0.007523075954704779,
    price_change_percentage_24h: -3.25441,
    market_cap_change_24h: -23153576.515586734,
    market_cap_change_percentage_24h: -3.25385,
    circulating_supply: 3080694709.96682,
    total_supply: null,
    max_supply: null,
    ath: 4.34,
    ath_change_percentage: -94.84977,
    ath_date: "2021-03-30T03:44:28.828Z",
    atl: 0.06044,
    atl_change_percentage: 269.73089,
    atl_date: "2020-04-29T08:19:34.574Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.969Z",
    price_change_percentage_14d_in_currency: -4.5807904777766595,
    price_change_percentage_1h_in_currency: -0.10446453879290521,
    price_change_percentage_1y_in_currency: -80.47627835839674,
    price_change_percentage_200d_in_currency: 2.0513364791974507,
    price_change_percentage_24h_in_currency: -3.2544121116239397,
    price_change_percentage_30d_in_currency: -18.85607829555728,
    price_change_percentage_7d_in_currency: -6.9321036649230425,
  },
  {
    id: "curve-dao-token",
    symbol: "crv",
    name: "Curve DAO",
    image:
      "https://assets.coingecko.com/coins/images/12124/large/Curve.png?1597369484",
    current_price: 0.890323,
    market_cap: 686675715,
    market_cap_rank: 67,
    fully_diluted_valuation: 2939694444,
    total_volume: 60742943,
    high_24h: 0.93799,
    low_24h: 0.876667,
    price_change_24h: -0.0456331444792023,
    price_change_percentage_24h: -4.87557,
    market_cap_change_24h: -35043040.49295628,
    market_cap_change_percentage_24h: -4.8555,
    circulating_supply: 771546409,
    total_supply: 1922887396.72704,
    max_supply: 3303030299,
    ath: 15.37,
    ath_change_percentage: -94.21428,
    ath_date: "2020-08-14T00:00:00.000Z",
    atl: 0.331577,
    atl_change_percentage: 168.22902,
    atl_date: "2020-11-05T13:09:50.181Z",
    roi: null,
    last_updated: "2023-03-27T23:31:40.197Z",
    price_change_percentage_14d_in_currency: -4.884960984739506,
    price_change_percentage_1h_in_currency: 0.5403253839714661,
    price_change_percentage_1y_in_currency: -62.979346167210245,
    price_change_percentage_200d_in_currency: -23.724692585346833,
    price_change_percentage_24h_in_currency: -4.875566153754919,
    price_change_percentage_30d_in_currency: -10.895404776743916,
    price_change_percentage_7d_in_currency: -13.544656118265433,
  },
  {
    id: "bitcoin-cash-sv",
    symbol: "bsv",
    name: "Bitcoin SV",
    image:
      "https://assets.coingecko.com/coins/images/6799/large/BSV.png?1558947902",
    current_price: 35.46,
    market_cap: 683144229,
    market_cap_rank: 68,
    fully_diluted_valuation: 744626374,
    total_volume: 16544263,
    high_24h: 37.09,
    low_24h: 34.97,
    price_change_24h: -1.2854077947369262,
    price_change_percentage_24h: -3.49825,
    market_cap_change_24h: -24502694.99413693,
    market_cap_change_percentage_24h: -3.46256,
    circulating_supply: 19266076.644239,
    total_supply: 21000000,
    max_supply: 21000000,
    ath: 489.75,
    ath_change_percentage: -92.75313,
    ath_date: "2021-04-16T17:09:04.630Z",
    atl: 31.89,
    atl_change_percentage: 11.30802,
    atl_date: "2023-03-10T11:01:28.159Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.930Z",
    price_change_percentage_14d_in_currency: 1.7547931505670042,
    price_change_percentage_1h_in_currency: 0.2527990804695517,
    price_change_percentage_1y_in_currency: -60.582880655837855,
    price_change_percentage_200d_in_currency: -31.47184646543058,
    price_change_percentage_24h_in_currency: -3.498251120223756,
    price_change_percentage_30d_in_currency: -14.223845609382657,
    price_change_percentage_7d_in_currency: -5.610950183792363,
  },
  {
    id: "gatechain-token",
    symbol: "gt",
    name: "Gate",
    image:
      "https://assets.coingecko.com/coins/images/8183/large/gt.png?1556085624",
    current_price: 4.84,
    market_cap: 682478415,
    market_cap_rank: 69,
    fully_diluted_valuation: null,
    total_volume: 958723,
    high_24h: 5.16,
    low_24h: 4.8,
    price_change_24h: -0.31851912805133065,
    price_change_percentage_24h: -6.17319,
    market_cap_change_24h: -45003124.976903915,
    market_cap_change_percentage_24h: -6.18615,
    circulating_supply: 140973058.65504882,
    total_supply: 300000000,
    max_supply: null,
    ath: 12.94,
    ath_change_percentage: -62.62195,
    ath_date: "2021-05-12T11:39:16.531Z",
    atl: 0.25754,
    atl_change_percentage: 1778.31455,
    atl_date: "2020-03-13T02:18:02.481Z",
    roi: null,
    last_updated: "2023-03-27T23:31:37.434Z",
    price_change_percentage_14d_in_currency: 0.1682621613865512,
    price_change_percentage_1h_in_currency: 0.23119541358379853,
    price_change_percentage_1y_in_currency: -25.388067792103175,
    price_change_percentage_200d_in_currency: 20.83613842517361,
    price_change_percentage_24h_in_currency: -6.173190371195424,
    price_change_percentage_30d_in_currency: -7.904177050854987,
    price_change_percentage_7d_in_currency: -12.27887118504592,
  },
  {
    id: "conflux-token",
    symbol: "cfx",
    name: "Conflux",
    image:
      "https://assets.coingecko.com/coins/images/13079/large/3vuYMbjN.png?1631512305",
    current_price: 0.32068,
    market_cap: 672467222,
    market_cap_rank: 70,
    fully_diluted_valuation: null,
    total_volume: 275338483,
    high_24h: 0.35284,
    low_24h: 0.314254,
    price_change_24h: -0.03168204606600683,
    price_change_percentage_24h: -8.99133,
    market_cap_change_24h: -65198785.59785378,
    market_cap_change_percentage_24h: -8.83852,
    circulating_supply: 2097547687.26523,
    total_supply: 5284997962.62513,
    max_supply: null,
    ath: 1.7,
    ath_change_percentage: -81.16926,
    ath_date: "2021-03-27T03:43:35.178Z",
    atl: 0.02199898,
    atl_change_percentage: 1355.89406,
    atl_date: "2022-12-30T08:16:30.345Z",
    roi: null,
    last_updated: "2023-03-27T23:31:51.402Z",
    price_change_percentage_14d_in_currency: 75.9473614588684,
    price_change_percentage_1h_in_currency: 0.1530465088705785,
    price_change_percentage_1y_in_currency: 114.10786538092019,
    price_change_percentage_200d_in_currency: 518.9491891350901,
    price_change_percentage_24h_in_currency: -8.991332902280767,
    price_change_percentage_30d_in_currency: 33.613613837192595,
    price_change_percentage_7d_in_currency: -30.47972222219003,
  },
  {
    id: "pancakeswap-token",
    symbol: "cake",
    name: "PancakeSwap",
    image:
      "https://assets.coingecko.com/coins/images/12632/large/pancakeswap-cake-logo_%281%29.png?1629359065",
    current_price: 3.58,
    market_cap: 652893945,
    market_cap_rank: 71,
    fully_diluted_valuation: 2680544104,
    total_volume: 60778635,
    high_24h: 3.76,
    low_24h: 3.54,
    price_change_24h: -0.17616079467789225,
    price_change_percentage_24h: -4.69255,
    market_cap_change_24h: -47130537.470856786,
    market_cap_change_percentage_24h: -6.7327,
    circulating_supply: 182675770.271119,
    total_supply: 376868148.758852,
    max_supply: 750000000,
    ath: 43.96,
    ath_change_percentage: -91.86721,
    ath_date: "2021-04-30T10:08:22.934Z",
    atl: 0.194441,
    atl_change_percentage: 1738.88994,
    atl_date: "2020-11-03T14:29:34.165Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.032Z",
    price_change_percentage_14d_in_currency: -2.667286775688775,
    price_change_percentage_1h_in_currency: 0.22023484606779162,
    price_change_percentage_1y_in_currency: -51.20837980273929,
    price_change_percentage_200d_in_currency: -13.098200994132595,
    price_change_percentage_24h_in_currency: -4.692548804778556,
    price_change_percentage_30d_in_currency: -10.100499427875743,
    price_change_percentage_7d_in_currency: -7.689382066845823,
  },
  {
    id: "optimism",
    symbol: "op",
    name: "Optimism",
    image:
      "https://assets.coingecko.com/coins/images/25244/large/Optimism.png?1660904599",
    current_price: 2.07,
    market_cap: 649057446,
    market_cap_rank: 72,
    fully_diluted_valuation: 8854160327,
    total_volume: 198222192,
    high_24h: 2.28,
    low_24h: 2.02,
    price_change_24h: -0.21140467929067208,
    price_change_percentage_24h: -9.28501,
    market_cap_change_24h: -67830870.4054482,
    market_cap_change_percentage_24h: -9.46185,
    circulating_supply: 314844141,
    total_supply: 4294967296,
    max_supply: 4294967296,
    ath: 3.22,
    ath_change_percentage: -36.10643,
    ath_date: "2023-02-24T20:20:00.509Z",
    atl: 0.402159,
    atl_change_percentage: 412.08835,
    atl_date: "2022-06-18T20:54:52.178Z",
    roi: null,
    last_updated: "2023-03-27T23:31:51.053Z",
    price_change_percentage_14d_in_currency: -11.990501785972638,
    price_change_percentage_1h_in_currency: 0.061740408674457764,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: 76.01512807958204,
    price_change_percentage_24h_in_currency: -9.285011900735176,
    price_change_percentage_30d_in_currency: -32.31707231073453,
    price_change_percentage_7d_in_currency: -24.414362585851784,
  },
  {
    id: "mina-protocol",
    symbol: "mina",
    name: "Mina Protocol",
    image:
      "https://assets.coingecko.com/coins/images/15628/large/JM4_vQ34_400x400.png?1621394004",
    current_price: 0.733433,
    market_cap: 639206190,
    market_cap_rank: 73,
    fully_diluted_valuation: 742972130,
    total_volume: 57186565,
    high_24h: 0.816373,
    low_24h: 0.715251,
    price_change_24h: -0.08278393982731713,
    price_change_percentage_24h: -10.1424,
    market_cap_change_24h: -73487929.87432909,
    market_cap_change_percentage_24h: -10.31129,
    circulating_supply: 874572942.840039,
    total_supply: 1016547292.84004,
    max_supply: null,
    ath: 9.09,
    ath_change_percentage: -91.96679,
    ath_date: "2021-06-01T01:42:37.064Z",
    atl: 0.422757,
    atl_change_percentage: 72.73456,
    atl_date: "2023-01-01T03:25:49.254Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.845Z",
    price_change_percentage_14d_in_currency: 5.541700553518179,
    price_change_percentage_1h_in_currency: 0.9243159688022865,
    price_change_percentage_1y_in_currency: -71.37842179145758,
    price_change_percentage_200d_in_currency: 11.891899863262905,
    price_change_percentage_24h_in_currency: -10.142399705267414,
    price_change_percentage_30d_in_currency: -22.930342034405502,
    price_change_percentage_7d_in_currency: -16.23510287813572,
  },
  {
    id: "dash",
    symbol: "dash",
    name: "Dash",
    image:
      "https://assets.coingecko.com/coins/images/19/large/dash-logo.png?1548385930",
    current_price: 55.95,
    market_cap: 626969878,
    market_cap_rank: 74,
    fully_diluted_valuation: null,
    total_volume: 75573487,
    high_24h: 59.67,
    low_24h: 54.93,
    price_change_24h: -3.6672136282974463,
    price_change_percentage_24h: -6.15177,
    market_cap_change_24h: -41201029.96314597,
    market_cap_change_percentage_24h: -6.16624,
    circulating_supply: 11206685.5511826,
    total_supply: 18920000,
    max_supply: null,
    ath: 1493.59,
    ath_change_percentage: -96.2595,
    ath_date: "2017-12-20T00:00:00.000Z",
    atl: 0.213899,
    atl_change_percentage: 26018.7254,
    atl_date: "2014-02-14T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:54.348Z",
    price_change_percentage_14d_in_currency: 4.327760096948223,
    price_change_percentage_1h_in_currency: 0.44098486445244645,
    price_change_percentage_1y_in_currency: -56.26747769179982,
    price_change_percentage_200d_in_currency: 23.612473214847498,
    price_change_percentage_24h_in_currency: -6.151768345378137,
    price_change_percentage_30d_in_currency: -20.19421605207492,
    price_change_percentage_7d_in_currency: -3.8074208569235783,
  },
  {
    id: "gmx",
    symbol: "gmx",
    name: "GMX",
    image:
      "https://assets.coingecko.com/coins/images/18323/large/arbit.png?1631532468",
    current_price: 72.27,
    market_cap: 619912727,
    market_cap_rank: 75,
    fully_diluted_valuation: 957515896,
    total_volume: 60210080,
    high_24h: 72.55,
    low_24h: 66.08,
    price_change_24h: 2.78,
    price_change_percentage_24h: 3.99796,
    market_cap_change_24h: 24346495,
    market_cap_change_percentage_24h: 4.08796,
    circulating_supply: 8578284.35694856,
    total_supply: 8578284.35694856,
    max_supply: 13250000,
    ath: 85.95,
    ath_change_percentage: -16.08028,
    ath_date: "2023-03-18T01:50:39.186Z",
    atl: 11.53,
    atl_change_percentage: 525.36336,
    atl_date: "2022-06-15T09:30:22.146Z",
    roi: null,
    last_updated: "2023-03-27T23:31:40.516Z",
    price_change_percentage_14d_in_currency: 5.255247011777874,
    price_change_percentage_1h_in_currency: -0.15341768032761643,
    price_change_percentage_1y_in_currency: 152.0462023063907,
    price_change_percentage_200d_in_currency: 36.14874268730179,
    price_change_percentage_24h_in_currency: 3.997957001272787,
    price_change_percentage_30d_in_currency: -1.9594499535327086,
    price_change_percentage_7d_in_currency: -11.712055900889814,
  },
  {
    id: "maker",
    symbol: "mkr",
    name: "Maker",
    image:
      "https://assets.coingecko.com/coins/images/1364/large/Mark_Maker.png?1585191826",
    current_price: 677.7,
    market_cap: 610947671,
    market_cap_rank: 76,
    fully_diluted_valuation: 681623726,
    total_volume: 36713283,
    high_24h: 680.14,
    low_24h: 637.55,
    price_change_24h: 3.99,
    price_change_percentage_24h: 0.59292,
    market_cap_change_24h: 3157108,
    market_cap_change_percentage_24h: 0.51944,
    circulating_supply: 901310.9472893132,
    total_supply: 977631.036950888,
    max_supply: 1005577,
    ath: 6292.31,
    ath_change_percentage: -89.22645,
    ath_date: "2021-05-03T21:54:29.333Z",
    atl: 168.36,
    atl_change_percentage: 302.65836,
    atl_date: "2020-03-16T20:52:36.527Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.924Z",
    price_change_percentage_14d_in_currency: -22.3972909845645,
    price_change_percentage_1h_in_currency: -0.22334256901788305,
    price_change_percentage_1y_in_currency: -66.33725238925746,
    price_change_percentage_200d_in_currency: -8.197476778855467,
    price_change_percentage_24h_in_currency: 0.5929218762965583,
    price_change_percentage_30d_in_currency: -4.912182832816001,
    price_change_percentage_7d_in_currency: -1.9576724038719282,
  },
  {
    id: "chiliz",
    symbol: "chz",
    name: "Chiliz",
    image:
      "https://assets.coingecko.com/coins/images/8834/large/CHZ_Token_updated.png?1675848257",
    current_price: 0.114073,
    market_cap: 609393766,
    market_cap_rank: 77,
    fully_diluted_valuation: 1013616770,
    total_volume: 68517348,
    high_24h: 0.121253,
    low_24h: 0.112725,
    price_change_24h: -0.007012309494338301,
    price_change_percentage_24h: -5.79119,
    market_cap_change_24h: -37877677.99187422,
    market_cap_change_percentage_24h: -5.8519,
    circulating_supply: 5344064580,
    total_supply: 8888888888,
    max_supply: 8888888888,
    ath: 0.878633,
    ath_change_percentage: -87.02952,
    ath_date: "2021-03-13T08:04:21.200Z",
    atl: 0.00410887,
    atl_change_percentage: 2673.58034,
    atl_date: "2019-09-28T00:00:00.000Z",
    roi: {
      times: 4.185156068207632,
      currency: "usd",
      percentage: 418.5156068207632,
    },
    last_updated: "2023-03-27T23:31:58.260Z",
    price_change_percentage_14d_in_currency: -1.1640399379490403,
    price_change_percentage_1h_in_currency: 0.23892978769252177,
    price_change_percentage_1y_in_currency: -52.91576563180139,
    price_change_percentage_200d_in_currency: -41.23752087504314,
    price_change_percentage_24h_in_currency: -5.79119334852931,
    price_change_percentage_30d_in_currency: -15.731206941738588,
    price_change_percentage_7d_in_currency: -6.9638912534650546,
  },
  {
    id: "bittorrent",
    symbol: "btt",
    name: "BitTorrent",
    image:
      "https://assets.coingecko.com/coins/images/22457/large/btt_logo.png?1643857231",
    current_price: 6.16186e-7,
    market_cap: 585949534,
    market_cap_rank: 79,
    fully_diluted_valuation: 609708640,
    total_volume: 11426115,
    high_24h: 6.22137e-7,
    low_24h: 6.00531e-7,
    price_change_24h: -5.951387621e-9,
    price_change_percentage_24h: -0.9566,
    market_cap_change_24h: -5960453.6033478975,
    market_cap_change_percentage_24h: -1.00699,
    circulating_supply: 951421714286000,
    total_supply: 990000000000000,
    max_supply: 990000000000000,
    ath: 0.00000343,
    ath_change_percentage: -82.06635,
    ath_date: "2022-01-21T04:00:31.909Z",
    atl: 5.8926e-7,
    atl_change_percentage: 4.43008,
    atl_date: "2023-03-11T08:30:00.452Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.757Z",
    price_change_percentage_14d_in_currency: -3.7275007303029186,
    price_change_percentage_1h_in_currency: 0.34257019599321065,
    price_change_percentage_1y_in_currency: -68.14686777357217,
    price_change_percentage_200d_in_currency: -30.314317956951243,
    price_change_percentage_24h_in_currency: -0.9566037034014439,
    price_change_percentage_30d_in_currency: -12.955474531758806,
    price_change_percentage_7d_in_currency: -7.269917945577744,
  },
  {
    id: "huobi-token",
    symbol: "ht",
    name: "Huobi",
    image:
      "https://assets.coingecko.com/coins/images/2822/large/huobi-token-logo.png?1547036992",
    current_price: 3.59,
    market_cap: 581982280,
    market_cap_rank: 78,
    fully_diluted_valuation: 731277244,
    total_volume: 6934724,
    high_24h: 3.7,
    low_24h: 3.54,
    price_change_24h: -0.11158302285821353,
    price_change_percentage_24h: -3.01852,
    market_cap_change_24h: -17759528.248057365,
    market_cap_change_percentage_24h: -2.9612,
    circulating_supply: 162336522.3,
    total_supply: 203980445.3,
    max_supply: 203980445.3,
    ath: 39.66,
    ath_change_percentage: -90.96664,
    ath_date: "2021-05-12T14:42:21.586Z",
    atl: 0.90862,
    atl_change_percentage: 294.30142,
    atl_date: "2019-01-30T00:00:00.000Z",
    roi: {
      times: 2.621248508476298,
      currency: "usd",
      percentage: 262.1248508476298,
    },
    last_updated: "2023-03-27T23:31:51.695Z",
    price_change_percentage_14d_in_currency: -14.584263599650718,
    price_change_percentage_1h_in_currency: -0.02450497468404835,
    price_change_percentage_1y_in_currency: -60.390091024265935,
    price_change_percentage_200d_in_currency: -23.797166328572068,
    price_change_percentage_24h_in_currency: -3.018515607428238,
    price_change_percentage_30d_in_currency: -32.26576681651836,
    price_change_percentage_7d_in_currency: -11.130460313051335,
  },
  {
    id: "ecash",
    symbol: "xec",
    name: "eCash",
    image:
      "https://assets.coingecko.com/coins/images/16646/large/Logo_final-22.png?1628239446",
    current_price: 0.00002966,
    market_cap: 573792310,
    market_cap_rank: 80,
    fully_diluted_valuation: 622891803,
    total_volume: 6147740,
    high_24h: 0.00003084,
    low_24h: 0.000029,
    price_change_24h: -0.000001085125735241,
    price_change_percentage_24h: -3.52894,
    market_cap_change_24h: -21390149.280169725,
    market_cap_change_percentage_24h: -3.59388,
    circulating_supply: 19344673423303,
    total_supply: 21000000000000,
    max_supply: 21000000000000,
    ath: 0.00038001,
    ath_change_percentage: -92.20142,
    ath_date: "2021-09-04T17:09:31.137Z",
    atl: 0.00001847,
    atl_change_percentage: 60.45366,
    atl_date: "2021-07-20T20:49:46.212Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.611Z",
    price_change_percentage_14d_in_currency: 2.4182151163976173,
    price_change_percentage_1h_in_currency: 0.24025681331805135,
    price_change_percentage_1y_in_currency: -65.55887560326043,
    price_change_percentage_200d_in_currency: -29.656685096033748,
    price_change_percentage_24h_in_currency: -3.5289428274597294,
    price_change_percentage_30d_in_currency: -16.92928838159463,
    price_change_percentage_7d_in_currency: -9.596603178507758,
  },
  {
    id: "iota",
    symbol: "miota",
    name: "IOTA",
    image:
      "https://assets.coingecko.com/coins/images/692/large/IOTA_Swirl.png?1604238557",
    current_price: 0.20023,
    market_cap: 556560801,
    market_cap_rank: 81,
    fully_diluted_valuation: null,
    total_volume: 13967143,
    high_24h: 0.21122,
    low_24h: 0.196826,
    price_change_24h: -0.01086445304504244,
    price_change_percentage_24h: -5.14672,
    market_cap_change_24h: -29965630.623630524,
    market_cap_change_percentage_24h: -5.109,
    circulating_supply: 2779530283.277761,
    total_supply: 2779530283,
    max_supply: null,
    ath: 5.25,
    ath_change_percentage: -96.18618,
    ath_date: "2017-12-19T00:00:00.000Z",
    atl: 0.081637,
    atl_change_percentage: 145.2049,
    atl_date: "2020-03-13T02:22:41.168Z",
    roi: {
      times: 4.49615064092473,
      currency: "btc",
      percentage: 449.61506409247306,
    },
    last_updated: "2023-03-27T23:31:59.365Z",
    price_change_percentage_14d_in_currency: -1.210767155831701,
    price_change_percentage_1h_in_currency: 0.12965424661857025,
    price_change_percentage_1y_in_currency: -75.91581037911934,
    price_change_percentage_200d_in_currency: -27.706247448012533,
    price_change_percentage_24h_in_currency: -5.146722328613169,
    price_change_percentage_30d_in_currency: -20.743491735163122,
    price_change_percentage_7d_in_currency: -10.047422070688704,
  },
  {
    id: "xdce-crowd-sale",
    symbol: "xdc",
    name: "XDC Network",
    image:
      "https://assets.coingecko.com/coins/images/2912/large/xdc-icon.png?1633700890",
    current_price: 0.0395177,
    market_cap: 547529459,
    market_cap_rank: 82,
    fully_diluted_valuation: null,
    total_volume: 5489388,
    high_24h: 0.04043313,
    low_24h: 0.03894,
    price_change_24h: -0.00045798824652761,
    price_change_percentage_24h: -1.14567,
    market_cap_change_24h: -4609206.813419938,
    market_cap_change_percentage_24h: -0.83479,
    circulating_supply: 13824747566.25,
    total_supply: 37824743009.7,
    max_supply: null,
    ath: 0.192754,
    ath_change_percentage: -79.46222,
    ath_date: "2021-08-21T04:39:48.324Z",
    atl: 0.00039532,
    atl_change_percentage: 9914.06949,
    atl_date: "2019-07-22T00:00:00.000Z",
    roi: {
      times: 2.061392989094435,
      currency: "eth",
      percentage: 206.13929890944348,
    },
    last_updated: "2023-03-27T23:31:51.221Z",
    price_change_percentage_14d_in_currency: 34.048523778785714,
    price_change_percentage_1h_in_currency: -0.2909782387280952,
    price_change_percentage_1y_in_currency: -33.38641325467537,
    price_change_percentage_200d_in_currency: 60.7575611597378,
    price_change_percentage_24h_in_currency: -1.1456670187461815,
    price_change_percentage_30d_in_currency: 51.17291211599585,
    price_change_percentage_7d_in_currency: 11.717426915409447,
  },
  {
    id: "bitget-token",
    symbol: "bgb",
    name: "Bitget Token",
    image:
      "https://assets.coingecko.com/coins/images/11610/large/photo_2022-01-24_14-08-03.jpg?1643019457",
    current_price: 0.390217,
    market_cap: 546183037,
    market_cap_rank: 83,
    fully_diluted_valuation: 780260924,
    total_volume: 6646242,
    high_24h: 0.40765,
    low_24h: 0.386945,
    price_change_24h: -0.017355122768555446,
    price_change_percentage_24h: -4.25817,
    market_cap_change_24h: -24387664.702708602,
    market_cap_change_percentage_24h: -4.27426,
    circulating_supply: 1400001000,
    total_supply: 2000000000,
    max_supply: 2000000000,
    ath: 0.515471,
    ath_change_percentage: -24.32438,
    ath_date: "2023-02-16T08:52:49.445Z",
    atl: 0.0142795,
    atl_change_percentage: 2631.79013,
    atl_date: "2020-06-25T04:17:05.895Z",
    roi: null,
    last_updated: "2023-03-27T23:31:31.477Z",
    price_change_percentage_14d_in_currency: 8.558825196795212,
    price_change_percentage_1h_in_currency: 0.0021840008104410317,
    price_change_percentage_1y_in_currency: 83.96788587936214,
    price_change_percentage_200d_in_currency: 139.51706222003693,
    price_change_percentage_24h_in_currency: -4.258171490323795,
    price_change_percentage_30d_in_currency: 1.1079679468742873,
    price_change_percentage_7d_in_currency: 1.977874570714695,
  },
  {
    id: "frax-share",
    symbol: "fxs",
    name: "Frax Share",
    image:
      "https://assets.coingecko.com/coins/images/13423/large/Frax_Shares_icon.png?1679886947",
    current_price: 7.48,
    market_cap: 531497997,
    market_cap_rank: 84,
    fully_diluted_valuation: 746430053,
    total_volume: 16529421,
    high_24h: 7.94,
    low_24h: 7.4,
    price_change_24h: -0.45585726937049387,
    price_change_percentage_24h: -5.74606,
    market_cap_change_24h: -33479987.87065375,
    market_cap_change_percentage_24h: -5.92589,
    circulating_supply: 71079287.2200396,
    total_supply: 99822984.1145714,
    max_supply: 99822984.1145714,
    ath: 42.8,
    ath_change_percentage: -82.52944,
    ath_date: "2022-01-12T15:22:27.465Z",
    atl: 1.5,
    atl_change_percentage: 397.44271,
    atl_date: "2021-06-25T16:50:51.447Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.618Z",
    price_change_percentage_14d_in_currency: -14.14484496225944,
    price_change_percentage_1h_in_currency: 0.04831243341570277,
    price_change_percentage_1y_in_currency: -63.760659996536496,
    price_change_percentage_200d_in_currency: 20.44875318007204,
    price_change_percentage_24h_in_currency: -5.746061036337671,
    price_change_percentage_30d_in_currency: -26.41694188392559,
    price_change_percentage_7d_in_currency: -12.031574587708835,
  },
  {
    id: "edgecoin-2",
    symbol: "edgt",
    name: "Edgecoin",
    image:
      "https://assets.coingecko.com/coins/images/14409/large/edgecoin_bank_logo-4_%281%29.png?1673251201",
    current_price: 1.003,
    market_cap: 526714747,
    market_cap_rank: 85,
    fully_diluted_valuation: 1002763845983,
    total_volume: 21943001,
    high_24h: 1.008,
    low_24h: 0.99802,
    price_change_24h: 0.00108283,
    price_change_percentage_24h: 0.1081,
    market_cap_change_24h: 544594,
    market_cap_change_percentage_24h: 0.1035,
    circulating_supply: 525263000.698,
    total_supply: 1000000000,
    max_supply: 1000000000000,
    ath: 2,
    ath_change_percentage: -49.97355,
    ath_date: "2021-12-17T06:09:45.294Z",
    atl: 0.206311,
    atl_change_percentage: 385.37442,
    atl_date: "2022-01-07T08:23:24.122Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.815Z",
    price_change_percentage_14d_in_currency: -0.4444145836792237,
    price_change_percentage_1h_in_currency: 0.010731318536307871,
    price_change_percentage_1y_in_currency: 0.34204610168049787,
    price_change_percentage_200d_in_currency: 0.24355813418879044,
    price_change_percentage_24h_in_currency: 0.10810174301766776,
    price_change_percentage_30d_in_currency: 0.2406070928179163,
    price_change_percentage_7d_in_currency: -0.45862565122090904,
  },
  {
    id: "compound-ether",
    symbol: "ceth",
    name: "cETH",
    image:
      "https://assets.coingecko.com/coins/images/10643/large/ceth2.JPG?1581389598",
    current_price: 34.36,
    market_cap: 523697873,
    market_cap_rank: 86,
    fully_diluted_valuation: 523697873,
    total_volume: 26.82,
    high_24h: 35.78,
    low_24h: 34.29,
    price_change_24h: -1.4101179443926526,
    price_change_percentage_24h: -3.94171,
    market_cap_change_24h: -9863928.413009346,
    market_cap_change_percentage_24h: -1.84869,
    circulating_supply: 15239661.9471228,
    total_supply: 15239661.9471228,
    max_supply: null,
    ath: 97.75,
    ath_change_percentage: -64.84507,
    ath_date: "2021-11-21T12:39:57.508Z",
    atl: 1.89,
    atl_change_percentage: 1721.78633,
    atl_date: "2020-03-13T02:22:33.711Z",
    roi: null,
    last_updated: "2023-03-27T23:07:01.046Z",
    price_change_percentage_14d_in_currency: 8.792131016886005,
    price_change_percentage_1h_in_currency: -0.05203945277824952,
    price_change_percentage_1y_in_currency: -45.35894217119265,
    price_change_percentage_200d_in_currency: 4.574430442428538,
    price_change_percentage_24h_in_currency: -3.941711264536857,
    price_change_percentage_30d_in_currency: 6.700118219683325,
    price_change_percentage_7d_in_currency: -5.090138252284485,
  },
  {
    id: "pax-gold",
    symbol: "paxg",
    name: "PAX Gold",
    image:
      "https://assets.coingecko.com/coins/images/9519/large/paxg.PNG?1568542565",
    current_price: 1983.28,
    market_cap: 507082653,
    market_cap_rank: 87,
    fully_diluted_valuation: null,
    total_volume: 14884008,
    high_24h: 1992.45,
    low_24h: 1960.78,
    price_change_24h: -7.770536819036806,
    price_change_percentage_24h: -0.39027,
    market_cap_change_24h: -1436865.7023116946,
    market_cap_change_percentage_24h: -0.28256,
    circulating_supply: 255755.251,
    total_supply: 255755.251,
    max_supply: null,
    ath: 2241.37,
    ath_change_percentage: -11.54296,
    ath_date: "2021-05-17T19:02:29.657Z",
    atl: 1399.64,
    atl_change_percentage: 41.65405,
    atl_date: "2019-11-18T03:09:35.959Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.071Z",
    price_change_percentage_14d_in_currency: 3.4520657922428706,
    price_change_percentage_1h_in_currency: 0.12535455454337047,
    price_change_percentage_1y_in_currency: 0.9998385134849486,
    price_change_percentage_200d_in_currency: 16.027221894754035,
    price_change_percentage_24h_in_currency: -0.3902740054598135,
    price_change_percentage_30d_in_currency: 10.143514027937327,
    price_change_percentage_7d_in_currency: 0.12436342244013521,
  },
  {
    id: "singularitynet",
    symbol: "agix",
    name: "SingularityNET",
    image:
      "https://assets.coingecko.com/coins/images/2138/large/singularitynet.png?1548609559",
    current_price: 0.404294,
    market_cap: 486178135,
    market_cap_rank: 88,
    fully_diluted_valuation: 806184105,
    total_volume: 133348989,
    high_24h: 0.450061,
    low_24h: 0.396697,
    price_change_24h: -0.04558699954635015,
    price_change_percentage_24h: -10.13313,
    market_cap_change_24h: -57025844.743112445,
    market_cap_change_percentage_24h: -10.49805,
    circulating_supply: 1206121857.26201,
    total_supply: 1271927708.23659,
    max_supply: 2000000000,
    ath: 0.95023,
    ath_change_percentage: -57.54828,
    ath_date: "2018-01-28T00:00:00.000Z",
    atl: 0.00747159,
    atl_change_percentage: 5298.97088,
    atl_date: "2020-03-13T02:24:16.528Z",
    roi: {
      times: 3.042936314495541,
      currency: "usd",
      percentage: 304.2936314495541,
    },
    last_updated: "2023-03-27T23:31:59.621Z",
    price_change_percentage_14d_in_currency: 7.255004176093119,
    price_change_percentage_1h_in_currency: 1.0693559458312412,
    price_change_percentage_1y_in_currency: 143.81191050511214,
    price_change_percentage_200d_in_currency: 893.4390980177611,
    price_change_percentage_24h_in_currency: -10.133132303436549,
    price_change_percentage_30d_in_currency: -9.205201041381224,
    price_change_percentage_7d_in_currency: -22.161357547538174,
  },
  {
    id: "tokenize-xchange",
    symbol: "tkx",
    name: "Tokenize Xchange",
    image:
      "https://assets.coingecko.com/coins/images/4984/large/TKX_-_Logo_-_RGB-15.png?1672912391",
    current_price: 6.05,
    market_cap: 484326965,
    market_cap_rank: 89,
    fully_diluted_valuation: 605438978,
    total_volume: 8337112,
    high_24h: 6.32,
    low_24h: 6.01,
    price_change_24h: -0.2644876858078833,
    price_change_percentage_24h: -4.18831,
    market_cap_change_24h: -20209251.765811086,
    market_cap_change_percentage_24h: -4.00551,
    circulating_supply: 79995999.94518414,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 22.3,
    ath_change_percentage: -72.92353,
    ath_date: "2022-10-31T10:23:59.455Z",
    atl: 0.111255,
    atl_change_percentage: 5326.31782,
    atl_date: "2019-04-28T00:00:00.000Z",
    roi: {
      times: 19.827587970137973,
      currency: "usd",
      percentage: 1982.7587970137972,
    },
    last_updated: "2023-03-27T23:31:29.009Z",
    price_change_percentage_14d_in_currency: 0.8593528031625284,
    price_change_percentage_1h_in_currency: 0.1672392803069912,
    price_change_percentage_1y_in_currency: -30.38244120792195,
    price_change_percentage_200d_in_currency: 13.351592101698925,
    price_change_percentage_24h_in_currency: -4.1883102252301345,
    price_change_percentage_30d_in_currency: -4.499494011089053,
    price_change_percentage_7d_in_currency: -6.417707331318927,
  },
  {
    id: "tether-gold",
    symbol: "xaut",
    name: "Tether Gold",
    image:
      "https://assets.coingecko.com/coins/images/10481/large/Tether_Gold.png?1668148656",
    current_price: 1963.5,
    market_cap: 484033616,
    market_cap_rank: 90,
    fully_diluted_valuation: 484033616,
    total_volume: 6826080,
    high_24h: 1982.6,
    low_24h: 1956.09,
    price_change_24h: -15.970194868302542,
    price_change_percentage_24h: -0.80679,
    market_cap_change_24h: -4234273.041329801,
    market_cap_change_percentage_24h: -0.8672,
    circulating_supply: 246524.33,
    total_supply: 246524.33,
    max_supply: null,
    ath: 2169.74,
    ath_change_percentage: -9.50845,
    ath_date: "2023-03-15T20:36:21.941Z",
    atl: 1447.84,
    atl_change_percentage: 35.61099,
    atl_date: "2020-03-19T13:45:41.821Z",
    roi: null,
    last_updated: "2023-03-27T23:31:44.296Z",
    price_change_percentage_14d_in_currency: 4.590423716957397,
    price_change_percentage_1h_in_currency: 0.0491722288777985,
    price_change_percentage_1y_in_currency: -0.9693263267866575,
    price_change_percentage_200d_in_currency: 14.793933791072,
    price_change_percentage_24h_in_currency: -0.8067901548073063,
    price_change_percentage_30d_in_currency: 8.461467308163687,
    price_change_percentage_7d_in_currency: -1.659431122576601,
  },
  {
    id: "trust-wallet-token",
    symbol: "twt",
    name: "Trust Wallet",
    image:
      "https://assets.coingecko.com/coins/images/11085/large/Trust.png?1588062702",
    current_price: 1.091,
    market_cap: 462983590,
    market_cap_rank: 91,
    fully_diluted_valuation: null,
    total_volume: 25275536,
    high_24h: 1.19,
    low_24h: 1.091,
    price_change_24h: -0.09745118500406756,
    price_change_percentage_24h: -8.19787,
    market_cap_change_24h: -31697052.611262262,
    market_cap_change_percentage_24h: -6.40758,
    circulating_supply: 416649900,
    total_supply: 1000000000,
    max_supply: null,
    ath: 2.72,
    ath_change_percentage: -59.17237,
    ath_date: "2022-12-11T23:25:46.205Z",
    atl: 0.00277641,
    atl_change_percentage: 39911.45461,
    atl_date: "2020-06-09T09:15:06.983Z",
    roi: null,
    last_updated: "2023-03-27T23:31:48.032Z",
    price_change_percentage_14d_in_currency: -12.362062376660576,
    price_change_percentage_1h_in_currency: -1.7882675681656155,
    price_change_percentage_1y_in_currency: -10.726428473109003,
    price_change_percentage_200d_in_currency: 12.625608496926377,
    price_change_percentage_24h_in_currency: -8.197874203433761,
    price_change_percentage_30d_in_currency: -21.410107407831962,
    price_change_percentage_7d_in_currency: -13.551331055627891,
  },
  {
    id: "flare-networks",
    symbol: "flr",
    name: "Flare",
    image:
      "https://assets.coingecko.com/coins/images/28624/large/FLR-icon200x200.png?1673325704",
    current_price: 0.0376458,
    market_cap: 461484479,
    market_cap_rank: 92,
    fully_diluted_valuation: 3795090655,
    total_volume: 21128528,
    high_24h: 0.03924362,
    low_24h: 0.03320018,
    price_change_24h: 0.0021636,
    price_change_percentage_24h: 6.09771,
    market_cap_change_24h: 27511622,
    market_cap_change_percentage_24h: 6.33948,
    circulating_supply: 12257698511.7175,
    total_supply: 100803123797.456,
    max_supply: null,
    ath: 0.150073,
    ath_change_percentage: -74.86961,
    ath_date: "2023-01-10T03:14:05.921Z",
    atl: 0.0236988,
    atl_change_percentage: 59.13851,
    atl_date: "2023-01-10T04:34:47.390Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.266Z",
    price_change_percentage_14d_in_currency: 14.100183459587882,
    price_change_percentage_1h_in_currency: 2.6165278933734877,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: 6.097710433256704,
    price_change_percentage_30d_in_currency: -5.967521066951983,
    price_change_percentage_7d_in_currency: 20.696688486687307,
  },
  {
    id: "compound-usd-coin",
    symbol: "cusdc",
    name: "cUSDC",
    image:
      "https://assets.coingecko.com/coins/images/9442/large/Compound_USDC.png?1567581577",
    current_price: 0.02279155,
    market_cap: 451080328,
    market_cap_rank: 93,
    fully_diluted_valuation: null,
    total_volume: 0.02177261,
    high_24h: 0.02284318,
    low_24h: 0.02269691,
    price_change_24h: -0.000051624395531427,
    price_change_percentage_24h: -0.22599,
    market_cap_change_24h: 8189853,
    market_cap_change_percentage_24h: 1.84918,
    circulating_supply: 19791555641.6348,
    total_supply: 19791555641.6348,
    max_supply: null,
    ath: 0.058843,
    ath_change_percentage: -61.26745,
    ath_date: "2020-10-21T11:24:27.820Z",
    atl: 0.00620705,
    atl_change_percentage: 267.18794,
    atl_date: "2021-03-04T08:11:37.438Z",
    roi: null,
    last_updated: "2023-03-27T23:31:33.693Z",
    price_change_percentage_14d_in_currency: 1.4040611370265865,
    price_change_percentage_1h_in_currency: -0.1585294464279446,
    price_change_percentage_1y_in_currency: 1.1681911765443647,
    price_change_percentage_200d_in_currency: 0.6383735600191187,
    price_change_percentage_24h_in_currency: -0.22599479165553016,
    price_change_percentage_30d_in_currency: 0.20315642717794927,
    price_change_percentage_7d_in_currency: -0.20692791547323777,
  },
  {
    id: "mask-network",
    symbol: "mask",
    name: "Mask Network",
    image:
      "https://assets.coingecko.com/coins/images/14051/large/Mask_Network.jpg?1614050316",
    current_price: 5.71,
    market_cap: 438151959,
    market_cap_rank: 94,
    fully_diluted_valuation: 575380117,
    total_volume: 124385178,
    high_24h: 6.21,
    low_24h: 5.65,
    price_change_24h: -0.4197318967760948,
    price_change_percentage_24h: -6.84565,
    market_cap_change_24h: -28231637.947822392,
    market_cap_change_percentage_24h: -6.05331,
    circulating_supply: 76150000,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 41.45,
    ath_change_percentage: -86.12136,
    ath_date: "2021-02-24T17:42:44.637Z",
    atl: 0.976528,
    atl_change_percentage: 489.03262,
    atl_date: "2022-10-13T10:36:10.009Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.991Z",
    price_change_percentage_14d_in_currency: 84.44896099623591,
    price_change_percentage_1h_in_currency: -0.9642437871633057,
    price_change_percentage_1y_in_currency: 8.414366224168392,
    price_change_percentage_200d_in_currency: 305.0384344320812,
    price_change_percentage_24h_in_currency: -6.84564881295975,
    price_change_percentage_30d_in_currency: 55.4278631137712,
    price_change_percentage_7d_in_currency: -5.4266150625126865,
  },
  {
    id: "osmosis",
    symbol: "osmo",
    name: "Osmosis",
    image:
      "https://assets.coingecko.com/coins/images/16724/large/osmo.png?1632763885",
    current_price: 0.775258,
    market_cap: 428846816,
    market_cap_rank: 95,
    fully_diluted_valuation: 774153122,
    total_volume: 10506878,
    high_24h: 0.807913,
    low_24h: 0.767471,
    price_change_24h: -0.031445806739103466,
    price_change_percentage_24h: -3.89806,
    market_cap_change_24h: -18430501.8532933,
    market_cap_change_percentage_24h: -4.1206,
    circulating_supply: 553956063,
    total_supply: 325000000,
    max_supply: 1000000000,
    ath: 11.25,
    ath_change_percentage: -93.12169,
    ath_date: "2022-03-04T05:12:18.707Z",
    atl: 0.678606,
    atl_change_percentage: 14.02006,
    atl_date: "2023-01-01T05:30:08.710Z",
    roi: null,
    last_updated: "2023-03-27T23:31:45.876Z",
    price_change_percentage_14d_in_currency: -7.199462100530282,
    price_change_percentage_1h_in_currency: 0.1580351488575722,
    price_change_percentage_1y_in_currency: -90.61615044463129,
    price_change_percentage_200d_in_currency: -36.86402703532629,
    price_change_percentage_24h_in_currency: -3.8980625577505106,
    price_change_percentage_30d_in_currency: -21.240935316764876,
    price_change_percentage_7d_in_currency: -10.090253953066894,
  },
  {
    id: "loopring",
    symbol: "lrc",
    name: "Loopring",
    image:
      "https://assets.coingecko.com/coins/images/913/large/LRC.png?1572852344",
    current_price: 0.343428,
    market_cap: 427148277,
    market_cap_rank: 96,
    fully_diluted_valuation: 471208075,
    total_volume: 56504619,
    high_24h: 0.359564,
    low_24h: 0.331816,
    price_change_24h: -0.01607318365485816,
    price_change_percentage_24h: -4.47097,
    market_cap_change_24h: -20649947.8517586,
    market_cap_change_percentage_24h: -4.61144,
    circulating_supply: 1245991468.94246,
    total_supply: 1373873397.44246,
    max_supply: 1374513896,
    ath: 3.75,
    ath_change_percentage: -90.85778,
    ath_date: "2021-11-10T14:59:53.164Z",
    atl: 0.01963893,
    atl_change_percentage: 1645.60795,
    atl_date: "2019-12-18T13:14:41.553Z",
    roi: {
      times: 4.723796190165634,
      currency: "usd",
      percentage: 472.3796190165633,
    },
    last_updated: "2023-03-27T23:31:51.702Z",
    price_change_percentage_14d_in_currency: 8.876641760524729,
    price_change_percentage_1h_in_currency: 0.7623000836240117,
    price_change_percentage_1y_in_currency: -67.74776125391104,
    price_change_percentage_200d_in_currency: 0.3810947696494566,
    price_change_percentage_24h_in_currency: -4.470971058188466,
    price_change_percentage_30d_in_currency: -8.669246050732017,
    price_change_percentage_7d_in_currency: -4.761119617157877,
  },
  {
    id: "zilliqa",
    symbol: "zil",
    name: "Zilliqa",
    image:
      "https://assets.coingecko.com/coins/images/2687/large/Zilliqa-logo.png?1547036894",
    current_price: 0.02607189,
    market_cap: 424155455,
    market_cap_rank: 97,
    fully_diluted_valuation: 546866949,
    total_volume: 33367873,
    high_24h: 0.02754729,
    low_24h: 0.02550322,
    price_change_24h: -0.001443234118804551,
    price_change_percentage_24h: -5.24524,
    market_cap_change_24h: -23956875.880129695,
    market_cap_change_percentage_24h: -5.34618,
    circulating_supply: 16287809273.0389,
    total_supply: 17336815462.3889,
    max_supply: 21000000000,
    ath: 0.255376,
    ath_change_percentage: -89.80317,
    ath_date: "2021-05-06T17:33:45.940Z",
    atl: 0.00239616,
    atl_change_percentage: 986.74955,
    atl_date: "2020-03-13T02:22:55.161Z",
    roi: {
      times: 0.7932234054698654,
      currency: "eth",
      percentage: 79.32234054698654,
    },
    last_updated: "2023-03-27T23:31:52.198Z",
    price_change_percentage_14d_in_currency: 6.281099276234162,
    price_change_percentage_1h_in_currency: 0.22712327942979424,
    price_change_percentage_1y_in_currency: -71.07805740534245,
    price_change_percentage_200d_in_currency: -25.040597730460902,
    price_change_percentage_24h_in_currency: -5.245239332484294,
    price_change_percentage_30d_in_currency: -22.400088036096758,
    price_change_percentage_7d_in_currency: -11.901435464926134,
  },
  {
    id: "radix",
    symbol: "xrd",
    name: "Radix",
    image:
      "https://assets.coingecko.com/coins/images/4374/large/Radix.png?1629701658",
    current_price: 0.04108183,
    market_cap: 414736974,
    market_cap_rank: 98,
    fully_diluted_valuation: 982191427,
    total_volume: 1110066,
    high_24h: 0.04345124,
    low_24h: 0.03995261,
    price_change_24h: -0.002155208915229683,
    price_change_percentage_24h: -4.98464,
    market_cap_change_24h: -23712527.63030088,
    market_cap_change_percentage_24h: -5.40827,
    circulating_supply: 10134162331.7288,
    total_supply: 12534144491.0795,
    max_supply: 24000000000,
    ath: 0.651264,
    ath_change_percentage: -93.71668,
    ath_date: "2021-11-14T16:09:27.130Z",
    atl: 0.03145312,
    atl_change_percentage: 30.10146,
    atl_date: "2022-11-29T23:20:09.754Z",
    roi: null,
    last_updated: "2023-03-27T23:31:41.406Z",
    price_change_percentage_14d_in_currency: 6.406143658002689,
    price_change_percentage_1h_in_currency: 0.9662274499456124,
    price_change_percentage_1y_in_currency: -72.18908331834933,
    price_change_percentage_200d_in_currency: -29.658594624713892,
    price_change_percentage_24h_in_currency: -4.984635745205259,
    price_change_percentage_30d_in_currency: -10.646937154354614,
    price_change_percentage_7d_in_currency: -6.588356367211038,
  },
  {
    id: "render-token",
    symbol: "rndr",
    name: "Render",
    image:
      "https://assets.coingecko.com/coins/images/11636/large/rndr.png?1638840934",
    current_price: 1.15,
    market_cap: 413951360,
    market_cap_rank: 99,
    fully_diluted_valuation: 608155758,
    total_volume: 31890976,
    high_24h: 1.24,
    low_24h: 1.11,
    price_change_24h: -0.08603752717107693,
    price_change_percentage_24h: -6.98667,
    market_cap_change_24h: -31730025.152928174,
    market_cap_change_percentage_24h: -7.11944,
    circulating_supply: 361444954.108796,
    total_supply: 531016083.388796,
    max_supply: 531016083.388796,
    ath: 8.78,
    ath_change_percentage: -86.96044,
    ath_date: "2021-11-21T10:03:19.097Z",
    atl: 0.03665669,
    atl_change_percentage: 3024.3026,
    atl_date: "2020-06-16T13:22:25.900Z",
    roi: null,
    last_updated: "2023-03-27T23:31:42.178Z",
    price_change_percentage_14d_in_currency: -8.630558158845487,
    price_change_percentage_1h_in_currency: 0.025067383868755372,
    price_change_percentage_1y_in_currency: -57.651371776668846,
    price_change_percentage_200d_in_currency: 125.73284703324457,
    price_change_percentage_24h_in_currency: -6.986674516176465,
    price_change_percentage_30d_in_currency: -21.065546197955417,
    price_change_percentage_7d_in_currency: -22.819970271659685,
  },
  {
    id: "1inch",
    symbol: "1inch",
    name: "1inch",
    image:
      "https://assets.coingecko.com/coins/images/13469/large/1inch-token.png?1608803028",
    current_price: 0.489926,
    market_cap: 408921399,
    market_cap_rank: 100,
    fully_diluted_valuation: 734766714,
    total_volume: 29404407,
    high_24h: 0.516374,
    low_24h: 0.483854,
    price_change_24h: -0.02578892409911676,
    price_change_percentage_24h: -5.00061,
    market_cap_change_24h: -22041193.412434578,
    market_cap_change_percentage_24h: -5.11441,
    circulating_supply: 834798429.163766,
    total_supply: 1500000000,
    max_supply: 1500000000,
    ath: 8.65,
    ath_change_percentage: -94.33763,
    ath_date: "2021-10-27T08:24:54.808Z",
    atl: 0.37369,
    atl_change_percentage: 31.0946,
    atl_date: "2022-12-30T12:35:04.113Z",
    roi: null,
    last_updated: "2023-03-27T23:31:46.177Z",
    price_change_percentage_14d_in_currency: 2.873704629436687,
    price_change_percentage_1h_in_currency: -0.19501265510362403,
    price_change_percentage_1y_in_currency: -69.91319810091767,
    price_change_percentage_200d_in_currency: -22.631632463377528,
    price_change_percentage_24h_in_currency: -5.000614121988998,
    price_change_percentage_30d_in_currency: -18.469733752071,
    price_change_percentage_7d_in_currency: -12.109064629056995,
  },
  {
    id: "nexo",
    symbol: "nexo",
    name: "NEXO",
    image:
      "https://assets.coingecko.com/coins/images/3695/large/nexo.png?1548086057",
    current_price: 0.722729,
    market_cap: 405039236,
    market_cap_rank: 101,
    fully_diluted_valuation: 723284337,
    total_volume: 7619054,
    high_24h: 0.765847,
    low_24h: 0.7012,
    price_change_24h: -0.03475186327884516,
    price_change_percentage_24h: -4.58782,
    market_cap_change_24h: -19366428.553729534,
    market_cap_change_percentage_24h: -4.56319,
    circulating_supply: 560000010.0064,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 4.07,
    ath_change_percentage: -82.20635,
    ath_date: "2021-05-12T14:37:47.535Z",
    atl: 0.04515276,
    atl_change_percentage: 1503.09235,
    atl_date: "2018-09-13T00:00:00.000Z",
    roi: {
      times: 6.227287242525278,
      currency: "usd",
      percentage: 622.7287242525279,
    },
    last_updated: "2023-03-27T23:31:56.858Z",
    price_change_percentage_14d_in_currency: 18.227654064768018,
    price_change_percentage_1h_in_currency: -0.6029495644129228,
    price_change_percentage_1y_in_currency: -68.8133427963375,
    price_change_percentage_200d_in_currency: -19.933977196517734,
    price_change_percentage_24h_in_currency: -4.58782229549953,
    price_change_percentage_30d_in_currency: 0.6240522803739584,
    price_change_percentage_7d_in_currency: 11.589682099814983,
  },
  {
    id: "thorchain",
    symbol: "rune",
    name: "THORChain",
    image:
      "https://assets.coingecko.com/coins/images/6595/large/Rune200x200.png?1671179394",
    current_price: 1.34,
    market_cap: 401800110,
    market_cap_rank: 102,
    fully_diluted_valuation: 668106684,
    total_volume: 61669009,
    high_24h: 1.42,
    low_24h: 1.32,
    price_change_24h: -0.07731080813139135,
    price_change_percentage_24h: -5.45742,
    market_cap_change_24h: -24911492.69248575,
    market_cap_change_percentage_24h: -5.83802,
    circulating_supply: 300700561,
    total_supply: 500000000,
    max_supply: 500000000,
    ath: 20.87,
    ath_change_percentage: -93.6185,
    ath_date: "2021-05-19T00:30:09.436Z",
    atl: 0.00851264,
    atl_change_percentage: 15543.37945,
    atl_date: "2019-09-28T00:00:00.000Z",
    roi: {
      times: 34.24494366818573,
      currency: "usd",
      percentage: 3424.494366818574,
    },
    last_updated: "2023-03-27T23:31:52.596Z",
    price_change_percentage_14d_in_currency: -0.07314421045774269,
    price_change_percentage_1h_in_currency: 0.6145269296590113,
    price_change_percentage_1y_in_currency: -87.26074771067464,
    price_change_percentage_200d_in_currency: -27.074476403355074,
    price_change_percentage_24h_in_currency: -5.457418422037431,
    price_change_percentage_30d_in_currency: -18.500777961453714,
    price_change_percentage_7d_in_currency: -8.315253363511825,
  },
  {
    id: "cdai",
    symbol: "cdai",
    name: "cDAI",
    image:
      "https://assets.coingecko.com/coins/images/9281/large/cDAI.png?1576467585",
    current_price: 0.02219092,
    market_cap: 400011285,
    market_cap_rank: 103,
    fully_diluted_valuation: 400011285,
    total_volume: 2841.09,
    high_24h: 0.02224678,
    low_24h: 0.02198535,
    price_change_24h: -0.000049394072202745,
    price_change_percentage_24h: -0.22209,
    market_cap_change_24h: -10017657.58601284,
    market_cap_change_percentage_24h: -2.44316,
    circulating_supply: 18025899170.0291,
    total_supply: 18025899170.0291,
    max_supply: null,
    ath: 0.03159087,
    ath_change_percentage: -29.75527,
    ath_date: "2020-10-12T21:29:00.007Z",
    atl: 0.00728854,
    atl_change_percentage: 204.46301,
    atl_date: "2020-03-18T04:29:40.819Z",
    roi: null,
    last_updated: "2023-03-27T23:31:33.080Z",
    price_change_percentage_14d_in_currency: 1.279753906391135,
    price_change_percentage_1h_in_currency: -0.08294842452008902,
    price_change_percentage_1y_in_currency: 1.3202764179874076,
    price_change_percentage_200d_in_currency: 0.5435024074277405,
    price_change_percentage_24h_in_currency: -0.22209251298489127,
    price_change_percentage_30d_in_currency: 0.05437986410121359,
    price_change_percentage_7d_in_currency: -0.18332226301253807,
  },
  {
    id: "rocket-pool-eth",
    symbol: "reth",
    name: "Rocket Pool ETH",
    image:
      "https://assets.coingecko.com/coins/images/20764/large/reth.png?1637652366",
    current_price: 1834.25,
    market_cap: 396805121,
    market_cap_rank: 104,
    fully_diluted_valuation: null,
    total_volume: 1570913,
    high_24h: 1907.72,
    low_24h: 1818.28,
    price_change_24h: -72.10669636601756,
    price_change_percentage_24h: -3.78243,
    market_cap_change_24h: -15246954.789853275,
    market_cap_change_percentage_24h: -3.70025,
    circulating_supply: 216429.765808773,
    total_supply: 216429.765808773,
    max_supply: null,
    ath: 4814.31,
    ath_change_percentage: -61.92402,
    ath_date: "2021-12-01T08:03:50.749Z",
    atl: 887.26,
    atl_change_percentage: 106.60104,
    atl_date: "2022-06-18T20:55:45.957Z",
    roi: null,
    last_updated: "2023-03-27T23:31:47.761Z",
    price_change_percentage_14d_in_currency: 8.412077415222367,
    price_change_percentage_1h_in_currency: 0.11140594698280618,
    price_change_percentage_1y_in_currency: -42.85994052229122,
    price_change_percentage_200d_in_currency: 10.05613168811681,
    price_change_percentage_24h_in_currency: -3.782433690972594,
    price_change_percentage_30d_in_currency: 6.473264886574108,
    price_change_percentage_7d_in_currency: -5.096442176097823,
  },
  {
    id: "gemini-dollar",
    symbol: "gusd",
    name: "Gemini Dollar",
    image:
      "https://assets.coingecko.com/coins/images/5992/large/gemini-dollar-gusd.png?1536745278",
    current_price: 1.002,
    market_cap: 393366469,
    market_cap_rank: 105,
    fully_diluted_valuation: 393366469,
    total_volume: 596307,
    high_24h: 1.005,
    low_24h: 0.988474,
    price_change_24h: -0.000245165885088827,
    price_change_percentage_24h: -0.02447,
    market_cap_change_24h: -1334484.3021956682,
    market_cap_change_percentage_24h: -0.3381,
    circulating_supply: 392683074.37,
    total_supply: 392683074.37,
    max_supply: null,
    ath: 3.3,
    ath_change_percentage: -69.68088,
    ath_date: "2018-10-11T17:36:21.529Z",
    atl: 0.78261,
    atl_change_percentage: 27.99514,
    atl_date: "2018-09-29T00:00:00.000Z",
    roi: {
      times: 0.001740319961508,
      currency: "usd",
      percentage: 0.1740319961508,
    },
    last_updated: "2023-03-27T23:31:49.055Z",
    price_change_percentage_14d_in_currency: 0.44750144444705026,
    price_change_percentage_1h_in_currency: 0.13387781603512386,
    price_change_percentage_1y_in_currency: 0.24980473713356305,
    price_change_percentage_200d_in_currency: 1.5823706855581314,
    price_change_percentage_24h_in_currency: -0.024468007626046787,
    price_change_percentage_30d_in_currency: 0.024247510337509506,
    price_change_percentage_7d_in_currency: 0.2469960991656928,
  },
  {
    id: "arweave",
    symbol: "ar",
    name: "Arweave",
    image:
      "https://assets.coingecko.com/coins/images/4343/large/oRt6SiEN_400x400.jpg?1591059616",
    current_price: 7.8,
    market_cap: 390405947,
    market_cap_rank: 106,
    fully_diluted_valuation: 514219972,
    total_volume: 15866213,
    high_24h: 8.31,
    low_24h: 7.65,
    price_change_24h: -0.5098885293343018,
    price_change_percentage_24h: -6.13938,
    market_cap_change_24h: -25882451.217158675,
    market_cap_change_percentage_24h: -6.21743,
    circulating_supply: 50108502,
    total_supply: 64598643,
    max_supply: 66000000,
    ath: 89.24,
    ath_change_percentage: -91.26582,
    ath_date: "2021-11-05T04:14:42.689Z",
    atl: 0.298788,
    atl_change_percentage: 2508.52784,
    atl_date: "2020-01-31T06:47:36.543Z",
    roi: {
      times: 9.534229285741683,
      currency: "usd",
      percentage: 953.4229285741683,
    },
    last_updated: "2023-03-27T23:31:57.962Z",
    price_change_percentage_14d_in_currency: -5.378310262072109,
    price_change_percentage_1h_in_currency: 0.0057548126468071085,
    price_change_percentage_1y_in_currency: -77.93741555330637,
    price_change_percentage_200d_in_currency: -20.02521006882358,
    price_change_percentage_24h_in_currency: -6.13937547464101,
    price_change_percentage_30d_in_currency: -23.948861038241027,
    price_change_percentage_7d_in_currency: -14.642318063443582,
  },
  {
    id: "oec-token",
    symbol: "okt",
    name: "OKC Token",
    image:
      "https://assets.coingecko.com/coins/images/13708/large/WeChat_Image_20220118095654.png?1642471094",
    current_price: 21.83,
    market_cap: 388790969,
    market_cap_rank: 107,
    fully_diluted_valuation: 457465723,
    total_volume: 2991325,
    high_24h: 22.59,
    low_24h: 21.51,
    price_change_24h: -0.7632629604784036,
    price_change_percentage_24h: -3.37848,
    market_cap_change_24h: -11834512.98232609,
    market_cap_change_percentage_24h: -2.95401,
    circulating_supply: 17847480,
    total_supply: 17847259.5,
    max_supply: 21000000,
    ath: 250.53,
    ath_change_percentage: -91.30493,
    ath_date: "2021-05-10T03:09:56.045Z",
    atl: 13.02,
    atl_change_percentage: 67.26671,
    atl_date: "2022-07-13T00:38:46.306Z",
    roi: null,
    last_updated: "2023-03-27T23:31:44.195Z",
    price_change_percentage_14d_in_currency: -4.885849247954715,
    price_change_percentage_1h_in_currency: 0.0690350147498221,
    price_change_percentage_1y_in_currency: -38.557940326191364,
    price_change_percentage_200d_in_currency: 27.934193834204606,
    price_change_percentage_24h_in_currency: -3.3784810650535033,
    price_change_percentage_30d_in_currency: -33.0102234501647,
    price_change_percentage_7d_in_currency: -10.714837498543773,
  },
  {
    id: "btse-token",
    symbol: "btse",
    name: "BTSE Token",
    image:
      "https://assets.coingecko.com/coins/images/10807/large/BTSE_logo_Square.jpeg?1583965964",
    current_price: 2.37,
    market_cap: 384390326,
    market_cap_rank: 108,
    fully_diluted_valuation: 474375868,
    total_volume: 674581,
    high_24h: 2.4,
    low_24h: 2.33,
    price_change_24h: 0.01595062,
    price_change_percentage_24h: 0.67702,
    market_cap_change_24h: 2845057,
    market_cap_change_percentage_24h: 0.74567,
    circulating_supply: 162061501,
    total_supply: 200000000,
    max_supply: 200000000,
    ath: 9.21,
    ath_change_percentage: -74.27791,
    ath_date: "2022-03-23T09:11:07.549Z",
    atl: 0.631269,
    atl_change_percentage: 275.46428,
    atl_date: "2020-12-13T14:22:21.597Z",
    roi: {
      times: 0.1859839041827215,
      currency: "usd",
      percentage: 18.59839041827215,
    },
    last_updated: "2023-03-27T23:31:40.415Z",
    price_change_percentage_14d_in_currency: 3.4093020467402058,
    price_change_percentage_1h_in_currency: -0.2586620025364996,
    price_change_percentage_1y_in_currency: -69.14270355823197,
    price_change_percentage_200d_in_currency: -45.27243830033744,
    price_change_percentage_24h_in_currency: 0.6770162264681525,
    price_change_percentage_30d_in_currency: -1.5815980068239022,
    price_change_percentage_7d_in_currency: -1.4717242150107426,
  },
  {
    id: "kava",
    symbol: "kava",
    name: "Kava",
    image:
      "https://assets.coingecko.com/coins/images/9761/large/kava.png?1663638871",
    current_price: 0.838345,
    market_cap: 383266797,
    market_cap_rank: 109,
    fully_diluted_valuation: null,
    total_volume: 19921409,
    high_24h: 0.872228,
    low_24h: 0.811068,
    price_change_24h: -0.029366356566263407,
    price_change_percentage_24h: -3.38435,
    market_cap_change_24h: -13018319.006919205,
    market_cap_change_percentage_24h: -3.28509,
    circulating_supply: 457555286,
    total_supply: 457513049,
    max_supply: null,
    ath: 9.12,
    ath_change_percentage: -90.83661,
    ath_date: "2021-08-30T11:10:02.948Z",
    atl: 0.287137,
    atl_change_percentage: 191.05394,
    atl_date: "2020-03-13T02:24:16.835Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.655Z",
    price_change_percentage_14d_in_currency: -16.097088468137247,
    price_change_percentage_1h_in_currency: 0.34876146550794923,
    price_change_percentage_1y_in_currency: -78.37507456840646,
    price_change_percentage_200d_in_currency: -47.21110323851999,
    price_change_percentage_24h_in_currency: -3.384347796171286,
    price_change_percentage_30d_in_currency: -4.9232142918506385,
    price_change_percentage_7d_in_currency: -16.09813913532952,
  },
  {
    id: "kaspa",
    symbol: "kas",
    name: "Kaspa",
    image:
      "https://assets.coingecko.com/coins/images/25751/large/kaspa-icon-exchanges.png?1653891958",
    current_price: 0.02165179,
    market_cap: 380046734,
    market_cap_rank: 110,
    fully_diluted_valuation: null,
    total_volume: 8157284,
    high_24h: 0.02180913,
    low_24h: 0.01805318,
    price_change_24h: 0.00340988,
    price_change_percentage_24h: 18.69257,
    market_cap_change_24h: 60237038,
    market_cap_change_percentage_24h: 18.83528,
    circulating_supply: 17552671882,
    total_supply: 17551940194,
    max_supply: null,
    ath: 0.02180913,
    ath_change_percentage: -1.28224,
    ath_date: "2023-03-27T23:04:55.645Z",
    atl: 0.00017105,
    atl_change_percentage: 12486.68959,
    atl_date: "2022-05-26T14:42:59.316Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.075Z",
    price_change_percentage_14d_in_currency: 78.60685962224483,
    price_change_percentage_1h_in_currency: 1.518300784649634,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: 526.6381886604793,
    price_change_percentage_24h_in_currency: 18.69256984580535,
    price_change_percentage_30d_in_currency: 177.91156129658745,
    price_change_percentage_7d_in_currency: 30.442973393804102,
  },
  {
    id: "zcash",
    symbol: "zec",
    name: "Zcash",
    image:
      "https://assets.coingecko.com/coins/images/486/large/circle-zcash-color.png?1547034197",
    current_price: 35.65,
    market_cap: 376126815,
    market_cap_rank: 111,
    fully_diluted_valuation: 747732349,
    total_volume: 43685296,
    high_24h: 37.4,
    low_24h: 34.88,
    price_change_24h: -0.7423929950920183,
    price_change_percentage_24h: -2.03987,
    market_cap_change_24h: -10774573.961022377,
    market_cap_change_percentage_24h: -2.78484,
    circulating_supply: 10563489.890646,
    total_supply: 21000000,
    max_supply: 21000000,
    ath: 3191.93,
    ath_change_percentage: -98.88378,
    ath_date: "2016-10-29T00:00:00.000Z",
    atl: 19.75,
    atl_change_percentage: 80.3664,
    atl_date: "2020-03-13T02:20:55.002Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.280Z",
    price_change_percentage_14d_in_currency: 3.768731298914814,
    price_change_percentage_1h_in_currency: 0.06197751756895853,
    price_change_percentage_1y_in_currency: -82.62227680924521,
    price_change_percentage_200d_in_currency: -40.138756150425095,
    price_change_percentage_24h_in_currency: -2.0398739722376513,
    price_change_percentage_30d_in_currency: -21.156576286893184,
    price_change_percentage_7d_in_currency: -3.308487921867275,
  },
  {
    id: "convex-finance",
    symbol: "cvx",
    name: "Convex Finance",
    image:
      "https://assets.coingecko.com/coins/images/15585/large/convex.png?1621256328",
    current_price: 4.94,
    market_cap: 374187501,
    market_cap_rank: 112,
    fully_diluted_valuation: 493547308,
    total_volume: 2775108,
    high_24h: 5.16,
    low_24h: 4.87,
    price_change_24h: -0.2204338079170043,
    price_change_percentage_24h: -4.27536,
    market_cap_change_24h: -16655227.717471063,
    market_cap_change_percentage_24h: -4.26136,
    circulating_supply: 75815933.92520395,
    total_supply: 97765247.782599,
    max_supply: 100000000,
    ath: 60.09,
    ath_change_percentage: -91.798,
    ath_date: "2022-01-01T18:04:03.030Z",
    atl: 1.9,
    atl_change_percentage: 158.99652,
    atl_date: "2021-07-20T13:17:29.183Z",
    roi: null,
    last_updated: "2023-03-27T23:31:41.784Z",
    price_change_percentage_14d_in_currency: -8.856648694065699,
    price_change_percentage_1h_in_currency: 0.22685248692620227,
    price_change_percentage_1y_in_currency: -82.18874151004155,
    price_change_percentage_200d_in_currency: -7.905069551304006,
    price_change_percentage_24h_in_currency: -4.275364405219266,
    price_change_percentage_30d_in_currency: -14.835940124813431,
    price_change_percentage_7d_in_currency: -13.618180189893176,
  },
  {
    id: "casper-network",
    symbol: "cspr",
    name: "Casper Network",
    image:
      "https://assets.coingecko.com/coins/images/15279/large/casper.PNG?1620341020",
    current_price: 0.0342581,
    market_cap: 371796825,
    market_cap_rank: 114,
    fully_diluted_valuation: 397277932,
    total_volume: 6207915,
    high_24h: 0.03597644,
    low_24h: 0.03375083,
    price_change_24h: -0.001185120531115372,
    price_change_percentage_24h: -3.34372,
    market_cap_change_24h: -11877535.385003984,
    market_cap_change_percentage_24h: -3.09573,
    circulating_supply: 10854185120,
    total_supply: 11598077023,
    max_supply: null,
    ath: 1.33,
    ath_change_percentage: -97.4191,
    ath_date: "2021-05-12T00:00:00.000Z",
    atl: 0.02241297,
    atl_change_percentage: 52.62807,
    atl_date: "2022-06-18T20:14:44.694Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.219Z",
    price_change_percentage_14d_in_currency: -7.326687542330468,
    price_change_percentage_1h_in_currency: -0.6106376687936634,
    price_change_percentage_1y_in_currency: -53.26453848865037,
    price_change_percentage_200d_in_currency: 28.6480522001716,
    price_change_percentage_24h_in_currency: -3.343715405891597,
    price_change_percentage_30d_in_currency: -9.096897643547054,
    price_change_percentage_7d_in_currency: -9.072131800782344,
  },
  {
    id: "enjincoin",
    symbol: "enj",
    name: "Enjin Coin",
    image:
      "https://assets.coingecko.com/coins/images/1102/large/enjin-coin-logo.png?1547035078",
    current_price: 0.370368,
    market_cap: 370378121,
    market_cap_rank: 115,
    fully_diluted_valuation: 370378121,
    total_volume: 22537962,
    high_24h: 0.393191,
    low_24h: 0.362843,
    price_change_24h: -0.02233483490064886,
    price_change_percentage_24h: -5.68746,
    market_cap_change_24h: -22031385.18188131,
    market_cap_change_percentage_24h: -5.61439,
    circulating_supply: 1000000000,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 4.82,
    ath_change_percentage: -92.32093,
    ath_date: "2021-11-25T09:53:41.955Z",
    atl: 0.01865964,
    atl_change_percentage: 1883.31653,
    atl_date: "2017-11-12T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.551Z",
    price_change_percentage_14d_in_currency: -3.9587500366669652,
    price_change_percentage_1h_in_currency: 0.34277040826488536,
    price_change_percentage_1y_in_currency: -77.58621059853024,
    price_change_percentage_200d_in_currency: -29.122507672749688,
    price_change_percentage_24h_in_currency: -5.687458884877745,
    price_change_percentage_30d_in_currency: -26.073635599166806,
    price_change_percentage_7d_in_currency: -13.121722324229482,
  },
  {
    id: "dydx",
    symbol: "dydx",
    name: "dYdX",
    image:
      "https://assets.coingecko.com/coins/images/17500/large/hjnIm9bV.jpg?1628009360",
    current_price: 2.39,
    market_cap: 370168209,
    market_cap_rank: 113,
    fully_diluted_valuation: 2387579650,
    total_volume: 136199445,
    high_24h: 2.42,
    low_24h: 2.17,
    price_change_24h: -0.006845960460242663,
    price_change_percentage_24h: -0.28591,
    market_cap_change_24h: 2291119,
    market_cap_change_percentage_24h: 0.62279,
    circulating_supply: 155039103.55365175,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 27.86,
    ath_change_percentage: -91.43706,
    ath_date: "2021-09-30T01:23:43.570Z",
    atl: 1.011,
    atl_change_percentage: 136.06455,
    atl_date: "2022-06-18T20:55:50.603Z",
    roi: null,
    last_updated: "2023-03-27T23:31:41.009Z",
    price_change_percentage_14d_in_currency: 5.752847686398907,
    price_change_percentage_1h_in_currency: -0.7150670202067454,
    price_change_percentage_1y_in_currency: -55.8150036737592,
    price_change_percentage_200d_in_currency: 64.61272358440871,
    price_change_percentage_24h_in_currency: -0.28591243058718957,
    price_change_percentage_30d_in_currency: -10.309245691065572,
    price_change_percentage_7d_in_currency: -14.387936121786094,
  },
  {
    id: "fetch-ai",
    symbol: "fet",
    name: "Fetch.ai",
    image:
      "https://assets.coingecko.com/coins/images/5681/large/Fetch.jpg?1572098136",
    current_price: 0.347785,
    market_cap: 362900315,
    market_cap_rank: 116,
    fully_diluted_valuation: 400994823,
    total_volume: 59027679,
    high_24h: 0.376252,
    low_24h: 0.337735,
    price_change_24h: -0.028042025957437156,
    price_change_percentage_24h: -7.46143,
    market_cap_change_24h: -29519926.159059823,
    market_cap_change_percentage_24h: -7.52253,
    circulating_supply: 1043462805,
    total_supply: 1152997575,
    max_supply: 1152997575,
    ath: 1.17,
    ath_change_percentage: -70.30555,
    ath_date: "2021-09-08T02:24:24.858Z",
    atl: 0.00816959,
    atl_change_percentage: 4159.91399,
    atl_date: "2020-03-13T02:24:18.347Z",
    roi: {
      times: 3.011356625539114,
      currency: "usd",
      percentage: 301.1356625539114,
    },
    last_updated: "2023-03-27T23:31:51.470Z",
    price_change_percentage_14d_in_currency: -9.185185748058629,
    price_change_percentage_1h_in_currency: 0.19543921265978062,
    price_change_percentage_1y_in_currency: -19.501703262366092,
    price_change_percentage_200d_in_currency: 256.5914329595081,
    price_change_percentage_24h_in_currency: -7.4614257134994695,
    price_change_percentage_30d_in_currency: -26.84001754725867,
    price_change_percentage_7d_in_currency: -18.26717076131759,
  },
  {
    id: "defichain",
    symbol: "dfi",
    name: "DeFiChain",
    image:
      "https://assets.coingecko.com/coins/images/11757/large/symbol-defi-blockchain_200.png?1597306538",
    current_price: 0.532491,
    market_cap: 362059836,
    market_cap_rank: 117,
    fully_diluted_valuation: null,
    total_volume: 4821561,
    high_24h: 0.555324,
    low_24h: 0.529729,
    price_change_24h: -0.02207708008446374,
    price_change_percentage_24h: -3.98095,
    market_cap_change_24h: -14750243.43260926,
    market_cap_change_percentage_24h: -3.9145,
    circulating_supply: 679936932.05802,
    total_supply: 1200000000,
    max_supply: null,
    ath: 5.61,
    ath_change_percentage: -90.51767,
    ath_date: "2021-12-06T03:05:01.038Z",
    atl: 0.162998,
    atl_change_percentage: 226.54669,
    atl_date: "2020-07-16T10:24:06.014Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.954Z",
    price_change_percentage_14d_in_currency: 6.460895210371752,
    price_change_percentage_1h_in_currency: -0.046403887645490624,
    price_change_percentage_1y_in_currency: -87.55661953345586,
    price_change_percentage_200d_in_currency: -47.416879898836505,
    price_change_percentage_24h_in_currency: -3.9809507362143433,
    price_change_percentage_30d_in_currency: -7.516807182954343,
    price_change_percentage_7d_in_currency: -10.369817764599553,
  },
  {
    id: "ethereum-pow-iou",
    symbol: "ethw",
    name: "EthereumPoW",
    image:
      "https://assets.coingecko.com/coins/images/26997/large/logo-clear.png?1661311105",
    current_price: 3.3,
    market_cap: 355859161,
    market_cap_rank: 118,
    fully_diluted_valuation: 355858415,
    total_volume: 5998211,
    high_24h: 3.39,
    low_24h: 3.24,
    price_change_24h: -0.08344161368002068,
    price_change_percentage_24h: -2.46582,
    market_cap_change_24h: -9052890.8283239,
    market_cap_change_percentage_24h: -2.48084,
    circulating_supply: 107818943.04993,
    total_supply: 107818717.04993,
    max_supply: null,
    ath: 58.54,
    ath_change_percentage: -94.36217,
    ath_date: "2022-09-03T00:10:33.722Z",
    atl: 2.87,
    atl_change_percentage: 14.80793,
    atl_date: "2022-12-19T23:25:23.177Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.080Z",
    price_change_percentage_14d_in_currency: -1.7692937029906166,
    price_change_percentage_1h_in_currency: -0.21222105682116027,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: -90.37806424601544,
    price_change_percentage_24h_in_currency: -2.4658188477596203,
    price_change_percentage_30d_in_currency: -9.581277415782063,
    price_change_percentage_7d_in_currency: -4.703368949776068,
  },
  {
    id: "basic-attention-token",
    symbol: "bat",
    name: "Basic Attention",
    image:
      "https://assets.coingecko.com/coins/images/677/large/basic-attention-token.png?1547034427",
    current_price: 0.236523,
    market_cap: 351464016,
    market_cap_rank: 119,
    fully_diluted_valuation: 354783955,
    total_volume: 39175049,
    high_24h: 0.248845,
    low_24h: 0.233953,
    price_change_24h: -0.01220215112377862,
    price_change_percentage_24h: -4.90588,
    market_cap_change_24h: -17726016.260309637,
    market_cap_change_percentage_24h: -4.80133,
    circulating_supply: 1485963548.4163349,
    total_supply: 1500000000,
    max_supply: 1500000000,
    ath: 1.9,
    ath_change_percentage: -87.60776,
    ath_date: "2021-11-28T00:23:51.354Z",
    atl: 0.072394,
    atl_change_percentage: 225.33381,
    atl_date: "2017-07-16T00:00:00.000Z",
    roi: {
      times: -0.11814233687926592,
      currency: "eth",
      percentage: -11.814233687926592,
    },
    last_updated: "2023-03-27T23:31:34.124Z",
    price_change_percentage_14d_in_currency: 4.9289483396292795,
    price_change_percentage_1h_in_currency: 0.18681904714140027,
    price_change_percentage_1y_in_currency: -72.31523051668923,
    price_change_percentage_200d_in_currency: -27.37944808516854,
    price_change_percentage_24h_in_currency: -4.905879087806811,
    price_change_percentage_30d_in_currency: -21.28799842798213,
    price_change_percentage_7d_in_currency: -8.529515586478698,
  },
  {
    id: "wemix-token",
    symbol: "wemix",
    name: "WEMIX",
    image:
      "https://assets.coingecko.com/coins/images/12998/large/wemixcoin_color_200.png?1666768971",
    current_price: 1.42,
    market_cap: 348449438,
    market_cap_rank: 120,
    fully_diluted_valuation: 1362484381,
    total_volume: 4996937,
    high_24h: 1.47,
    low_24h: 1.33,
    price_change_24h: 0.02046333,
    price_change_percentage_24h: 1.46392,
    market_cap_change_24h: 4682540,
    market_cap_change_percentage_24h: 1.36213,
    circulating_supply: 245651961.762414,
    total_supply: 960532358.742231,
    max_supply: null,
    ath: 24.71,
    ath_change_percentage: -94.26005,
    ath_date: "2021-11-21T17:33:44.178Z",
    atl: 0.128398,
    atl_change_percentage: 1004.72321,
    atl_date: "2021-06-22T12:52:49.089Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.779Z",
    price_change_percentage_14d_in_currency: -14.616954665397591,
    price_change_percentage_1h_in_currency: -0.6245403911503811,
    price_change_percentage_1y_in_currency: -70.03545512132663,
    price_change_percentage_200d_in_currency: -29.103554040505884,
    price_change_percentage_24h_in_currency: 1.4639233438961805,
    price_change_percentage_30d_in_currency: -41.526011690235435,
    price_change_percentage_7d_in_currency: -12.8046793843816,
  },
  {
    id: "baby-doge-coin",
    symbol: "babydoge",
    name: "Baby Doge Coin",
    image:
      "https://assets.coingecko.com/coins/images/16125/large/babydoge.jpg?1676303229",
    current_price: 2.192e-9,
    market_cap: 343380222,
    market_cap_rank: 121,
    fully_diluted_valuation: 923745885,
    total_volume: 5873330,
    high_24h: 2.467e-9,
    low_24h: 2.156e-9,
    price_change_24h: -2.3122528e-11,
    price_change_percentage_24h: -1.0437,
    market_cap_change_24h: -2720556.5535348654,
    market_cap_change_percentage_24h: -0.78606,
    circulating_supply: 156124856092293500,
    total_supply: 420000000000000000,
    max_supply: 420000000000000000,
    ath: 6.345e-9,
    ath_change_percentage: -65.45945,
    ath_date: "2022-01-16T20:24:43.758Z",
    atl: 9.4771e-11,
    atl_change_percentage: 2212.42708,
    atl_date: "2021-06-09T02:48:21.787Z",
    roi: null,
    last_updated: "2023-03-27T23:31:44.501Z",
    price_change_percentage_14d_in_currency: -1.0650656383080608,
    price_change_percentage_1h_in_currency: -0.6797049080771136,
    price_change_percentage_1y_in_currency: -30.65560479175054,
    price_change_percentage_200d_in_currency: 82.66665644283245,
    price_change_percentage_24h_in_currency: -1.0436979307762753,
    price_change_percentage_30d_in_currency: -18.8354126156489,
    price_change_percentage_7d_in_currency: -6.451676359832733,
  },
  {
    id: "nem",
    symbol: "xem",
    name: "NEM",
    image:
      "https://assets.coingecko.com/coins/images/242/large/NEM_WC_Logo_200px.png?1642668663",
    current_price: 0.03743992,
    market_cap: 336528652,
    market_cap_rank: 122,
    fully_diluted_valuation: null,
    total_volume: 10057238,
    high_24h: 0.03992445,
    low_24h: 0.03659221,
    price_change_24h: -0.002282949918909545,
    price_change_percentage_24h: -5.74719,
    market_cap_change_24h: -20223362.733616948,
    market_cap_change_percentage_24h: -5.66875,
    circulating_supply: 8999999999,
    total_supply: 8999999999,
    max_supply: null,
    ath: 1.87,
    ath_change_percentage: -97.9985,
    ath_date: "2018-01-07T00:00:00.000Z",
    atl: 0.00008482,
    atl_change_percentage: 43993.62683,
    atl_date: "2015-09-05T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.729Z",
    price_change_percentage_14d_in_currency: 2.3555991073697222,
    price_change_percentage_1h_in_currency: 0.18861676012836068,
    price_change_percentage_1y_in_currency: -65.46444026543614,
    price_change_percentage_200d_in_currency: -12.171150344610048,
    price_change_percentage_24h_in_currency: -5.747192782335013,
    price_change_percentage_30d_in_currency: -9.405159621918386,
    price_change_percentage_7d_in_currency: -10.594103879223988,
  },
  {
    id: "floki",
    symbol: "floki",
    name: "FLOKI",
    image:
      "https://assets.coingecko.com/coins/images/16746/large/PNG_image.png?1643184642",
    current_price: 0.00003377,
    market_cap: 330638392,
    market_cap_rank: 123,
    fully_diluted_valuation: null,
    total_volume: 27591876,
    high_24h: 0.00003636,
    low_24h: 0.00003274,
    price_change_24h: -0.000002560345459738,
    price_change_percentage_24h: -7.04662,
    market_cap_change_24h: -24946074.926395774,
    market_cap_change_percentage_24h: -7.01551,
    circulating_supply: 9784136561995.39,
    total_supply: 10000000000000,
    max_supply: null,
    ath: 0.00033651,
    ath_change_percentage: -89.95155,
    ath_date: "2021-11-04T06:58:35.285Z",
    atl: 8.428e-8,
    atl_change_percentage: 40020.74295,
    atl_date: "2021-07-06T01:11:20.438Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.015Z",
    price_change_percentage_14d_in_currency: -6.269996824509691,
    price_change_percentage_1h_in_currency: 0.8895882834072886,
    price_change_percentage_1y_in_currency: -3.9681149612286193,
    price_change_percentage_200d_in_currency: 267.04773389562854,
    price_change_percentage_24h_in_currency: -7.046617851787978,
    price_change_percentage_30d_in_currency: -28.211128023222187,
    price_change_percentage_7d_in_currency: -13.165769470157068,
  },
  {
    id: "ethereum-name-service",
    symbol: "ens",
    name: "Ethereum Name Service",
    image:
      "https://assets.coingecko.com/coins/images/19785/large/acatxTm8_400x400.jpg?1635850140",
    current_price: 12.67,
    market_cap: 326741830,
    market_cap_rank: 124,
    fully_diluted_valuation: 1267264761,
    total_volume: 32988877,
    high_24h: 13.34,
    low_24h: 12.37,
    price_change_24h: -0.6647885429777958,
    price_change_percentage_24h: -4.98438,
    market_cap_change_24h: -17318126.45046562,
    market_cap_change_percentage_24h: -5.03346,
    circulating_supply: 25783233.34309683,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 83.4,
    ath_change_percentage: -84.818,
    ath_date: "2021-11-11T02:20:01.099Z",
    atl: 7.45,
    atl_change_percentage: 69.90621,
    atl_date: "2022-06-14T02:00:36.378Z",
    roi: null,
    last_updated: "2023-03-27T23:31:45.869Z",
    price_change_percentage_14d_in_currency: -3.1153151791532268,
    price_change_percentage_1h_in_currency: 0.09629682260187526,
    price_change_percentage_1y_in_currency: -26.929211770309973,
    price_change_percentage_200d_in_currency: -14.33328200095164,
    price_change_percentage_24h_in_currency: -4.984380322592685,
    price_change_percentage_30d_in_currency: -19.489607975247303,
    price_change_percentage_7d_in_currency: -13.17228394636509,
  },
  {
    id: "nxm",
    symbol: "nxm",
    name: "Nexus Mutual",
    image:
      "https://assets.coingecko.com/coins/images/11810/large/NXMmain.png?1674799570",
    current_price: 47.6,
    market_cap: 321841492,
    market_cap_rank: 125,
    fully_diluted_valuation: 321841492,
    total_volume: 13520.53,
    high_24h: 49.99,
    low_24h: 47.48,
    price_change_24h: -2.242191815074264,
    price_change_percentage_24h: -4.4982,
    market_cap_change_24h: -16077579.566851437,
    market_cap_change_percentage_24h: -4.75782,
    circulating_supply: 6760775.00048553,
    total_supply: 6760775.00048553,
    max_supply: 6760775.00048553,
    ath: 185.97,
    ath_change_percentage: -74.40269,
    ath_date: "2021-11-10T15:14:14.418Z",
    atl: 6.96,
    atl_change_percentage: 583.68352,
    atl_date: "2020-07-22T19:54:06.406Z",
    roi: null,
    last_updated: "2023-03-27T23:07:00.664Z",
    price_change_percentage_14d_in_currency: 194.39560344344844,
    price_change_percentage_1h_in_currency: -0.052039452778245864,
    price_change_percentage_1y_in_currency: -54.92279727148374,
    price_change_percentage_200d_in_currency: -8.623954609901078,
    price_change_percentage_24h_in_currency: -4.498200089776999,
    price_change_percentage_30d_in_currency: 2.879463630398125,
    price_change_percentage_7d_in_currency: -8.554781668830397,
  },
  {
    id: "qtum",
    symbol: "qtum",
    name: "Qtum",
    image:
      "https://assets.coingecko.com/coins/images/684/large/Qtum_Logo_blue_CG.png?1637155875",
    current_price: 3.03,
    market_cap: 314871585,
    market_cap_rank: 126,
    fully_diluted_valuation: null,
    total_volume: 26712063,
    high_24h: 3.22,
    low_24h: 2.96,
    price_change_24h: -0.10619533623272304,
    price_change_percentage_24h: -3.39081,
    market_cap_change_24h: -12861931.534570456,
    market_cap_change_percentage_24h: -3.92451,
    circulating_supply: 104591532.5,
    total_supply: 107822406,
    max_supply: null,
    ath: 100.22,
    ath_change_percentage: -96.99585,
    ath_date: "2018-01-06T00:00:00.000Z",
    atl: 0.783142,
    atl_change_percentage: 284.46177,
    atl_date: "2020-03-13T02:22:57.149Z",
    roi: {
      times: 9.085532099529827,
      currency: "usd",
      percentage: 908.5532099529827,
    },
    last_updated: "2023-03-27T23:31:59.083Z",
    price_change_percentage_14d_in_currency: 11.171013382074001,
    price_change_percentage_1h_in_currency: 0.7399970170049568,
    price_change_percentage_1y_in_currency: -63.12291675614643,
    price_change_percentage_200d_in_currency: -2.4974484975501485,
    price_change_percentage_24h_in_currency: -3.3908127094801945,
    price_change_percentage_30d_in_currency: -5.937017193677208,
    price_change_percentage_7d_in_currency: -15.49170849453318,
  },
  {
    id: "aleph-zero",
    symbol: "azero",
    name: "Aleph Zero",
    image:
      "https://assets.coingecko.com/coins/images/17212/large/gtmuTVa.png?1626853180",
    current_price: 1.43,
    market_cap: 314165429,
    market_cap_rank: 127,
    fully_diluted_valuation: null,
    total_volume: 2744916,
    high_24h: 1.52,
    low_24h: 1.4,
    price_change_24h: -0.08084767378325952,
    price_change_percentage_24h: -5.36473,
    market_cap_change_24h: -17876335.69913733,
    market_cap_change_percentage_24h: -5.38376,
    circulating_supply: 220100498.761628,
    total_supply: 327395967.664548,
    max_supply: null,
    ath: 3.09,
    ath_change_percentage: -54.04578,
    ath_date: "2022-04-15T00:09:30.642Z",
    atl: 0.592052,
    atl_change_percentage: 140.20301,
    atl_date: "2022-06-18T20:17:51.413Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.945Z",
    price_change_percentage_14d_in_currency: 9.81453512427449,
    price_change_percentage_1h_in_currency: -0.1606312791745371,
    price_change_percentage_1y_in_currency: -3.507040777932417,
    price_change_percentage_200d_in_currency: 34.820866746644626,
    price_change_percentage_24h_in_currency: -5.3647262220666505,
    price_change_percentage_30d_in_currency: -5.123866495986113,
    price_change_percentage_7d_in_currency: -3.720825989765623,
  },
  {
    id: "holotoken",
    symbol: "hot",
    name: "Holo",
    image:
      "https://assets.coingecko.com/coins/images/3348/large/Holologo_Profile.png?1547037966",
    current_price: 0.00173669,
    market_cap: 308470762,
    market_cap_rank: 128,
    fully_diluted_valuation: null,
    total_volume: 21045385,
    high_24h: 0.00185812,
    low_24h: 0.00170272,
    price_change_24h: -0.000113656855933614,
    price_change_percentage_24h: -6.14245,
    market_cap_change_24h: -20330168.498820722,
    market_cap_change_percentage_24h: -6.18312,
    circulating_supply: 177619433541.141,
    total_supply: 177619433541.141,
    max_supply: null,
    ath: 0.03126682,
    ath_change_percentage: -94.45586,
    ath_date: "2021-04-05T16:04:52.608Z",
    atl: 0.0002202,
    atl_change_percentage: 687.23267,
    atl_date: "2020-03-13T02:23:01.612Z",
    roi: {
      times: 3.4625284251411936,
      currency: "eth",
      percentage: 346.2528425141194,
    },
    last_updated: "2023-03-27T23:31:52.036Z",
    price_change_percentage_14d_in_currency: 1.6264150355668707,
    price_change_percentage_1h_in_currency: 0.19108909181247655,
    price_change_percentage_1y_in_currency: -66.39591143329444,
    price_change_percentage_200d_in_currency: -14.333999708348896,
    price_change_percentage_24h_in_currency: -6.142445971097163,
    price_change_percentage_30d_in_currency: -16.65264401780201,
    price_change_percentage_7d_in_currency: -9.029638387690413,
  },
  {
    id: "theta-fuel",
    symbol: "tfuel",
    name: "Theta Fuel",
    image:
      "https://assets.coingecko.com/coins/images/8029/large/1_0YusgngOrriVg4ZYx4wOFQ.png?1553483622",
    current_price: 0.050163,
    market_cap: 305493395,
    market_cap_rank: 129,
    fully_diluted_valuation: null,
    total_volume: 7315143,
    high_24h: 0.05313,
    low_24h: 0.04941337,
    price_change_24h: -0.002932419284814719,
    price_change_percentage_24h: -5.52293,
    market_cap_change_24h: -17624798.93537867,
    market_cap_change_percentage_24h: -5.4546,
    circulating_supply: 6079530274,
    total_supply: 6079504529,
    max_supply: null,
    ath: 0.68159,
    ath_change_percentage: -92.6276,
    ath_date: "2021-06-09T06:50:55.818Z",
    atl: 0.00090804,
    atl_change_percentage: 5433.85279,
    atl_date: "2020-03-13T02:30:37.972Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.265Z",
    price_change_percentage_14d_in_currency: 0.1980120699665238,
    price_change_percentage_1h_in_currency: -0.03160301906639484,
    price_change_percentage_1y_in_currency: -72.60561397663896,
    price_change_percentage_200d_in_currency: -9.193857360825085,
    price_change_percentage_24h_in_currency: -5.522926564690065,
    price_change_percentage_30d_in_currency: -18.523260084886086,
    price_change_percentage_7d_in_currency: -12.997432537622094,
  },
  {
    id: "beldex",
    symbol: "bdx",
    name: "Beldex",
    image:
      "https://assets.coingecko.com/coins/images/5111/large/Beldex.png?1559189036",
    current_price: 0.058759,
    market_cap: 305292335,
    market_cap_rank: 130,
    fully_diluted_valuation: 582649829,
    total_volume: 2533665,
    high_24h: 0.062237,
    low_24h: 0.057357,
    price_change_24h: -0.003229234040235701,
    price_change_percentage_24h: -5.20946,
    market_cap_change_24h: -16724169.438658416,
    market_cap_change_percentage_24h: -5.19358,
    circulating_supply: 5195695022.5837,
    total_supply: 9915973860.11308,
    max_supply: null,
    ath: 137242055,
    ath_change_percentage: -100,
    ath_date: "2020-09-02T09:13:36.882Z",
    atl: 0.00027519,
    atl_change_percentage: 21213.39433,
    atl_date: "2019-11-01T11:05:12.090Z",
    roi: {
      times: -0.7649651613165463,
      currency: "usd",
      percentage: -76.49651613165464,
    },
    last_updated: "2023-03-27T23:31:38.582Z",
    price_change_percentage_14d_in_currency: 48.393697825476465,
    price_change_percentage_1h_in_currency: 0.13137791770445992,
    price_change_percentage_1y_in_currency: -39.00455422627371,
    price_change_percentage_200d_in_currency: 8.084463702380145,
    price_change_percentage_24h_in_currency: -5.209455011583968,
    price_change_percentage_30d_in_currency: 68.97120883610629,
    price_change_percentage_7d_in_currency: 7.140436624865809,
  },
  {
    id: "woo-network",
    symbol: "woo",
    name: "WOO Network",
    image:
      "https://assets.coingecko.com/coins/images/12921/large/w2UiemF__400x400.jpg?1603670367",
    current_price: 0.181972,
    market_cap: 304501360,
    market_cap_rank: 131,
    fully_diluted_valuation: 408885095,
    total_volume: 15907967,
    high_24h: 0.195235,
    low_24h: 0.178274,
    price_change_24h: -0.013260240391262168,
    price_change_percentage_24h: -6.79204,
    market_cap_change_24h: -23128668.841974318,
    market_cap_change_percentage_24h: -7.05939,
    circulating_supply: 1676091138.21026,
    total_supply: 2250658857.90186,
    max_supply: 2250658857.90186,
    ath: 1.78,
    ath_change_percentage: -89.78464,
    ath_date: "2021-11-15T13:44:18.437Z",
    atl: 0.02211546,
    atl_change_percentage: 721.41237,
    atl_date: "2021-01-04T10:19:13.803Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.811Z",
    price_change_percentage_14d_in_currency: 1.624286163282275,
    price_change_percentage_1h_in_currency: 0.4726434791461848,
    price_change_percentage_1y_in_currency: -68.49454106479821,
    price_change_percentage_200d_in_currency: 19.51619042426021,
    price_change_percentage_24h_in_currency: -6.792035945585714,
    price_change_percentage_30d_in_currency: -14.188562083447511,
    price_change_percentage_7d_in_currency: -18.80373080108024,
  },
  {
    id: "terra-luna-2",
    symbol: "luna",
    name: "Terra",
    image:
      "https://assets.coingecko.com/coins/images/25767/large/01_Luna_color.png?1653556122",
    current_price: 1.26,
    market_cap: 304247401,
    market_cap_rank: 132,
    fully_diluted_valuation: 1350622625,
    total_volume: 33806437,
    high_24h: 1.32,
    low_24h: 1.23,
    price_change_24h: -0.054120563783442543,
    price_change_percentage_24h: -4.10846,
    market_cap_change_24h: -13232520.111963928,
    market_cap_change_percentage_24h: -4.16799,
    circulating_supply: 241651733.068901,
    total_supply: 1072746381.59725,
    max_supply: null,
    ath: 18.87,
    ath_change_percentage: -93.33352,
    ath_date: "2022-05-28T09:18:14.847Z",
    atl: 1.19,
    atl_change_percentage: 5.40308,
    atl_date: "2022-12-16T22:44:52.442Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.279Z",
    price_change_percentage_14d_in_currency: -8.384410436767045,
    price_change_percentage_1h_in_currency: 0.5520270581506116,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: -32.947952706125434,
    price_change_percentage_24h_in_currency: -4.108464438755332,
    price_change_percentage_30d_in_currency: -27.282300527428184,
    price_change_percentage_7d_in_currency: -14.306896799835528,
  },
  {
    id: "injective-protocol",
    symbol: "inj",
    name: "Injective",
    image:
      "https://assets.coingecko.com/coins/images/12882/large/Secondary_Symbol.png?1628233237",
    current_price: 3.77,
    market_cap: 301752685,
    market_cap_rank: 133,
    fully_diluted_valuation: 377164665,
    total_volume: 39692372,
    high_24h: 4.07,
    low_24h: 3.72,
    price_change_24h: -0.28631972540204886,
    price_change_percentage_24h: -7.05574,
    market_cap_change_24h: -23016836.512273908,
    market_cap_change_percentage_24h: -7.08713,
    circulating_supply: 80005555.33,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 24.89,
    ath_change_percentage: -84.872,
    ath_date: "2021-04-30T00:33:02.969Z",
    atl: 0.657401,
    atl_change_percentage: 472.76176,
    atl_date: "2020-11-03T16:19:30.576Z",
    roi: null,
    last_updated: "2023-03-27T23:31:54.307Z",
    price_change_percentage_14d_in_currency: 0.804816708673794,
    price_change_percentage_1h_in_currency: -0.15082115473890317,
    price_change_percentage_1y_in_currency: -35.251068419139116,
    price_change_percentage_200d_in_currency: 142.0892511699466,
    price_change_percentage_24h_in_currency: -7.055744151165451,
    price_change_percentage_30d_in_currency: 3.6898894465403127,
    price_change_percentage_7d_in_currency: -13.009740617236407,
  },
  {
    id: "decred",
    symbol: "dcr",
    name: "Decred",
    image:
      "https://assets.coingecko.com/coins/images/329/large/decred.png?1547034093",
    current_price: 20.13,
    market_cap: 298660393,
    market_cap_rank: 134,
    fully_diluted_valuation: null,
    total_volume: 1134948,
    high_24h: 21.32,
    low_24h: 19.97,
    price_change_24h: -1.192704122523594,
    price_change_percentage_24h: -5.59321,
    market_cap_change_24h: -17839623.637636423,
    market_cap_change_percentage_24h: -5.63653,
    circulating_supply: 14834382.3333369,
    total_supply: 21000000,
    max_supply: null,
    ath: 247.35,
    ath_change_percentage: -91.87238,
    ath_date: "2021-04-17T00:41:14.790Z",
    atl: 0.43154,
    atl_change_percentage: 4558.61229,
    atl_date: "2016-12-26T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:50.585Z",
    price_change_percentage_14d_in_currency: 2.9268215847405537,
    price_change_percentage_1h_in_currency: 0.08593267582526015,
    price_change_percentage_1y_in_currency: -67.09009290689653,
    price_change_percentage_200d_in_currency: -30.355727904889314,
    price_change_percentage_24h_in_currency: -5.593205476354538,
    price_change_percentage_30d_in_currency: -17.164813240163692,
    price_change_percentage_7d_in_currency: -4.553375820376069,
  },
  {
    id: "ravencoin",
    symbol: "rvn",
    name: "Ravencoin",
    image:
      "https://assets.coingecko.com/coins/images/3412/large/ravencoin.png?1548386057",
    current_price: 0.02438123,
    market_cap: 290387593,
    market_cap_rank: 135,
    fully_diluted_valuation: null,
    total_volume: 15409272,
    high_24h: 0.02616134,
    low_24h: 0.02381702,
    price_change_24h: -0.00177202133455525,
    price_change_percentage_24h: -6.77553,
    market_cap_change_24h: -21242867.719318807,
    market_cap_change_percentage_24h: -6.81669,
    circulating_supply: 11907968088.8129,
    total_supply: 11907780693.8129,
    max_supply: null,
    ath: 0.285218,
    ath_change_percentage: -91.4502,
    ath_date: "2021-02-20T11:19:07.791Z",
    atl: 0.00893232,
    atl_change_percentage: 173.00369,
    atl_date: "2020-03-13T02:30:00.004Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.834Z",
    price_change_percentage_14d_in_currency: 0.08429429519546364,
    price_change_percentage_1h_in_currency: 0.06961195616261368,
    price_change_percentage_1y_in_currency: -63.18468474404274,
    price_change_percentage_200d_in_currency: -33.91226376703373,
    price_change_percentage_24h_in_currency: -6.775528698893152,
    price_change_percentage_30d_in_currency: -24.04289045729133,
    price_change_percentage_7d_in_currency: -12.25002188070199,
  },
  {
    id: "kusama",
    symbol: "ksm",
    name: "Kusama",
    image:
      "https://assets.coingecko.com/coins/images/9568/large/m4zRhP5e_400x400.jpg?1576190080",
    current_price: 31.8,
    market_cap: 285564856,
    market_cap_rank: 136,
    fully_diluted_valuation: 317997481,
    total_volume: 16627354,
    high_24h: 33.82,
    low_24h: 31.34,
    price_change_24h: -1.9228029624704774,
    price_change_percentage_24h: -5.70102,
    market_cap_change_24h: -17017991.078318655,
    market_cap_change_percentage_24h: -5.62424,
    circulating_supply: 8980098.074112339,
    total_supply: 10000000,
    max_supply: 10000000,
    ath: 621.71,
    ath_change_percentage: -94.88691,
    ath_date: "2021-05-18T05:04:41.858Z",
    atl: 0.876572,
    atl_change_percentage: 3526.43818,
    atl_date: "2020-01-14T19:20:20.768Z",
    roi: null,
    last_updated: "2023-03-27T23:31:48.500Z",
    price_change_percentage_14d_in_currency: -2.1948443967826265,
    price_change_percentage_1h_in_currency: -0.06339665628910308,
    price_change_percentage_1y_in_currency: -80.63689391994698,
    price_change_percentage_200d_in_currency: -34.32988433049373,
    price_change_percentage_24h_in_currency: -5.701023101023884,
    price_change_percentage_30d_in_currency: -16.885014419573267,
    price_change_percentage_7d_in_currency: -13.535103924041072,
  },
  {
    id: "gains-farm",
    symbol: "gfarm2",
    name: "Gains Farm",
    image:
      "https://assets.coingecko.com/coins/images/13703/large/gfarm_v2.png?1611035398",
    current_price: 7930.53,
    market_cap: 284174530,
    market_cap_rank: 137,
    fully_diluted_valuation: 284174530,
    total_volume: 847.25,
    high_24h: null,
    low_24h: null,
    price_change_24h: null,
    price_change_percentage_24h: null,
    market_cap_change_24h: null,
    market_cap_change_percentage_24h: null,
    circulating_supply: 35833.0003763344,
    total_supply: 35833.0003763344,
    max_supply: 35833.0003763344,
    ath: 11444.33,
    ath_change_percentage: -30.70343,
    ath_date: "2023-02-17T08:10:37.065Z",
    atl: 18.04,
    atl_change_percentage: 43872.73281,
    atl_date: "2021-01-26T16:14:36.262Z",
    roi: null,
    last_updated: "2023-03-26T07:39:19.460Z",
    price_change_percentage_14d_in_currency: 24.113309342461918,
    price_change_percentage_1h_in_currency: null,
    price_change_percentage_1y_in_currency: 234.40751412576324,
    price_change_percentage_200d_in_currency: 397.85502094080016,
    price_change_percentage_24h_in_currency: null,
    price_change_percentage_30d_in_currency: -7.25763407125125,
    price_change_percentage_7d_in_currency: -14.460959809639695,
  },
  {
    id: "olympus",
    symbol: "ohm",
    name: "Olympus",
    image:
      "https://assets.coingecko.com/coins/images/14483/large/token_OHM_%281%29.png?1628311611",
    current_price: 10.22,
    market_cap: 283627364,
    market_cap_rank: 138,
    fully_diluted_valuation: 287278667,
    total_volume: 711095,
    high_24h: 10.32,
    low_24h: 10.19,
    price_change_24h: -0.09699768882418525,
    price_change_percentage_24h: -0.94031,
    market_cap_change_24h: -2395169.029283285,
    market_cap_change_percentage_24h: -0.83741,
    circulating_supply: 27766805.309068747,
    total_supply: 28124263.9104282,
    max_supply: 28124263.9104282,
    ath: 1415.26,
    ath_change_percentage: -99.27824,
    ath_date: "2021-04-25T00:00:00.000Z",
    atl: 7.54,
    atl_change_percentage: 35.40962,
    atl_date: "2022-11-26T16:36:26.296Z",
    roi: null,
    last_updated: "2023-03-27T23:31:51.303Z",
    price_change_percentage_14d_in_currency: 0.7675639120186979,
    price_change_percentage_1h_in_currency: 0.08787652980749242,
    price_change_percentage_1y_in_currency: -74.07118263711052,
    price_change_percentage_200d_in_currency: -9.258285043432336,
    price_change_percentage_24h_in_currency: -0.9403104381454511,
    price_change_percentage_30d_in_currency: -1.1851788008051611,
    price_change_percentage_7d_in_currency: -2.1763644016409742,
  },
  {
    id: "gala",
    symbol: "gala",
    name: "GALA",
    image:
      "https://assets.coingecko.com/coins/images/12493/large/GALA-COINGECKO.png?1600233435",
    current_price: 0.03757406,
    market_cap: 283401571,
    market_cap_rank: 139,
    fully_diluted_valuation: 1878698706,
    total_volume: 174357776,
    high_24h: 0.04025708,
    low_24h: 0.03650176,
    price_change_24h: -0.002484034776855188,
    price_change_percentage_24h: -6.20108,
    market_cap_change_24h: -18722175.4695099,
    market_cap_change_percentage_24h: -6.19686,
    circulating_supply: 7542496572.319239,
    total_supply: 39233906510.0965,
    max_supply: 50000000000,
    ath: 0.824837,
    ath_change_percentage: -95.45878,
    ath_date: "2021-11-26T01:03:48.731Z",
    atl: 0.00013475,
    atl_change_percentage: 27698.00275,
    atl_date: "2020-12-28T08:46:48.367Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.785Z",
    price_change_percentage_14d_in_currency: 7.851249354734769,
    price_change_percentage_1h_in_currency: 0.33589688787146604,
    price_change_percentage_1y_in_currency: -85.04743026858065,
    price_change_percentage_200d_in_currency: -22.99531078737273,
    price_change_percentage_24h_in_currency: -6.201080245037905,
    price_change_percentage_30d_in_currency: -8.795524266572388,
    price_change_percentage_7d_in_currency: -19.777041945681532,
  },
  {
    id: "compound-governance-token",
    symbol: "comp",
    name: "Compound",
    image:
      "https://assets.coingecko.com/coins/images/10775/large/COMP.png?1592625425",
    current_price: 41.08,
    market_cap: 281648665,
    market_cap_rank: 140,
    fully_diluted_valuation: 410800965,
    total_volume: 18770440,
    high_24h: 42.92,
    low_24h: 40.17,
    price_change_24h: -1.7013973107097868,
    price_change_percentage_24h: -3.97693,
    market_cap_change_24h: -11282061.766666532,
    market_cap_change_percentage_24h: -3.85144,
    circulating_supply: 6856085.76329154,
    total_supply: 10000000,
    max_supply: 10000000,
    ath: 910.54,
    ath_change_percentage: -95.4913,
    ath_date: "2021-05-12T02:29:08.794Z",
    atl: 26.41,
    atl_change_percentage: 55.44602,
    atl_date: "2022-06-18T20:54:18.261Z",
    roi: null,
    last_updated: "2023-03-27T23:31:35.875Z",
    price_change_percentage_14d_in_currency: -3.549290310332694,
    price_change_percentage_1h_in_currency: 0.4178191668910437,
    price_change_percentage_1y_in_currency: -66.28050985603579,
    price_change_percentage_200d_in_currency: -15.769350876183164,
    price_change_percentage_24h_in_currency: -3.976932562526629,
    price_change_percentage_30d_in_currency: -19.150885945436343,
    price_change_percentage_7d_in_currency: -11.533293947091098,
  },
  {
    id: "celo",
    symbol: "celo",
    name: "Celo",
    image:
      "https://assets.coingecko.com/coins/images/11090/large/InjXBNx9_400x400.jpg?1674707499",
    current_price: 0.572301,
    market_cap: 281296145,
    market_cap_rank: 141,
    fully_diluted_valuation: 572284578,
    total_volume: 13086224,
    high_24h: 0.611926,
    low_24h: 0.560919,
    price_change_24h: -0.03897750573749737,
    price_change_percentage_24h: -6.37639,
    market_cap_change_24h: -19304083.907988906,
    market_cap_change_percentage_24h: -6.42185,
    circulating_supply: 491531934,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 9.82,
    ath_change_percentage: -94.17984,
    ath_date: "2021-08-30T14:25:09.929Z",
    atl: 0.404104,
    atl_change_percentage: 41.45249,
    atl_date: "2022-11-14T04:33:02.678Z",
    roi: null,
    last_updated: "2023-03-27T23:31:48.112Z",
    price_change_percentage_14d_in_currency: -1.5777100156599375,
    price_change_percentage_1h_in_currency: -0.10853985158529952,
    price_change_percentage_1y_in_currency: -81.69558463507546,
    price_change_percentage_200d_in_currency: -29.421753453756505,
    price_change_percentage_24h_in_currency: -6.376392289174078,
    price_change_percentage_30d_in_currency: -26.79277667080043,
    price_change_percentage_7d_in_currency: -16.05953351347178,
  },
  {
    id: "safemoon",
    symbol: "safemoon",
    name: "SafeMoon [OLD]",
    image:
      "https://assets.coingecko.com/coins/images/14362/large/174x174-white.png?1617174846",
    current_price: 6.388e-9,
    market_cap: 277800683,
    market_cap_rank: 142,
    fully_diluted_valuation: null,
    total_volume: 5.25,
    high_24h: 6.801e-9,
    low_24h: 6.32e-9,
    price_change_24h: -4.05238995e-10,
    price_change_percentage_24h: -5.96522,
    market_cap_change_24h: -14241412.357248962,
    market_cap_change_percentage_24h: -4.87649,
    circulating_supply: 0,
    total_supply: 1000000000000000,
    max_supply: null,
    ath: 0.00001094,
    ath_change_percentage: -99.9417,
    ath_date: "2021-05-11T20:32:53.513Z",
    atl: 3.3e-9,
    atl_change_percentage: 93.32411,
    atl_date: "2022-06-18T20:49:56.139Z",
    roi: null,
    last_updated: "2023-03-27T23:31:37.506Z",
    price_change_percentage_14d_in_currency: 6.908259369826168,
    price_change_percentage_1h_in_currency: 0.4508973822610575,
    price_change_percentage_1y_in_currency: -98.83922524826377,
    price_change_percentage_200d_in_currency: 17.967135349024254,
    price_change_percentage_24h_in_currency: -5.9652188972650375,
    price_change_percentage_30d_in_currency: 2.9675565456232267,
    price_change_percentage_7d_in_currency: -8.445931076962676,
  },
  {
    id: "magic",
    symbol: "magic",
    name: "Magic",
    image:
      "https://assets.coingecko.com/coins/images/18623/large/magic.png?1656052146",
    current_price: 1.3,
    market_cap: 276923348,
    market_cap_rank: 143,
    fully_diluted_valuation: 453012945,
    total_volume: 70448345,
    high_24h: 1.46,
    low_24h: 1.28,
    price_change_24h: -0.15580112254000134,
    price_change_percentage_24h: -10.67775,
    market_cap_change_24h: -33630868.904105544,
    market_cap_change_percentage_24h: -10.82931,
    circulating_supply: 212554912.436439,
    total_supply: 339645510.317976,
    max_supply: 347714007,
    ath: 6.32,
    ath_change_percentage: -79.40772,
    ath_date: "2022-02-19T16:24:53.615Z",
    atl: 0.01999252,
    atl_change_percentage: 6413.29368,
    atl_date: "2021-10-07T01:57:51.729Z",
    roi: null,
    last_updated: "2023-03-27T23:31:49.801Z",
    price_change_percentage_14d_in_currency: 3.300853146913597,
    price_change_percentage_1h_in_currency: 0.38550633713265353,
    price_change_percentage_1y_in_currency: -59.57417161284457,
    price_change_percentage_200d_in_currency: 114.98785074648161,
    price_change_percentage_24h_in_currency: -10.677745325020696,
    price_change_percentage_30d_in_currency: -19.84370590311697,
    price_change_percentage_7d_in_currency: -29.818223165517455,
  },
  {
    id: "flex-coin",
    symbol: "flex",
    name: "FLEX Coin",
    image:
      "https://assets.coingecko.com/coins/images/9108/large/coinflex_logo.png?1628750583",
    current_price: 2.79,
    market_cap: 274692969,
    market_cap_rank: 144,
    fully_diluted_valuation: 274890016,
    total_volume: 3462380,
    high_24h: 4.61,
    low_24h: 2.53,
    price_change_24h: 0.204922,
    price_change_percentage_24h: 7.94067,
    market_cap_change_24h: 20152751,
    market_cap_change_percentage_24h: 7.91731,
    circulating_supply: 98664988.8927454,
    total_supply: 98735764.894,
    max_supply: 98735764.894,
    ath: 7.56,
    ath_change_percentage: -63.20572,
    ath_date: "2021-12-22T02:44:42.437Z",
    atl: 0.00047299,
    atl_change_percentage: 588295.8189,
    atl_date: "2020-08-04T11:18:39.614Z",
    roi: null,
    last_updated: "2023-03-27T23:31:51.982Z",
    price_change_percentage_14d_in_currency: 61.92919602427226,
    price_change_percentage_1h_in_currency: -1.3779826344909447,
    price_change_percentage_1y_in_currency: -28.488298113738107,
    price_change_percentage_200d_in_currency: 1292.7910241536458,
    price_change_percentage_24h_in_currency: 7.940666045063975,
    price_change_percentage_30d_in_currency: 99.6327687088115,
    price_change_percentage_7d_in_currency: 58.861828135950475,
  },
  {
    id: "bitcoin-gold",
    symbol: "btg",
    name: "Bitcoin Gold",
    image:
      "https://assets.coingecko.com/coins/images/1043/large/bitcoin-gold-logo.png?1547034978",
    current_price: 15.59,
    market_cap: 273102655,
    market_cap_rank: 146,
    fully_diluted_valuation: null,
    total_volume: 4274488,
    high_24h: 16.47,
    low_24h: 15.38,
    price_change_24h: -0.749562669023895,
    price_change_percentage_24h: -4.58673,
    market_cap_change_24h: -13196209.2140584,
    market_cap_change_percentage_24h: -4.60924,
    circulating_supply: 17513924,
    total_supply: 21000000,
    max_supply: null,
    ath: 456.25,
    ath_change_percentage: -96.58559,
    ath_date: "2017-12-20T00:00:00.000Z",
    atl: 4.25,
    atl_change_percentage: 266.16127,
    atl_date: "2020-03-13T02:22:52.902Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.206Z",
    price_change_percentage_14d_in_currency: 6.699774578316752,
    price_change_percentage_1h_in_currency: -0.3218467107374861,
    price_change_percentage_1y_in_currency: -63.25411971451953,
    price_change_percentage_200d_in_currency: -34.620647680386874,
    price_change_percentage_24h_in_currency: -4.586731191302762,
    price_change_percentage_30d_in_currency: -10.397917527551344,
    price_change_percentage_7d_in_currency: -10.852018536407046,
  },
  {
    id: "gnosis",
    symbol: "gno",
    name: "Gnosis",
    image:
      "https://assets.coingecko.com/coins/images/662/large/logo_square_simple_300px.png?1609402668",
    current_price: 105.45,
    market_cap: 273082879,
    market_cap_rank: 145,
    fully_diluted_valuation: 316362418,
    total_volume: 4292074,
    high_24h: 110.03,
    low_24h: 104.64,
    price_change_24h: -3.062882072434448,
    price_change_percentage_24h: -2.82257,
    market_cap_change_24h: -7939709.199144423,
    market_cap_change_percentage_24h: -2.82529,
    circulating_supply: 2589589,
    total_supply: 3000000,
    max_supply: 3000000,
    ath: 644.2,
    ath_change_percentage: -83.63152,
    ath_date: "2021-11-08T17:33:29.302Z",
    atl: 6.88,
    atl_change_percentage: 1431.73437,
    atl_date: "2020-03-13T02:24:11.825Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.205Z",
    price_change_percentage_14d_in_currency: 1.3895357856088824,
    price_change_percentage_1h_in_currency: 0.02435802012018923,
    price_change_percentage_1y_in_currency: -68.9557485268302,
    price_change_percentage_200d_in_currency: -32.98194458368419,
    price_change_percentage_24h_in_currency: -2.8225667281761813,
    price_change_percentage_30d_in_currency: -0.6558025021314956,
    price_change_percentage_7d_in_currency: -7.218615618746969,
  },
  {
    id: "oasis-network",
    symbol: "rose",
    name: "Oasis Network",
    image:
      "https://assets.coingecko.com/coins/images/13162/large/rose.png?1605772906",
    current_price: 0.053594,
    market_cap: 268988321,
    market_cap_rank: 147,
    fully_diluted_valuation: 534836383,
    total_volume: 34689843,
    high_24h: 0.057455,
    low_24h: 0.053002,
    price_change_24h: -0.003623819142608176,
    price_change_percentage_24h: -6.33337,
    market_cap_change_24h: -19086208.909348667,
    market_cap_change_percentage_24h: -6.62544,
    circulating_supply: 5029357184,
    total_supply: 10000000000,
    max_supply: 10000000000,
    ath: 0.597347,
    ath_change_percentage: -91.04639,
    ath_date: "2022-01-15T03:31:11.062Z",
    atl: 0.03200566,
    atl_change_percentage: 67.10829,
    atl_date: "2020-11-26T17:09:12.182Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.281Z",
    price_change_percentage_14d_in_currency: -0.8866658373066892,
    price_change_percentage_1h_in_currency: 0.025632014656816266,
    price_change_percentage_1y_in_currency: -79.74560362838584,
    price_change_percentage_200d_in_currency: -10.97360540758155,
    price_change_percentage_24h_in_currency: -6.333365009548894,
    price_change_percentage_30d_in_currency: -20.676149219188687,
    price_change_percentage_7d_in_currency: -16.27495243386132,
  },
  {
    id: "liquity-usd",
    symbol: "lusd",
    name: "Liquity USD",
    image:
      "https://assets.coingecko.com/coins/images/14666/large/Group_3.png?1617631327",
    current_price: 1.015,
    market_cap: 268627749,
    market_cap_rank: 148,
    fully_diluted_valuation: null,
    total_volume: 11457500,
    high_24h: 1.018,
    low_24h: 1.01,
    price_change_24h: 0.00112522,
    price_change_percentage_24h: 0.11098,
    market_cap_change_24h: 169952,
    market_cap_change_percentage_24h: 0.06331,
    circulating_supply: 264752412.102524,
    total_supply: 264752412.102524,
    max_supply: null,
    ath: 1.16,
    ath_change_percentage: -12.42745,
    ath_date: "2021-04-05T14:47:52.665Z",
    atl: 0.896722,
    atl_change_percentage: 13.12026,
    atl_date: "2022-01-27T09:42:06.510Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.567Z",
    price_change_percentage_14d_in_currency: 0.14794442856206286,
    price_change_percentage_1h_in_currency: -0.1091189684732159,
    price_change_percentage_1y_in_currency: 1.0773071443330795,
    price_change_percentage_200d_in_currency: 1.0142494943571996,
    price_change_percentage_24h_in_currency: 0.11098428366760195,
    price_change_percentage_30d_in_currency: 1.2991541401618056,
    price_change_percentage_7d_in_currency: 0.06920442957535547,
  },
  {
    id: "link",
    symbol: "ln",
    name: "LINK",
    image:
      "https://assets.coingecko.com/coins/images/6450/large/linklogo.png?1547042644",
    current_price: 39.22,
    market_cap: 268100832,
    market_cap_rank: 149,
    fully_diluted_valuation: null,
    total_volume: 67240,
    high_24h: 41.5,
    low_24h: 39.16,
    price_change_24h: -2.22954771096817,
    price_change_percentage_24h: -5.37953,
    market_cap_change_24h: -4310075.682953954,
    market_cap_change_percentage_24h: -1.5822,
    circulating_supply: 6734458,
    total_supply: 6734458,
    max_supply: null,
    ath: 345.88,
    ath_change_percentage: -88.49029,
    ath_date: "2021-04-01T22:19:00.034Z",
    atl: 1.055,
    atl_change_percentage: 3673.49406,
    atl_date: "2018-12-26T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.463Z",
    price_change_percentage_14d_in_currency: 0.5566737536441757,
    price_change_percentage_1h_in_currency: -2.719535728360456,
    price_change_percentage_1y_in_currency: -70.35082916696787,
    price_change_percentage_200d_in_currency: 12.672092671089358,
    price_change_percentage_24h_in_currency: -5.3795276823716724,
    price_change_percentage_30d_in_currency: -11.354266177528096,
    price_change_percentage_7d_in_currency: -7.682513614391964,
  },
  {
    id: "yearn-finance",
    symbol: "yfi",
    name: "yearn.finance",
    image:
      "https://assets.coingecko.com/coins/images/11849/large/yearn-finance-yfi.png?1676174746",
    current_price: 8103.36,
    market_cap: 265397676,
    market_cap_rank: 150,
    fully_diluted_valuation: 296882687,
    total_volume: 30003729,
    high_24h: 8473.34,
    low_24h: 7932.7,
    price_change_24h: -337.35473038802866,
    price_change_percentage_24h: -3.99676,
    market_cap_change_24h: -11380940.75509584,
    market_cap_change_percentage_24h: -4.11193,
    circulating_supply: 32777.496366381085,
    total_supply: 36666,
    max_supply: 36666,
    ath: 90787,
    ath_change_percentage: -91.08137,
    ath_date: "2021-05-12T00:29:37.713Z",
    atl: 31.65,
    atl_change_percentage: 25486.68867,
    atl_date: "2020-07-18T12:26:27.150Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.652Z",
    price_change_percentage_14d_in_currency: -1.8736119138317981,
    price_change_percentage_1h_in_currency: 0.4697184057189322,
    price_change_percentage_1y_in_currency: -61.64682183876966,
    price_change_percentage_200d_in_currency: -13.404849786972283,
    price_change_percentage_24h_in_currency: -3.9967559044681127,
    price_change_percentage_30d_in_currency: -7.1754425892743665,
    price_change_percentage_7d_in_currency: -8.37179363599721,
  },
  {
    id: "astar",
    symbol: "astr",
    name: "Astar",
    image:
      "https://assets.coingecko.com/coins/images/22617/large/astr.png?1642314057",
    current_price: 0.060464,
    market_cap: 263699298,
    market_cap_rank: 151,
    fully_diluted_valuation: 473651192,
    total_volume: 9035446,
    high_24h: 0.062466,
    low_24h: 0.058347,
    price_change_24h: -0.001952091174333467,
    price_change_percentage_24h: -3.12755,
    market_cap_change_24h: -8326645.845024973,
    market_cap_change_percentage_24h: -3.06097,
    circulating_supply: 4363228333,
    total_supply: 7837139930,
    max_supply: null,
    ath: 0.421574,
    ath_change_percentage: -85.67767,
    ath_date: "2022-01-17T13:34:36.289Z",
    atl: 0.03269521,
    atl_change_percentage: 84.67282,
    atl_date: "2022-10-13T13:05:41.982Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.385Z",
    price_change_percentage_14d_in_currency: -0.46766109961241653,
    price_change_percentage_1h_in_currency: -0.24906401088161056,
    price_change_percentage_1y_in_currency: -45.89278225138841,
    price_change_percentage_200d_in_currency: 70.74380095119194,
    price_change_percentage_24h_in_currency: -3.1275539555012872,
    price_change_percentage_30d_in_currency: -24.49374528854019,
    price_change_percentage_7d_in_currency: -14.674677043393677,
  },
  {
    id: "audius",
    symbol: "audio",
    name: "Audius",
    image:
      "https://assets.coingecko.com/coins/images/12913/large/AudiusCoinLogo_2x.png?1603425727",
    current_price: 0.265929,
    market_cap: 263674599,
    market_cap_rank: 152,
    fully_diluted_valuation: 307024243,
    total_volume: 9607760,
    high_24h: 0.274826,
    low_24h: 0.255021,
    price_change_24h: -0.008890769780190932,
    price_change_percentage_24h: -3.23513,
    market_cap_change_24h: -8398736.301597923,
    market_cap_change_percentage_24h: -3.08694,
    circulating_supply: 990636746,
    total_supply: 1153503212.35144,
    max_supply: 1153503212.35144,
    ath: 4.95,
    ath_change_percentage: -94.63461,
    ath_date: "2021-03-27T15:45:35.137Z",
    atl: 0.0437371,
    atl_change_percentage: 507.82152,
    atl_date: "2020-10-23T14:56:23.999Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.724Z",
    price_change_percentage_14d_in_currency: 8.376732117673658,
    price_change_percentage_1h_in_currency: 0.2646065135439909,
    price_change_percentage_1y_in_currency: -74.20871635762467,
    price_change_percentage_200d_in_currency: -6.277519489169742,
    price_change_percentage_24h_in_currency: -3.2351308800355567,
    price_change_percentage_30d_in_currency: -23.06123192615363,
    price_change_percentage_7d_in_currency: -11.460915550346645,
  },
  {
    id: "nucypher",
    symbol: "nu",
    name: "NuCypher",
    image:
      "https://assets.coingecko.com/coins/images/3318/large/photo1198982838879365035.jpg?1547037916",
    current_price: 0.200464,
    market_cap: 262880635,
    market_cap_rank: 153,
    fully_diluted_valuation: 785601321,
    total_volume: 51100245,
    high_24h: 0.211296,
    low_24h: 0.185698,
    price_change_24h: -0.007889497514201512,
    price_change_percentage_24h: -3.78659,
    market_cap_change_24h: -8114755.382274866,
    market_cap_change_percentage_24h: -2.99443,
    circulating_supply: 1300142684.8066669,
    total_supply: 3885390081.74825,
    max_supply: 3885390081.74825,
    ath: 2.61,
    ath_change_percentage: -92.25217,
    ath_date: "2021-10-15T08:50:14.799Z",
    atl: 0.062214,
    atl_change_percentage: 224.96574,
    atl_date: "2020-11-27T03:03:31.701Z",
    roi: null,
    last_updated: "2023-03-27T23:31:32.451Z",
    price_change_percentage_14d_in_currency: 81.23880025581731,
    price_change_percentage_1h_in_currency: 0.7448055882426227,
    price_change_percentage_1y_in_currency: -54.2910620993656,
    price_change_percentage_200d_in_currency: 26.782096852440603,
    price_change_percentage_24h_in_currency: -3.7865902029875698,
    price_change_percentage_30d_in_currency: 31.854106527539606,
    price_change_percentage_7d_in_currency: 7.989158473975985,
  },
  {
    id: "balancer",
    symbol: "bal",
    name: "Balancer",
    image:
      "https://assets.coingecko.com/coins/images/11683/large/Balancer.png?1592792958",
    current_price: 6.47,
    market_cap: 260252433,
    market_cap_rank: 154,
    fully_diluted_valuation: 622176117,
    total_volume: 6922901,
    high_24h: 6.91,
    low_24h: 6.43,
    price_change_24h: -0.3310506056638953,
    price_change_percentage_24h: -4.86707,
    market_cap_change_24h: -13234014.793717533,
    market_cap_change_percentage_24h: -4.839,
    circulating_supply: 40219246.4936515,
    total_supply: 56189965.9773135,
    max_supply: 96150704,
    ath: 74.45,
    ath_change_percentage: -91.31298,
    ath_date: "2021-05-04T13:35:02.939Z",
    atl: 3.66,
    atl_change_percentage: 76.91356,
    atl_date: "2022-06-18T21:00:00.231Z",
    roi: null,
    last_updated: "2023-03-27T23:31:45.839Z",
    price_change_percentage_14d_in_currency: 1.1612628054951533,
    price_change_percentage_1h_in_currency: 0.21988075732477397,
    price_change_percentage_1y_in_currency: -49.76032175458755,
    price_change_percentage_200d_in_currency: -9.172205096948796,
    price_change_percentage_24h_in_currency: -4.8670694868863915,
    price_change_percentage_30d_in_currency: -7.992507475307225,
    price_change_percentage_7d_in_currency: -4.571748287590949,
  },
  {
    id: "access-protocol",
    symbol: "acs",
    name: "Access Protocol",
    image:
      "https://assets.coingecko.com/coins/images/28747/large/dR4FovX4_400x400.jpg?1673860839",
    current_price: 0.00871925,
    market_cap: 258313596,
    market_cap_rank: 155,
    fully_diluted_valuation: 872013393,
    total_volume: 5671228,
    high_24h: 0.00922693,
    low_24h: 0.00847333,
    price_change_24h: -0.000363617484253741,
    price_change_percentage_24h: -4.00333,
    market_cap_change_24h: -10807664.022166193,
    market_cap_change_percentage_24h: -4.01591,
    circulating_supply: 29631917737.5816,
    total_supply: 100031239227.671,
    max_supply: null,
    ath: 0.02687893,
    ath_change_percentage: -67.58011,
    ath_date: "2023-02-16T01:23:46.316Z",
    atl: 0.00336715,
    atl_change_percentage: 158.79766,
    atl_date: "2023-03-04T23:14:13.064Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.373Z",
    price_change_percentage_14d_in_currency: -19.615078383646576,
    price_change_percentage_1h_in_currency: 0.5126198650449837,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: -4.003332922606102,
    price_change_percentage_30d_in_currency: 4.1150014480790595,
    price_change_percentage_7d_in_currency: -17.02751165735653,
  },
  {
    id: "chia",
    symbol: "xch",
    name: "Chia",
    image:
      "https://assets.coingecko.com/coins/images/15174/large/zV5K5y9f_400x400.png?1620024414",
    current_price: 37.37,
    market_cap: 257166127,
    market_cap_rank: 156,
    fully_diluted_valuation: null,
    total_volume: 5201429,
    high_24h: 38.84,
    low_24h: 37.04,
    price_change_24h: -1.3881373580599572,
    price_change_percentage_24h: -3.58157,
    market_cap_change_24h: -9137658.094242424,
    market_cap_change_percentage_24h: -3.43129,
    circulating_supply: 6880327.73692435,
    total_supply: 27880023.7273502,
    max_supply: null,
    ath: 1645.12,
    ath_change_percentage: -97.72989,
    ath_date: "2021-05-15T14:24:45.107Z",
    atl: 26.27,
    atl_change_percentage: 42.15497,
    atl_date: "2022-06-13T09:12:42.846Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.758Z",
    price_change_percentage_14d_in_currency: -3.1001054877607084,
    price_change_percentage_1h_in_currency: -0.0007227100547892423,
    price_change_percentage_1y_in_currency: -45.562498408067775,
    price_change_percentage_200d_in_currency: 6.371102659483328,
    price_change_percentage_24h_in_currency: -3.5815662102004495,
    price_change_percentage_30d_in_currency: -5.140119989799679,
    price_change_percentage_7d_in_currency: -4.029519076998805,
  },
  {
    id: "ssv-network",
    symbol: "ssv",
    name: "SSV Network",
    image:
      "https://assets.coingecko.com/coins/images/19155/large/ssv.png?1638181902",
    current_price: 35.9,
    market_cap: 254333079,
    market_cap_rank: 157,
    fully_diluted_valuation: 397593122,
    total_volume: 48966967,
    high_24h: 38.71,
    low_24h: 34.59,
    price_change_24h: -1.8047615712913156,
    price_change_percentage_24h: -4.786,
    market_cap_change_24h: -13167051.447335958,
    market_cap_change_percentage_24h: -4.92226,
    circulating_supply: 7085672.647228521,
    total_supply: 11076871,
    max_supply: null,
    ath: 49.52,
    ath_change_percentage: -27.53526,
    ath_date: "2023-02-27T23:15:10.196Z",
    atl: 3.67,
    atl_change_percentage: 877.48812,
    atl_date: "2022-06-18T20:56:57.599Z",
    roi: null,
    last_updated: "2023-03-27T23:31:46.942Z",
    price_change_percentage_14d_in_currency: 0.48864228844701224,
    price_change_percentage_1h_in_currency: 0.8603357087406427,
    price_change_percentage_1y_in_currency: 96.86302146546608,
    price_change_percentage_200d_in_currency: 138.68333458174672,
    price_change_percentage_24h_in_currency: -4.785996460551964,
    price_change_percentage_30d_in_currency: -5.149812095370603,
    price_change_percentage_7d_in_currency: -9.242944871359839,
  },
  {
    id: "ankr",
    symbol: "ankr",
    name: "Ankr Network",
    image:
      "https://assets.coingecko.com/coins/images/4324/large/U85xTl2.png?1608111978",
    current_price: 0.03093231,
    market_cap: 252513184,
    market_cap_rank: 158,
    fully_diluted_valuation: 309342518,
    total_volume: 35807983,
    high_24h: 0.03326372,
    low_24h: 0.03015258,
    price_change_24h: -0.001965946809186121,
    price_change_percentage_24h: -5.97584,
    market_cap_change_24h: -16267275.136769176,
    market_cap_change_percentage_24h: -6.05225,
    circulating_supply: 8162899377.791667,
    total_supply: 10000000000,
    max_supply: 10000000000,
    ath: 0.213513,
    ath_change_percentage: -85.48651,
    ath_date: "2021-04-16T19:44:04.474Z",
    atl: 0.00070728,
    atl_change_percentage: 4281.30878,
    atl_date: "2020-03-13T02:24:03.563Z",
    roi: {
      times: 3.6867141478694774,
      currency: "usd",
      percentage: 368.6714147869477,
    },
    last_updated: "2023-03-27T23:31:57.610Z",
    price_change_percentage_14d_in_currency: 1.6304701131334631,
    price_change_percentage_1h_in_currency: 0.20344399311858957,
    price_change_percentage_1y_in_currency: -63.737350596782086,
    price_change_percentage_200d_in_currency: -10.61296409691559,
    price_change_percentage_24h_in_currency: -5.975838230117246,
    price_change_percentage_30d_in_currency: -28.61005194434879,
    price_change_percentage_7d_in_currency: -15.672850584706232,
  },
  {
    id: "bone-shibaswap",
    symbol: "bone",
    name: "Bone ShibaSwap",
    image:
      "https://assets.coingecko.com/coins/images/16916/large/bone_icon.png?1625625505",
    current_price: 1.066,
    market_cap: 245177843,
    market_cap_rank: 159,
    fully_diluted_valuation: 266586387,
    total_volume: 5209794,
    high_24h: 1.12,
    low_24h: 1.059,
    price_change_24h: -0.050241586286286166,
    price_change_percentage_24h: -4.49962,
    market_cap_change_24h: -11654490.808001846,
    market_cap_change_percentage_24h: -4.53778,
    circulating_supply: 229923445.59824258,
    total_supply: 230003022.824847,
    max_supply: 250000000,
    ath: 15.5,
    ath_change_percentage: -93.11498,
    ath_date: "2021-07-07T02:52:33.198Z",
    atl: 0,
    atl_change_percentage: 1.201368353743567e37,
    atl_date: "2021-08-12T23:02:53.007Z",
    roi: null,
    last_updated: "2023-03-27T23:31:50.131Z",
    price_change_percentage_14d_in_currency: -29.333968610667938,
    price_change_percentage_1h_in_currency: -0.11864276415202431,
    price_change_percentage_1y_in_currency: 54.951973810163445,
    price_change_percentage_200d_in_currency: -40.89502860175217,
    price_change_percentage_24h_in_currency: -4.499621500841566,
    price_change_percentage_30d_in_currency: -41.79216683617031,
    price_change_percentage_7d_in_currency: -13.813401170062095,
  },
  {
    id: "omisego",
    symbol: "omg",
    name: "OMG Network",
    image:
      "https://assets.coingecko.com/coins/images/776/large/OMG_Network.jpg?1591167168",
    current_price: 1.75,
    market_cap: 244889759,
    market_cap_rank: 160,
    fully_diluted_valuation: 244889759,
    total_volume: 30879574,
    high_24h: 1.86,
    low_24h: 1.71,
    price_change_24h: -0.11206539304965779,
    price_change_percentage_24h: -6.02782,
    market_cap_change_24h: -15195418.873301953,
    market_cap_change_percentage_24h: -5.84248,
    circulating_supply: 140245398.245133,
    total_supply: 140245398.245133,
    max_supply: 140245398.245133,
    ath: 25.62,
    ath_change_percentage: -93.18444,
    ath_date: "2018-01-13T00:00:00.000Z",
    atl: 0.350917,
    atl_change_percentage: 397.6089,
    atl_date: "2020-03-13T02:30:10.072Z",
    roi: null,
    last_updated: "2023-03-27T23:31:48.961Z",
    price_change_percentage_14d_in_currency: 28.947592875631784,
    price_change_percentage_1h_in_currency: 0.7744840790201203,
    price_change_percentage_1y_in_currency: -66.35026359958782,
    price_change_percentage_200d_in_currency: -3.540251919665645,
    price_change_percentage_24h_in_currency: -6.0278155127742306,
    price_change_percentage_30d_in_currency: 2.190937671660247,
    price_change_percentage_7d_in_currency: -25.72120405463938,
  },
  {
    id: "huobi-btc",
    symbol: "hbtc",
    name: "Huobi BTC",
    image:
      "https://assets.coingecko.com/coins/images/12407/large/Unknown-5.png?1599624896",
    current_price: 27143,
    market_cap: 243457841,
    market_cap_rank: 161,
    fully_diluted_valuation: 243457841,
    total_volume: 40175,
    high_24h: 28129,
    low_24h: 26288,
    price_change_24h: -969.5467897222625,
    price_change_percentage_24h: -3.44882,
    market_cap_change_24h: -7428043.655154437,
    market_cap_change_percentage_24h: -2.96073,
    circulating_supply: 8969.497004742,
    total_supply: 8969.497004742,
    max_supply: 8969.497004742,
    ath: 166135,
    ath_change_percentage: -83.76235,
    ath_date: "2022-04-21T18:59:43.859Z",
    atl: 10704.55,
    atl_change_percentage: 152.00855,
    atl_date: "2023-03-10T01:30:46.660Z",
    roi: null,
    last_updated: "2023-03-27T23:29:40.298Z",
    price_change_percentage_14d_in_currency: 23.593177503479655,
    price_change_percentage_1h_in_currency: 0.35265545232665774,
    price_change_percentage_1y_in_currency: -39.00274691246595,
    price_change_percentage_200d_in_currency: 39.30327780074906,
    price_change_percentage_24h_in_currency: -3.448821167266273,
    price_change_percentage_30d_in_currency: 14.507383186906731,
    price_change_percentage_7d_in_currency: -3.385625761774836,
  },
  {
    id: "dao-maker",
    symbol: "dao",
    name: "DAO Maker",
    image:
      "https://assets.coingecko.com/coins/images/13915/large/4.png?1612838831",
    current_price: 1.59,
    market_cap: 237400006,
    market_cap_rank: 162,
    fully_diluted_valuation: 441234140,
    total_volume: 2328401,
    high_24h: 1.61,
    low_24h: 1.57,
    price_change_24h: -0.01745317609433195,
    price_change_percentage_24h: -1.08585,
    market_cap_change_24h: -2177295.452831626,
    market_cap_change_percentage_24h: -0.90881,
    circulating_supply: 149318000,
    total_supply: 277524000,
    max_supply: 277524000,
    ath: 8.71,
    ath_change_percentage: -81.74236,
    ath_date: "2021-04-21T17:13:06.858Z",
    atl: 0.764723,
    atl_change_percentage: 107.97906,
    atl_date: "2022-11-14T03:16:24.229Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.759Z",
    price_change_percentage_14d_in_currency: -11.272810904055614,
    price_change_percentage_1h_in_currency: -0.5425840185161587,
    price_change_percentage_1y_in_currency: -37.577694656244724,
    price_change_percentage_200d_in_currency: -9.833637755946883,
    price_change_percentage_24h_in_currency: -1.0858497851027122,
    price_change_percentage_30d_in_currency: 14.599541787156692,
    price_change_percentage_7d_in_currency: -9.004295653964443,
  },
  {
    id: "harmony",
    symbol: "one",
    name: "Harmony",
    image:
      "https://assets.coingecko.com/coins/images/4344/large/Y88JAze.png?1565065793",
    current_price: 0.01917305,
    market_cap: 235879437,
    market_cap_rank: 163,
    fully_diluted_valuation: 252184721,
    total_volume: 27616713,
    high_24h: 0.0206874,
    low_24h: 0.01886263,
    price_change_24h: -0.001488110396951431,
    price_change_percentage_24h: -7.20245,
    market_cap_change_24h: -18352067.310879856,
    market_cap_change_percentage_24h: -7.21864,
    circulating_supply: 12305426115.0007,
    total_supply: 13156044839.793139,
    max_supply: 13156044839.793139,
    ath: 0.37902,
    ath_change_percentage: -94.94332,
    ath_date: "2021-10-26T09:28:49.782Z",
    atl: 0.00127355,
    atl_change_percentage: 1404.91207,
    atl_date: "2020-03-13T02:24:14.005Z",
    roi: {
      times: 5.038755151130428,
      currency: "usd",
      percentage: 503.8755151130428,
    },
    last_updated: "2023-03-27T23:31:57.331Z",
    price_change_percentage_14d_in_currency: 6.997659533987975,
    price_change_percentage_1h_in_currency: 0.5352838500598237,
    price_change_percentage_1y_in_currency: -87.30238368647122,
    price_change_percentage_200d_in_currency: -3.4037962251798297,
    price_change_percentage_24h_in_currency: -7.202453980664915,
    price_change_percentage_30d_in_currency: -13.50190359586766,
    price_change_percentage_7d_in_currency: -12.801869987450615,
  },
  {
    id: "stepn",
    symbol: "gmt",
    name: "STEPN",
    image:
      "https://assets.coingecko.com/coins/images/23597/large/gmt.png?1644658792",
    current_price: 0.368425,
    market_cap: 232785076,
    market_cap_rank: 164,
    fully_diluted_valuation: 2208431970,
    total_volume: 64516825,
    high_24h: 0.395407,
    low_24h: 0.356841,
    price_change_24h: -0.0266614899905267,
    price_change_percentage_24h: -6.74826,
    market_cap_change_24h: -16043606.08711052,
    market_cap_change_percentage_24h: -6.44765,
    circulating_supply: 632444411.899396,
    total_supply: 5550411081.8994,
    max_supply: 6000000000,
    ath: 4.11,
    ath_change_percentage: -91.04186,
    ath_date: "2022-04-28T03:29:53.820Z",
    atl: 0.100826,
    atl_change_percentage: 264.92778,
    atl_date: "2022-03-11T06:04:31.100Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.173Z",
    price_change_percentage_14d_in_currency: 6.747174426597416,
    price_change_percentage_1h_in_currency: -0.09611759160757419,
    price_change_percentage_1y_in_currency: -51.637779292555955,
    price_change_percentage_200d_in_currency: -43.524642731038966,
    price_change_percentage_24h_in_currency: -6.748261624340931,
    price_change_percentage_30d_in_currency: -6.03415745288259,
    price_change_percentage_7d_in_currency: -18.111093277889523,
  },
  {
    id: "astrafer",
    symbol: "astrafer",
    name: "Astrafer",
    image:
      "https://assets.coingecko.com/coins/images/26246/large/ATSRA_Token.png?1657276411",
    current_price: 1.48,
    market_cap: 232322641,
    market_cap_rank: 165,
    fully_diluted_valuation: 1318464441,
    total_volume: 21346,
    high_24h: 1.55,
    low_24h: 1.47,
    price_change_24h: -0.06668653667751978,
    price_change_percentage_24h: -4.30379,
    market_cap_change_24h: -10124332.77651906,
    market_cap_change_percentage_24h: -4.1759,
    circulating_supply: 156485525.3,
    total_supply: 888077888,
    max_supply: 888077888,
    ath: 4.88,
    ath_change_percentage: -69.5593,
    ath_date: "2022-09-11T19:47:43.631Z",
    atl: 1.38,
    atl_change_percentage: 7.40938,
    atl_date: "2023-03-11T16:31:47.266Z",
    roi: null,
    last_updated: "2023-03-27T23:31:39.006Z",
    price_change_percentage_14d_in_currency: -4.8912846726440256,
    price_change_percentage_1h_in_currency: 0.01729540009862988,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: -55.71115391427705,
    price_change_percentage_24h_in_currency: -4.303792164273174,
    price_change_percentage_30d_in_currency: -20.962734570706246,
    price_change_percentage_7d_in_currency: -11.597990683722594,
  },
  {
    id: "escoin-token",
    symbol: "elg",
    name: "Escoin",
    image:
      "https://assets.coingecko.com/coins/images/13566/large/escoin-200.png?1609833886",
    current_price: 2.83,
    market_cap: 228752259,
    market_cap_rank: 166,
    fully_diluted_valuation: null,
    total_volume: 407239,
    high_24h: 2.84,
    low_24h: 2.79,
    price_change_24h: -0.016430788752391567,
    price_change_percentage_24h: -0.57811,
    market_cap_change_24h: 10734340,
    market_cap_change_percentage_24h: 4.9236,
    circulating_supply: 0,
    total_supply: 250000000,
    max_supply: null,
    ath: 3.61,
    ath_change_percentage: -21.84525,
    ath_date: "2022-06-24T02:40:08.448Z",
    atl: 0.00064644,
    atl_change_percentage: 436357.6021,
    atl_date: "2021-01-10T16:54:16.852Z",
    roi: null,
    last_updated: "2023-03-27T23:29:47.704Z",
    price_change_percentage_14d_in_currency: -0.6269356444788557,
    price_change_percentage_1h_in_currency: 0.13862870304133196,
    price_change_percentage_1y_in_currency: -14.272771442288851,
    price_change_percentage_200d_in_currency: -8.44834264920657,
    price_change_percentage_24h_in_currency: -0.578108255437619,
    price_change_percentage_30d_in_currency: -2.1833113535519875,
    price_change_percentage_7d_in_currency: -0.8072161733726466,
  },
  {
    id: "convex-crv",
    symbol: "cvxcrv",
    name: "Convex CRV",
    image:
      "https://assets.coingecko.com/coins/images/15586/large/convex-crv.png?1621255952",
    current_price: 0.784547,
    market_cap: 228223773,
    market_cap_rank: 167,
    fully_diluted_valuation: null,
    total_volume: 199666,
    high_24h: 0.820278,
    low_24h: 0.759764,
    price_change_24h: -0.02884545672301131,
    price_change_percentage_24h: -3.54632,
    market_cap_change_24h: -8361867.50576973,
    market_cap_change_percentage_24h: -3.53439,
    circulating_supply: 290898915.841089,
    total_supply: 290898915.841089,
    max_supply: null,
    ath: 6.48,
    ath_change_percentage: -87.88279,
    ath_date: "2022-01-03T14:01:45.955Z",
    atl: 0.393069,
    atl_change_percentage: 99.64659,
    atl_date: "2022-11-22T11:23:02.517Z",
    roi: null,
    last_updated: "2023-03-27T23:31:34.824Z",
    price_change_percentage_14d_in_currency: -4.277734830671678,
    price_change_percentage_1h_in_currency: -0.006140023653115615,
    price_change_percentage_1y_in_currency: -66.92514884259755,
    price_change_percentage_200d_in_currency: -26.2661496422202,
    price_change_percentage_24h_in_currency: -3.546316233942587,
    price_change_percentage_30d_in_currency: -9.089742259060776,
    price_change_percentage_7d_in_currency: -15.7894799584539,
  },
  {
    id: "iotex",
    symbol: "iotx",
    name: "IoTeX",
    image:
      "https://assets.coingecko.com/coins/images/3334/large/iotex-logo.png?1547037941",
    current_price: 0.02413554,
    market_cap: 228050991,
    market_cap_rank: 168,
    fully_diluted_valuation: 229197505,
    total_volume: 15811185,
    high_24h: 0.02537605,
    low_24h: 0.02387256,
    price_change_24h: -0.000845053218678261,
    price_change_percentage_24h: -3.38284,
    market_cap_change_24h: -8074371.056343496,
    market_cap_change_percentage_24h: -3.41953,
    circulating_supply: 9448763702,
    total_supply: 9496266827.32,
    max_supply: 9496266827.32,
    ath: 0.255593,
    ath_change_percentage: -90.56163,
    ath_date: "2021-11-13T16:54:18.643Z",
    atl: 0.00121576,
    atl_change_percentage: 1884.25802,
    atl_date: "2020-03-13T02:29:47.597Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.246Z",
    price_change_percentage_14d_in_currency: -0.0065155931312977184,
    price_change_percentage_1h_in_currency: -0.17455714882392623,
    price_change_percentage_1y_in_currency: -73.61837564350186,
    price_change_percentage_200d_in_currency: -13.76725264913092,
    price_change_percentage_24h_in_currency: -3.3828392075929927,
    price_change_percentage_30d_in_currency: -14.384092445705049,
    price_change_percentage_7d_in_currency: -8.471851658030348,
  },
  {
    id: "golem",
    symbol: "glm",
    name: "Golem",
    image:
      "https://assets.coingecko.com/coins/images/542/large/Golem_Submark_Positive_RGB.png?1606392013",
    current_price: 0.22741,
    market_cap: 227413592,
    market_cap_rank: 169,
    fully_diluted_valuation: null,
    total_volume: 3639273,
    high_24h: 0.240119,
    low_24h: 0.223664,
    price_change_24h: -0.012708449815102135,
    price_change_percentage_24h: -5.29257,
    market_cap_change_24h: -12478141.149558485,
    market_cap_change_percentage_24h: -5.20157,
    circulating_supply: 1000000000,
    total_supply: 1000000000,
    max_supply: null,
    ath: 1.32,
    ath_change_percentage: -82.82019,
    ath_date: "2018-04-13T09:13:22.739Z",
    atl: 0.00913753,
    atl_change_percentage: 2389.87642,
    atl_date: "2016-12-12T00:00:00.000Z",
    roi: {
      times: 21.74101355937989,
      currency: "usd",
      percentage: 2174.101355937989,
    },
    last_updated: "2023-03-27T23:31:57.178Z",
    price_change_percentage_14d_in_currency: 1.147868908988235,
    price_change_percentage_1h_in_currency: -0.03557856954601656,
    price_change_percentage_1y_in_currency: -56.15974249207453,
    price_change_percentage_200d_in_currency: -1.794692202873275,
    price_change_percentage_24h_in_currency: -5.292572331900403,
    price_change_percentage_30d_in_currency: -20.456224591844077,
    price_change_percentage_7d_in_currency: -10.864022666707807,
  },
  {
    id: "blox",
    symbol: "cdt",
    name: "Blox",
    image:
      "https://assets.coingecko.com/coins/images/1231/large/Blox_Staking_Logo_2.png?1609117544",
    current_price: 0.333706,
    market_cap: 225111074,
    market_cap_rank: 170,
    fully_diluted_valuation: null,
    total_volume: 112136,
    high_24h: 0.438225,
    low_24h: 0.308221,
    price_change_24h: -0.06652279505048547,
    price_change_percentage_24h: -16.62119,
    market_cap_change_24h: -44490263.67871699,
    market_cap_change_percentage_24h: -16.50224,
    circulating_supply: 674579184.17,
    total_supply: 1000000000,
    max_supply: null,
    ath: 0.502216,
    ath_change_percentage: -33.59357,
    ath_date: "2023-03-21T14:15:03.845Z",
    atl: 0.00164788,
    atl_change_percentage: 20138.30332,
    atl_date: "2020-03-13T02:24:15.284Z",
    roi: {
      times: 0.18506904906229343,
      currency: "eth",
      percentage: 18.506904906229344,
    },
    last_updated: "2023-03-27T23:28:19.856Z",
    price_change_percentage_14d_in_currency: -18.249396762060915,
    price_change_percentage_1h_in_currency: 5.2089842268955096,
    price_change_percentage_1y_in_currency: 175.15224530545177,
    price_change_percentage_200d_in_currency: 175.33223179706528,
    price_change_percentage_24h_in_currency: -16.6211945569431,
    price_change_percentage_30d_in_currency: 8.62112100576219,
    price_change_percentage_7d_in_currency: -23.53508746741134,
  },
  {
    id: "tether-eurt",
    symbol: "eurt",
    name: "Euro Tether",
    image:
      "https://assets.coingecko.com/coins/images/17385/large/Tether_full_logo_dm.png?1627537298",
    current_price: 1.085,
    market_cap: 223283738,
    market_cap_rank: 171,
    fully_diluted_valuation: 433563173,
    total_volume: 1343145,
    high_24h: 1.087,
    low_24h: 1.071,
    price_change_24h: 0.00711639,
    price_change_percentage_24h: 0.66051,
    market_cap_change_24h: 942915,
    market_cap_change_percentage_24h: 0.42409,
    circulating_supply: 205998829.98,
    total_supply: 400000050,
    max_supply: 400000050,
    ath: 1.31,
    ath_change_percentage: -17.14941,
    ath_date: "2021-09-02T00:28:44.121Z",
    atl: 0.944541,
    atl_change_percentage: 14.65879,
    atl_date: "2022-09-27T16:30:27.333Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.458Z",
    price_change_percentage_14d_in_currency: 1.764643363315048,
    price_change_percentage_1h_in_currency: 0.13527509482775513,
    price_change_percentage_1y_in_currency: -0.988185397845158,
    price_change_percentage_200d_in_currency: 8.478762352746962,
    price_change_percentage_24h_in_currency: 0.6605092439403483,
    price_change_percentage_30d_in_currency: 2.926254648462859,
    price_change_percentage_7d_in_currency: 1.574700781112033,
  },
  {
    id: "just",
    symbol: "jst",
    name: "JUST",
    image:
      "https://assets.coingecko.com/coins/images/11095/large/JUST.jpg?1588175394",
    current_price: 0.02501404,
    market_cap: 222676992,
    market_cap_rank: 172,
    fully_diluted_valuation: 247639003,
    total_volume: 23442925,
    high_24h: 0.026009,
    low_24h: 0.02459008,
    price_change_24h: -0.000992544891006111,
    price_change_percentage_24h: -3.81651,
    market_cap_change_24h: -8909250.680712283,
    market_cap_change_percentage_24h: -3.84706,
    circulating_supply: 8902080000,
    total_supply: 9900000000,
    max_supply: 9900000000,
    ath: 0.193254,
    ath_change_percentage: -87.07183,
    ath_date: "2021-04-05T04:34:23.454Z",
    atl: 0.00476275,
    atl_change_percentage: 424.57576,
    atl_date: "2020-05-09T06:08:54.872Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.542Z",
    price_change_percentage_14d_in_currency: 1.2165204537979064,
    price_change_percentage_1h_in_currency: 0.18640321855494113,
    price_change_percentage_1y_in_currency: -58.70190080659828,
    price_change_percentage_200d_in_currency: -3.755035149664069,
    price_change_percentage_24h_in_currency: -3.8165136546385696,
    price_change_percentage_30d_in_currency: -16.135155513139015,
    price_change_percentage_7d_in_currency: -11.243128210094756,
  },
  {
    id: "moonbeam",
    symbol: "glmr",
    name: "Moonbeam",
    image:
      "https://assets.coingecko.com/coins/images/22459/large/glmr.png?1641880985",
    current_price: 0.363882,
    market_cap: 219690098,
    market_cap_rank: 173,
    fully_diluted_valuation: 384742481,
    total_volume: 8240729,
    high_24h: 0.382449,
    low_24h: 0.357568,
    price_change_24h: -0.017168622007069756,
    price_change_percentage_24h: -4.5056,
    market_cap_change_24h: -10965888.21568042,
    market_cap_change_percentage_24h: -4.75422,
    circulating_supply: 605891014,
    total_supply: 1061094758,
    max_supply: null,
    ath: 19.5,
    ath_change_percentage: -98.14084,
    ath_date: "2022-01-11T14:57:46.115Z",
    atl: 0.314413,
    atl_change_percentage: 15.30407,
    atl_date: "2023-01-06T09:55:46.165Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.141Z",
    price_change_percentage_14d_in_currency: -3.47087722039946,
    price_change_percentage_1h_in_currency: 0.20547897538770143,
    price_change_percentage_1y_in_currency: -86.88769266320105,
    price_change_percentage_200d_in_currency: -27.21256716431061,
    price_change_percentage_24h_in_currency: -4.505601360118306,
    price_change_percentage_30d_in_currency: -20.162567992987253,
    price_change_percentage_7d_in_currency: -14.952469344242095,
  },
  {
    id: "frax-ether",
    symbol: "frxeth",
    name: "Frax Ether",
    image:
      "https://assets.coingecko.com/coins/images/28284/large/frxETH_icon.png?1679886981",
    current_price: 1715.17,
    market_cap: 215760272,
    market_cap_rank: 174,
    fully_diluted_valuation: 215760272,
    total_volume: 2708673,
    high_24h: 1781.72,
    low_24h: 1695.84,
    price_change_24h: -66.29645593449436,
    price_change_percentage_24h: -3.72145,
    market_cap_change_24h: -8176133.524854898,
    market_cap_change_percentage_24h: -3.6511,
    circulating_supply: 125802.666762156,
    total_supply: 125802.666762156,
    max_supply: null,
    ath: 1853.41,
    ath_change_percentage: -7.47714,
    ath_date: "2023-03-23T15:40:57.763Z",
    atl: 1137.25,
    atl_change_percentage: 50.78772,
    atl_date: "2022-11-23T02:25:33.267Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.791Z",
    price_change_percentage_14d_in_currency: 8.182557753827567,
    price_change_percentage_1h_in_currency: 0.13350591246171242,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: -3.721448978584496,
    price_change_percentage_30d_in_currency: 6.733316072135452,
    price_change_percentage_7d_in_currency: -4.97723843912271,
  },
  {
    id: "ecomi",
    symbol: "omi",
    name: "ECOMI",
    image:
      "https://assets.coingecko.com/coins/images/4428/large/ECOMI.png?1557928886",
    current_price: 0.00078882,
    market_cap: 213507424,
    market_cap_rank: 175,
    fully_diluted_valuation: 591614012,
    total_volume: 854470,
    high_24h: 0.00080772,
    low_24h: 0.00078332,
    price_change_24h: -0.000013943073080029,
    price_change_percentage_24h: -1.73689,
    market_cap_change_24h: -3339448.9941343963,
    market_cap_change_percentage_24h: -1.54,
    circulating_supply: 270667301117.746,
    total_supply: 311372314135.336,
    max_supply: 750000000000,
    ath: 0.01343572,
    ath_change_percentage: -94.13197,
    ath_date: "2021-03-19T17:20:53.999Z",
    atl: 0.00000337,
    atl_change_percentage: 23288.40411,
    atl_date: "2019-11-04T10:52:42.729Z",
    roi: {
      times: 1.901423620096507,
      currency: "btc",
      percentage: 190.1423620096507,
    },
    last_updated: "2023-03-27T23:31:46.908Z",
    price_change_percentage_14d_in_currency: -10.280106468267022,
    price_change_percentage_1h_in_currency: -0.2182093372021985,
    price_change_percentage_1y_in_currency: -73.40091579998247,
    price_change_percentage_200d_in_currency: -41.01976494214401,
    price_change_percentage_24h_in_currency: -1.7368880593455598,
    price_change_percentage_30d_in_currency: -24.76884614351328,
    price_change_percentage_7d_in_currency: -8.928081760986375,
  },
  {
    id: "blur",
    symbol: "blur",
    name: "Blur",
    image:
      "https://assets.coingecko.com/coins/images/28453/large/blur.png?1670745921",
    current_price: 0.505035,
    market_cap: 212744892,
    market_cap_rank: 176,
    fully_diluted_valuation: 1515111609,
    total_volume: 39452030,
    high_24h: 0.541304,
    low_24h: 0.496242,
    price_change_24h: -0.033173302456493525,
    price_change_percentage_24h: -6.16365,
    market_cap_change_24h: -13198411.239369243,
    market_cap_change_percentage_24h: -5.84147,
    circulating_supply: 421245981.73516,
    total_supply: 3000000000,
    max_supply: 3000000000,
    ath: 5.02,
    ath_change_percentage: -89.93927,
    ath_date: "2023-02-14T17:33:55.928Z",
    atl: 0.448217,
    atl_change_percentage: 12.59529,
    atl_date: "2023-03-12T15:46:10.368Z",
    roi: null,
    last_updated: "2023-03-27T23:31:51.779Z",
    price_change_percentage_14d_in_currency: -6.222415164217178,
    price_change_percentage_1h_in_currency: -0.2151872075848985,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: -6.163649394418363,
    price_change_percentage_30d_in_currency: -38.44296947609628,
    price_change_percentage_7d_in_currency: -13.428628715640514,
  },
  {
    id: "gains-network",
    symbol: "gns",
    name: "Gains Network",
    image:
      "https://assets.coingecko.com/coins/images/19737/large/logo.png?1635909203",
    current_price: 6.95,
    market_cap: 211522120,
    market_cap_rank: 177,
    fully_diluted_valuation: 211522120,
    total_volume: 14458951,
    high_24h: 7.33,
    low_24h: 6.69,
    price_change_24h: -0.37460973896830385,
    price_change_percentage_24h: -5.11496,
    market_cap_change_24h: -11534170.08969596,
    market_cap_change_percentage_24h: -5.17097,
    circulating_supply: 30438342,
    total_supply: 30438342,
    max_supply: 30438342,
    ath: 12.48,
    ath_change_percentage: -44.35034,
    ath_date: "2023-02-17T07:55:07.998Z",
    atl: 0.265841,
    atl_change_percentage: 2512.30762,
    atl_date: "2021-11-29T05:56:42.899Z",
    roi: null,
    last_updated: "2023-03-27T23:31:43.090Z",
    price_change_percentage_14d_in_currency: 4.401219818527955,
    price_change_percentage_1h_in_currency: -0.0020457301526043293,
    price_change_percentage_1y_in_currency: 183.75924585881117,
    price_change_percentage_200d_in_currency: 323.03548673087,
    price_change_percentage_24h_in_currency: -5.114957422948292,
    price_change_percentage_30d_in_currency: -16.746600208426162,
    price_change_percentage_7d_in_currency: -22.624783067856075,
  },
  {
    id: "jasmycoin",
    symbol: "jasmy",
    name: "JasmyCoin",
    image:
      "https://assets.coingecko.com/coins/images/13876/large/JASMY200x200.jpg?1612473259",
    current_price: 0.00440403,
    market_cap: 209499902,
    market_cap_rank: 178,
    fully_diluted_valuation: 220201704,
    total_volume: 39756814,
    high_24h: 0.00466827,
    low_24h: 0.00432256,
    price_change_24h: -0.000258647171625786,
    price_change_percentage_24h: -5.54718,
    market_cap_change_24h: -12377051.410050929,
    market_cap_change_percentage_24h: -5.57834,
    circulating_supply: 47569999999.3058,
    total_supply: 50000000000,
    max_supply: 50000000000,
    ath: 4.79,
    ath_change_percentage: -99.90825,
    ath_date: "2021-02-16T03:53:32.207Z",
    atl: 0.00275026,
    atl_change_percentage: 59.7917,
    atl_date: "2022-12-29T20:41:09.113Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.567Z",
    price_change_percentage_14d_in_currency: -16.397068925598376,
    price_change_percentage_1h_in_currency: 0.4500417935341866,
    price_change_percentage_1y_in_currency: -87.87804048065323,
    price_change_percentage_200d_in_currency: -50.50715400621646,
    price_change_percentage_24h_in_currency: -5.547176768144029,
    price_change_percentage_30d_in_currency: -28.834103024196377,
    price_change_percentage_7d_in_currency: -13.271619060533773,
  },
  {
    id: "terrausd",
    symbol: "ustc",
    name: "TerraClassicUSD",
    image:
      "https://assets.coingecko.com/coins/images/12681/large/UST.png?1653548090",
    current_price: 0.02122506,
    market_cap: 207811584,
    market_cap_rank: 179,
    fully_diluted_valuation: null,
    total_volume: 10191668,
    high_24h: 0.02247107,
    low_24h: 0.02083861,
    price_change_24h: -0.001213693706315952,
    price_change_percentage_24h: -5.40892,
    market_cap_change_24h: -13468077.253640145,
    market_cap_change_percentage_24h: -6.08645,
    circulating_supply: 9796956226.19144,
    total_supply: 9799265233.13189,
    max_supply: null,
    ath: 1.092,
    ath_change_percentage: -98.05737,
    ath_date: "2021-01-11T22:30:57.984Z",
    atl: 0.00601921,
    atl_change_percentage: 252.39973,
    atl_date: "2022-06-18T20:35:39.169Z",
    roi: null,
    last_updated: "2023-03-27T23:31:51.879Z",
    price_change_percentage_14d_in_currency: -7.440194608721819,
    price_change_percentage_1h_in_currency: -0.006282934451824518,
    price_change_percentage_1y_in_currency: -97.87739320166887,
    price_change_percentage_200d_in_currency: -48.59140930665417,
    price_change_percentage_24h_in_currency: -5.408917065734623,
    price_change_percentage_30d_in_currency: -21.50661086488093,
    price_change_percentage_7d_in_currency: -9.886075164291347,
  },
  {
    id: "band-protocol",
    symbol: "band",
    name: "Band Protocol",
    image:
      "https://assets.coingecko.com/coins/images/9545/large/Band_token_blue_violet_token.png?1625881431",
    current_price: 1.66,
    market_cap: 206123907,
    market_cap_rank: 181,
    fully_diluted_valuation: 220743038,
    total_volume: 12842068,
    high_24h: 1.77,
    low_24h: 1.62,
    price_change_24h: -0.09542503505071263,
    price_change_percentage_24h: -5.43151,
    market_cap_change_24h: -11732136.063176364,
    market_cap_change_percentage_24h: -5.38527,
    circulating_supply: 124062133.37706,
    total_supply: 132861115.879291,
    max_supply: null,
    ath: 22.83,
    ath_change_percentage: -92.73943,
    ath_date: "2021-04-15T12:04:11.270Z",
    atl: 0.203625,
    atl_change_percentage: 714.01245,
    atl_date: "2019-11-25T05:49:22.765Z",
    roi: {
      times: 2.512587227278091,
      currency: "usd",
      percentage: 251.2587227278091,
    },
    last_updated: "2023-03-27T23:31:45.978Z",
    price_change_percentage_14d_in_currency: 4.369488539149892,
    price_change_percentage_1h_in_currency: 1.3080006451702513,
    price_change_percentage_1y_in_currency: -60.32517625597046,
    price_change_percentage_200d_in_currency: 29.734507504795225,
    price_change_percentage_24h_in_currency: -5.4315092993818626,
    price_change_percentage_30d_in_currency: -16.927131357183438,
    price_change_percentage_7d_in_currency: -9.993784326409052,
  },
  {
    id: "kadena",
    symbol: "kda",
    name: "Kadena",
    image:
      "https://assets.coingecko.com/coins/images/3693/large/djLWD6mR_400x400.jpg?1591080616",
    current_price: 0.917715,
    market_cap: 205886477,
    market_cap_rank: 180,
    fully_diluted_valuation: 917715404,
    total_volume: 6633812,
    high_24h: 0.952606,
    low_24h: 0.902843,
    price_change_24h: -0.034723478302773,
    price_change_percentage_24h: -3.64574,
    market_cap_change_24h: -7727906.926310688,
    market_cap_change_percentage_24h: -3.61769,
    circulating_supply: 224346759.15625,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 27.64,
    ath_change_percentage: -96.6792,
    ath_date: "2021-11-11T13:22:45.731Z",
    atl: 0.065811,
    atl_change_percentage: 1294.47722,
    atl_date: "2020-03-13T02:00:28.582Z",
    roi: {
      times: -0.0822845964211386,
      currency: "usd",
      percentage: -8.22845964211386,
    },
    last_updated: "2023-03-27T23:31:49.295Z",
    price_change_percentage_14d_in_currency: -7.07691059148547,
    price_change_percentage_1h_in_currency: -0.011800477235584854,
    price_change_percentage_1y_in_currency: -86.38516691609134,
    price_change_percentage_200d_in_currency: -39.19744230989884,
    price_change_percentage_24h_in_currency: -3.645743465887642,
    price_change_percentage_30d_in_currency: -19.31809481380487,
    price_change_percentage_7d_in_currency: -14.076185759024288,
  },
  {
    id: "liquity",
    symbol: "lqty",
    name: "Liquity",
    image:
      "https://assets.coingecko.com/coins/images/14665/large/200-lqty-icon.png?1617631180",
    current_price: 2.25,
    market_cap: 204841408,
    market_cap_rank: 182,
    fully_diluted_valuation: 223928843,
    total_volume: 78004955,
    high_24h: 2.29,
    low_24h: 2.05,
    price_change_24h: 0.110364,
    price_change_percentage_24h: 5.16358,
    market_cap_change_24h: 9591017,
    market_cap_change_percentage_24h: 4.91216,
    circulating_supply: 91476116.2517723,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 146.94,
    ath_change_percentage: -98.47602,
    ath_date: "2021-04-05T21:48:37.754Z",
    atl: 0.54399,
    atl_change_percentage: 311.65817,
    atl_date: "2022-11-14T07:05:51.360Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.815Z",
    price_change_percentage_14d_in_currency: 3.825138455239023,
    price_change_percentage_1h_in_currency: 1.3048573728409834,
    price_change_percentage_1y_in_currency: -14.615493244002495,
    price_change_percentage_200d_in_currency: 153.52586956046122,
    price_change_percentage_24h_in_currency: 5.163577771171988,
    price_change_percentage_30d_in_currency: 121.68539098869444,
    price_change_percentage_7d_in_currency: -8.68112358152879,
  },
  {
    id: "amp-token",
    symbol: "amp",
    name: "Amp",
    image:
      "https://assets.coingecko.com/coins/images/12409/large/amp-200x200.png?1599625397",
    current_price: 0.0036366,
    market_cap: 204218757,
    market_cap_rank: 184,
    fully_diluted_valuation: 361829104,
    total_volume: 4497800,
    high_24h: 0.00380194,
    low_24h: 0.00360135,
    price_change_24h: -0.000164254633538656,
    price_change_percentage_24h: -4.32152,
    market_cap_change_24h: -8953840.903685331,
    market_cap_change_percentage_24h: -4.20028,
    circulating_supply: 56127938240.441696,
    total_supply: 99445917141.1247,
    max_supply: 99445917141.1247,
    ath: 0.120813,
    ath_change_percentage: -96.98974,
    ath_date: "2021-06-16T16:03:41.147Z",
    atl: 0.00250501,
    atl_change_percentage: 45.17966,
    atl_date: "2020-11-04T13:18:12.191Z",
    roi: null,
    last_updated: "2023-03-27T23:31:54.904Z",
    price_change_percentage_14d_in_currency: -16.186869674983527,
    price_change_percentage_1h_in_currency: 0.12752400586973728,
    price_change_percentage_1y_in_currency: -86.26909456850039,
    price_change_percentage_200d_in_currency: -34.86223771478618,
    price_change_percentage_24h_in_currency: -4.321521183828076,
    price_change_percentage_30d_in_currency: -46.921741593944695,
    price_change_percentage_7d_in_currency: -13.09721013333332,
  },
  {
    id: "waves",
    symbol: "waves",
    name: "Waves",
    image:
      "https://assets.coingecko.com/coins/images/425/large/waves.png?1548386117",
    current_price: 2.04,
    market_cap: 204192101,
    market_cap_rank: 183,
    fully_diluted_valuation: 204192101,
    total_volume: 28406126,
    high_24h: 2.17,
    low_24h: 2,
    price_change_24h: -0.12334024670639288,
    price_change_percentage_24h: -5.69245,
    market_cap_change_24h: -12749612.781216979,
    market_cap_change_percentage_24h: -5.87698,
    circulating_supply: 100000000,
    total_supply: 100000000,
    max_supply: null,
    ath: 61.3,
    ath_change_percentage: -96.66873,
    ath_date: "2022-03-31T14:34:44.545Z",
    atl: 0.130878,
    atl_change_percentage: 1460.34117,
    atl_date: "2016-08-02T00:00:00.000Z",
    roi: {
      times: 9.869107396907191,
      currency: "usd",
      percentage: 986.9107396907192,
    },
    last_updated: "2023-03-27T23:31:42.729Z",
    price_change_percentage_14d_in_currency: -3.252167541467647,
    price_change_percentage_1h_in_currency: 0.64129570926436,
    price_change_percentage_1y_in_currency: -93.73751222275654,
    price_change_percentage_200d_in_currency: -53.88027372244337,
    price_change_percentage_24h_in_currency: -5.692453972705054,
    price_change_percentage_30d_in_currency: -20.83665479587198,
    price_change_percentage_7d_in_currency: -14.077799940664102,
  },
  {
    id: "siacoin",
    symbol: "sc",
    name: "Siacoin",
    image:
      "https://assets.coingecko.com/coins/images/289/large/siacoin.png?1548386465",
    current_price: 0.00381641,
    market_cap: 196701556,
    market_cap_rank: 185,
    fully_diluted_valuation: null,
    total_volume: 5705977,
    high_24h: 0.00407962,
    low_24h: 0.00375154,
    price_change_24h: -0.000249283926488492,
    price_change_percentage_24h: -6.13141,
    market_cap_change_24h: -12940595.997291595,
    market_cap_change_percentage_24h: -6.17271,
    circulating_supply: 51477015000,
    total_supply: null,
    max_supply: null,
    ath: 0.092868,
    ath_change_percentage: -95.88602,
    ath_date: "2018-01-06T00:00:00.000Z",
    atl: 0.00001262,
    atl_change_percentage: 30170.90649,
    atl_date: "2015-12-28T00:00:00.000Z",
    roi: {
      times: -0.33154963367438617,
      currency: "btc",
      percentage: -33.15496336743862,
    },
    last_updated: "2023-03-27T23:31:55.064Z",
    price_change_percentage_14d_in_currency: 4.240924140115912,
    price_change_percentage_1h_in_currency: -0.23034457892011787,
    price_change_percentage_1y_in_currency: -64.53796772234638,
    price_change_percentage_200d_in_currency: -2.2770953332852453,
    price_change_percentage_24h_in_currency: -6.131406117725177,
    price_change_percentage_30d_in_currency: -13.359197114240176,
    price_change_percentage_7d_in_currency: -11.969880940911617,
  },
  {
    id: "icon",
    symbol: "icx",
    name: "ICON",
    image:
      "https://assets.coingecko.com/coins/images/1060/large/icon-icx-logo.png?1547035003",
    current_price: 0.206262,
    market_cap: 196233156,
    market_cap_rank: 186,
    fully_diluted_valuation: null,
    total_volume: 6458675,
    high_24h: 0.218929,
    low_24h: 0.200439,
    price_change_24h: -0.011133224201407057,
    price_change_percentage_24h: -5.12119,
    market_cap_change_24h: -10516184.911300302,
    market_cap_change_percentage_24h: -5.08644,
    circulating_supply: 951378550.19691,
    total_supply: 961848057.77321,
    max_supply: null,
    ath: 13.16,
    ath_change_percentage: -98.43355,
    ath_date: "2018-01-09T00:00:00.000Z",
    atl: 0.107465,
    atl_change_percentage: 91.8902,
    atl_date: "2020-01-03T02:14:53.139Z",
    roi: {
      times: 0.8751082650348391,
      currency: "usd",
      percentage: 87.51082650348391,
    },
    last_updated: "2023-03-27T23:31:53.504Z",
    price_change_percentage_14d_in_currency: 2.6013030959881718,
    price_change_percentage_1h_in_currency: 0.5334875922884413,
    price_change_percentage_1y_in_currency: -76.67439213646689,
    price_change_percentage_200d_in_currency: -21.825319181345222,
    price_change_percentage_24h_in_currency: -5.121192930853039,
    price_change_percentage_30d_in_currency: -17.36269235765732,
    price_change_percentage_7d_in_currency: -12.206944505318184,
  },
  {
    id: "ontology",
    symbol: "ont",
    name: "Ontology",
    image:
      "https://assets.coingecko.com/coins/images/3447/large/ONT.png?1583481820",
    current_price: 0.219674,
    market_cap: 193795249,
    market_cap_rank: 187,
    fully_diluted_valuation: null,
    total_volume: 16447088,
    high_24h: 0.231113,
    low_24h: 0.21488,
    price_change_24h: -0.011429165176450595,
    price_change_percentage_24h: -4.94549,
    market_cap_change_24h: -11066345.474191278,
    market_cap_change_percentage_24h: -5.40186,
    circulating_supply: 884582857,
    total_supply: 1000000000,
    max_supply: null,
    ath: 10.92,
    ath_change_percentage: -97.99466,
    ath_date: "2018-05-03T01:43:05.844Z",
    atl: 0.145208,
    atl_change_percentage: 50.81258,
    atl_date: "2022-12-30T07:46:17.182Z",
    roi: null,
    last_updated: "2023-03-27T23:31:57.564Z",
    price_change_percentage_14d_in_currency: 6.601613498908565,
    price_change_percentage_1h_in_currency: 0.2765201797378068,
    price_change_percentage_1y_in_currency: -62.461632268812025,
    price_change_percentage_200d_in_currency: -5.002421837459051,
    price_change_percentage_24h_in_currency: -4.94549191345097,
    price_change_percentage_30d_in_currency: -13.013787166331428,
    price_change_percentage_7d_in_currency: -12.754560027782874,
  },
  {
    id: "sushi",
    symbol: "sushi",
    name: "Sushi",
    image:
      "https://assets.coingecko.com/coins/images/12271/large/512x512_Logo_no_chop.png?1606986688",
    current_price: 1.005,
    market_cap: 193635834,
    market_cap_rank: 188,
    fully_diluted_valuation: 251097803,
    total_volume: 62296131,
    high_24h: 1.063,
    low_24h: 0.982011,
    price_change_24h: -0.05147082237295009,
    price_change_percentage_24h: -4.8737,
    market_cap_change_24h: -10075460.857045472,
    market_cap_change_percentage_24h: -4.94595,
    circulating_supply: 192789255.8554817,
    total_supply: 248196909.63409,
    max_supply: 250000000,
    ath: 23.38,
    ath_change_percentage: -95.70518,
    ath_date: "2021-03-13T23:44:36.774Z",
    atl: 0.475381,
    atl_change_percentage: 111.194,
    atl_date: "2020-11-04T14:53:53.560Z",
    roi: null,
    last_updated: "2023-03-27T23:31:23.086Z",
    price_change_percentage_14d_in_currency: -13.925497769684656,
    price_change_percentage_1h_in_currency: 0.11853718951611585,
    price_change_percentage_1y_in_currency: -72.32174514811841,
    price_change_percentage_200d_in_currency: -19.983653951662504,
    price_change_percentage_24h_in_currency: -4.8737046817159175,
    price_change_percentage_30d_in_currency: -25.94575690773855,
    price_change_percentage_7d_in_currency: -18.891502711810478,
  },
  {
    id: "insure",
    symbol: "sure",
    name: "inSure DeFi",
    image:
      "https://assets.coingecko.com/coins/images/10354/large/logo-grey-circle.png?1614910406",
    current_price: 0.00722534,
    market_cap: 191217119,
    market_cap_rank: 189,
    fully_diluted_valuation: 635830013,
    total_volume: 3564378,
    high_24h: 0.0083305,
    low_24h: 0.00671606,
    price_change_24h: -0.000622479158504455,
    price_change_percentage_24h: -7.93187,
    market_cap_change_24h: -16460676.961751372,
    market_cap_change_percentage_24h: -7.92606,
    circulating_supply: 26464787952.466843,
    total_supply: 88000000000,
    max_supply: 88000000000,
    ath: 0.11397,
    ath_change_percentage: -93.66393,
    ath_date: "2021-01-06T21:22:32.766Z",
    atl: 0.00015606,
    atl_change_percentage: 4527.19323,
    atl_date: "2021-06-28T04:52:56.935Z",
    roi: null,
    last_updated: "2023-03-27T23:31:47.141Z",
    price_change_percentage_14d_in_currency: 150.11611525693866,
    price_change_percentage_1h_in_currency: 2.4382375528903597,
    price_change_percentage_1y_in_currency: 16.53977406892028,
    price_change_percentage_200d_in_currency: 171.95009777815892,
    price_change_percentage_24h_in_currency: -7.931873331129557,
    price_change_percentage_30d_in_currency: 175.8182170802479,
    price_change_percentage_7d_in_currency: 94.57490685306216,
  },
  {
    id: "bitcoin-avalanche-bridged-btc-b",
    symbol: "btc.b",
    name: "Bitcoin Avalanche Bridged (BTC.b)",
    image:
      "https://assets.coingecko.com/coins/images/26115/large/btcb.png?1655921693",
    current_price: 27171,
    market_cap: 190710185,
    market_cap_rank: 190,
    fully_diluted_valuation: null,
    total_volume: 4227139,
    high_24h: 31769,
    low_24h: 26615,
    price_change_24h: -925.6166643384422,
    price_change_percentage_24h: -3.29437,
    market_cap_change_24h: -6214943.8651815355,
    market_cap_change_percentage_24h: -3.15599,
    circulating_supply: 7019.07354803,
    total_supply: 7019.07354803,
    max_supply: null,
    ath: 42442,
    ath_change_percentage: -36.03952,
    ath_date: "2023-01-16T22:36:24.558Z",
    atl: 7806.11,
    atl_change_percentage: 247.75087,
    atl_date: "2023-03-03T05:01:42.603Z",
    roi: null,
    last_updated: "2023-03-27T23:31:37.571Z",
    price_change_percentage_14d_in_currency: 22.76004074702261,
    price_change_percentage_1h_in_currency: -0.16763087818472058,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: 40.57102708596943,
    price_change_percentage_24h_in_currency: -3.2943716614678897,
    price_change_percentage_30d_in_currency: 17.033104174698796,
    price_change_percentage_7d_in_currency: -3.7329099106012738,
  },
  {
    id: "helium",
    symbol: "hnt",
    name: "Helium",
    image:
      "https://assets.coingecko.com/coins/images/4284/large/Helium_HNT.png?1612620071",
    current_price: 1.32,
    market_cap: 186611051,
    market_cap_rank: 191,
    fully_diluted_valuation: 295058378,
    total_volume: 1449139,
    high_24h: 1.45,
    low_24h: 1.32,
    price_change_24h: -0.09887397020826526,
    price_change_percentage_24h: -6.95313,
    market_cap_change_24h: -14391906.374120474,
    market_cap_change_percentage_24h: -7.16005,
    circulating_supply: 141037393.04048,
    total_supply: 223000000,
    max_supply: 223000000,
    ath: 54.88,
    ath_change_percentage: -97.59034,
    ath_date: "2021-11-12T23:08:25.301Z",
    atl: 0.113248,
    atl_change_percentage: 1067.6607,
    atl_date: "2020-04-18T00:19:10.902Z",
    roi: null,
    last_updated: "2023-03-27T23:31:33.616Z",
    price_change_percentage_14d_in_currency: -41.20332703974252,
    price_change_percentage_1h_in_currency: -0.07912240561459291,
    price_change_percentage_1y_in_currency: -94.48724032040387,
    price_change_percentage_200d_in_currency: -75.00634063661934,
    price_change_percentage_24h_in_currency: -6.953134544223746,
    price_change_percentage_30d_in_currency: -51.68943003747001,
    price_change_percentage_7d_in_currency: -16.149151721933695,
  },
  {
    id: "iostoken",
    symbol: "iost",
    name: "IOST",
    image:
      "https://assets.coingecko.com/coins/images/2523/large/IOST.png?1557555183",
    current_price: 0.00993696,
    market_cap: 185909622,
    market_cap_rank: 193,
    fully_diluted_valuation: 894326827,
    total_volume: 19918043,
    high_24h: 0.01064719,
    low_24h: 0.0097875,
    price_change_24h: -0.000596470537280677,
    price_change_percentage_24h: -5.66264,
    market_cap_change_24h: -11021096.02426678,
    market_cap_change_percentage_24h: -5.59643,
    circulating_supply: 18708894189,
    total_supply: 18708894189,
    max_supply: 90000000000,
    ath: 0.129829,
    ath_change_percentage: -92.38042,
    ath_date: "2018-01-24T00:00:00.000Z",
    atl: 0.00160309,
    atl_change_percentage: 517.0836,
    atl_date: "2020-03-13T02:25:35.257Z",
    roi: null,
    last_updated: "2023-03-27T23:31:54.032Z",
    price_change_percentage_14d_in_currency: 1.1165653921035195,
    price_change_percentage_1h_in_currency: 0.2334359515461999,
    price_change_percentage_1y_in_currency: -69.85172692807527,
    price_change_percentage_200d_in_currency: -21.475681002205512,
    price_change_percentage_24h_in_currency: -5.66264016510536,
    price_change_percentage_30d_in_currency: -11.899246654332995,
    price_change_percentage_7d_in_currency: -12.983036173313101,
  },
  {
    id: "ronin",
    symbol: "ron",
    name: "Ronin",
    image:
      "https://assets.coingecko.com/coins/images/20009/large/ronin.jpg?1649184678",
    current_price: 1.033,
    market_cap: 185896252,
    market_cap_rank: 192,
    fully_diluted_valuation: 1031992405,
    total_volume: 1649344,
    high_24h: 1.076,
    low_24h: 1.02,
    price_change_24h: -0.039442242180662834,
    price_change_percentage_24h: -3.67908,
    market_cap_change_24h: -6870771.839515626,
    market_cap_change_percentage_24h: -3.56429,
    circulating_supply: 180133353.065146,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 4.29,
    ath_change_percentage: -75.97596,
    ath_date: "2022-01-27T13:14:36.500Z",
    atl: 0.196601,
    atl_change_percentage: 424.75897,
    atl_date: "2022-11-21T19:36:31.487Z",
    roi: null,
    last_updated: "2023-03-27T23:31:34.262Z",
    price_change_percentage_14d_in_currency: 49.691927392758565,
    price_change_percentage_1h_in_currency: 0.09925633550845775,
    price_change_percentage_1y_in_currency: -52.18448958532047,
    price_change_percentage_200d_in_currency: 225.3547287875088,
    price_change_percentage_24h_in_currency: -3.6790837672184136,
    price_change_percentage_30d_in_currency: 31.311805566806107,
    price_change_percentage_7d_in_currency: 1.3051606379967466,
  },
  {
    id: "bitrise-token",
    symbol: "brise",
    name: "Bitgert",
    image:
      "https://assets.coingecko.com/coins/images/17388/large/bitgert.png?1660272192",
    current_price: 4.64968e-7,
    market_cap: 183973155,
    market_cap_rank: 194,
    fully_diluted_valuation: 464944741,
    total_volume: 1902408,
    high_24h: 4.87452e-7,
    low_24h: 4.6216e-7,
    price_change_24h: -2.0721965456e-8,
    price_change_percentage_24h: -4.2665,
    market_cap_change_24h: -8120546.804757625,
    market_cap_change_percentage_24h: -4.22739,
    circulating_supply: 395688215721653.25,
    total_supply: 427063549263988,
    max_supply: 1000000000000000,
    ath: 0.00000184,
    ath_change_percentage: -74.80486,
    ath_date: "2022-03-07T08:25:04.177Z",
    atl: 6.16584e-10,
    atl_change_percentage: 75175.84974,
    atl_date: "2021-09-09T21:36:32.800Z",
    roi: null,
    last_updated: "2023-03-27T23:31:49.671Z",
    price_change_percentage_14d_in_currency: 1.9644503361668724,
    price_change_percentage_1h_in_currency: 0.26452189820623373,
    price_change_percentage_1y_in_currency: -60.701241023297534,
    price_change_percentage_200d_in_currency: -45.037736448386994,
    price_change_percentage_24h_in_currency: -4.266499623604424,
    price_change_percentage_30d_in_currency: -13.730507316221848,
    price_change_percentage_7d_in_currency: -2.56439713595874,
  },
  {
    id: "mx-token",
    symbol: "mx",
    name: "MX",
    image:
      "https://assets.coingecko.com/coins/images/8545/large/MEXC_GLOBAL_LOGO.jpeg?1670213280",
    current_price: 1.83,
    market_cap: 183697964,
    market_cap_rank: 195,
    fully_diluted_valuation: null,
    total_volume: 303995,
    high_24h: 1.95,
    low_24h: 1.82,
    price_change_24h: -0.08924197791303667,
    price_change_percentage_24h: -4.64226,
    market_cap_change_24h: -8796300.84451902,
    market_cap_change_percentage_24h: -4.56964,
    circulating_supply: 99999999.9997,
    total_supply: 437200002.05,
    max_supply: null,
    ath: 3.7,
    ath_change_percentage: -50.3379,
    ath_date: "2021-12-02T00:59:40.216Z",
    atl: 0.04218457,
    atl_change_percentage: 4254.6785,
    atl_date: "2019-11-25T05:59:45.392Z",
    roi: null,
    last_updated: "2023-03-27T23:31:40.221Z",
    price_change_percentage_14d_in_currency: 5.830172728758681,
    price_change_percentage_1h_in_currency: -0.6147860054270797,
    price_change_percentage_1y_in_currency: -15.766359324856264,
    price_change_percentage_200d_in_currency: 95.67199275075842,
    price_change_percentage_24h_in_currency: -4.642256649917452,
    price_change_percentage_30d_in_currency: 46.20535783160747,
    price_change_percentage_7d_in_currency: -10.950438753213678,
  },
  {
    id: "joe",
    symbol: "joe",
    name: "JOE",
    image:
      "https://assets.coingecko.com/coins/images/17569/large/joe_200x200.png?1628497750",
    current_price: 0.533791,
    market_cap: 183544402,
    market_cap_rank: 197,
    fully_diluted_valuation: 266895255,
    total_volume: 139729045,
    high_24h: 0.552931,
    low_24h: 0.447708,
    price_change_24h: 0.052722,
    price_change_percentage_24h: 10.95937,
    market_cap_change_24h: 22070970,
    market_cap_change_percentage_24h: 13.66848,
    circulating_supply: 343851002.8577,
    total_supply: 476437634.356928,
    max_supply: 500000000,
    ath: 5.09,
    ath_change_percentage: -89.53376,
    ath_date: "2021-11-21T14:27:00.202Z",
    atl: 0.02658814,
    atl_change_percentage: 1902.50263,
    atl_date: "2021-08-11T14:01:35.223Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.545Z",
    price_change_percentage_14d_in_currency: 147.90483141034827,
    price_change_percentage_1h_in_currency: 1.7229601629557605,
    price_change_percentage_1y_in_currency: -45.50833524309718,
    price_change_percentage_200d_in_currency: 135.79679457951585,
    price_change_percentage_24h_in_currency: 10.959373065342488,
    price_change_percentage_30d_in_currency: 108.49829173920776,
    price_change_percentage_7d_in_currency: 57.595926691498725,
  },
  {
    id: "0x",
    symbol: "zrx",
    name: "0x",
    image:
      "https://assets.coingecko.com/coins/images/863/large/0x.png?1547034672",
    current_price: 0.216508,
    market_cap: 183496959,
    market_cap_rank: 196,
    fully_diluted_valuation: 216516594,
    total_volume: 14831053,
    high_24h: 0.230743,
    low_24h: 0.213358,
    price_change_24h: -0.014234804191868372,
    price_change_percentage_24h: -6.16912,
    market_cap_change_24h: -12063811.49190098,
    market_cap_change_percentage_24h: -6.16883,
    circulating_supply: 847496054.8122635,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 2.5,
    ath_change_percentage: -91.32938,
    ath_date: "2018-01-13T00:00:00.000Z",
    atl: 0.120667,
    atl_change_percentage: 79.42017,
    atl_date: "2020-03-13T02:27:49.563Z",
    roi: {
      times: 3.5105866635814085,
      currency: "usd",
      percentage: 351.05866635814084,
    },
    last_updated: "2023-03-27T23:31:57.390Z",
    price_change_percentage_14d_in_currency: 1.2680106678118508,
    price_change_percentage_1h_in_currency: -0.19017525946222702,
    price_change_percentage_1y_in_currency: -65.51319820710863,
    price_change_percentage_200d_in_currency: -24.007927043310616,
    price_change_percentage_24h_in_currency: -6.1691173340253105,
    price_change_percentage_30d_in_currency: -19.18198645175913,
    price_change_percentage_7d_in_currency: -14.11598968304939,
  },
  {
    id: "zelcash",
    symbol: "flux",
    name: "Flux",
    image:
      "https://assets.coingecko.com/coins/images/5163/large/Flux_symbol_blue-white.png?1617192144",
    current_price: 0.613944,
    market_cap: 180179955,
    market_cap_rank: 198,
    fully_diluted_valuation: null,
    total_volume: 18118961,
    high_24h: 0.659963,
    low_24h: 0.596836,
    price_change_24h: -0.021278319780049015,
    price_change_percentage_24h: -3.34975,
    market_cap_change_24h: -7627534.543117642,
    market_cap_change_percentage_24h: -4.06136,
    circulating_supply: 293935230.099319,
    total_supply: 440000000,
    max_supply: null,
    ath: 3.33,
    ath_change_percentage: -81.57248,
    ath_date: "2022-01-03T10:18:02.680Z",
    atl: 0.01640374,
    atl_change_percentage: 3636.18017,
    atl_date: "2021-01-13T05:29:57.987Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.214Z",
    price_change_percentage_14d_in_currency: -4.941541152217907,
    price_change_percentage_1h_in_currency: 0.4736156350953753,
    price_change_percentage_1y_in_currency: -61.236187527575495,
    price_change_percentage_200d_in_currency: -51.614498082904625,
    price_change_percentage_24h_in_currency: -3.349745491805647,
    price_change_percentage_30d_in_currency: -23.461564009553882,
    price_change_percentage_7d_in_currency: -6.816440390128557,
  },
  {
    id: "biconomy",
    symbol: "bico",
    name: "Biconomy",
    image:
      "https://assets.coingecko.com/coins/images/21061/large/biconomy_logo.jpg?1638269749",
    current_price: 0.354435,
    market_cap: 178189379,
    market_cap_rank: 199,
    fully_diluted_valuation: 354401650,
    total_volume: 4505381,
    high_24h: 0.379464,
    low_24h: 0.348477,
    price_change_24h: -0.021197254465757376,
    price_change_percentage_24h: -5.64308,
    market_cap_change_24h: -10633621.549826592,
    market_cap_change_percentage_24h: -5.63153,
    circulating_supply: 502789360.339722,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 21.45,
    ath_change_percentage: -98.34806,
    ath_date: "2021-12-02T02:18:45.254Z",
    atl: 0.256047,
    atl_change_percentage: 38.36789,
    atl_date: "2022-11-09T22:15:33.140Z",
    roi: null,
    last_updated: "2023-03-27T23:31:54.412Z",
    price_change_percentage_14d_in_currency: 1.426494402128939,
    price_change_percentage_1h_in_currency: 0.07955056542543246,
    price_change_percentage_1y_in_currency: -76.60766134458076,
    price_change_percentage_200d_in_currency: -29.454088294466263,
    price_change_percentage_24h_in_currency: -5.643081645924282,
    price_change_percentage_30d_in_currency: -21.388400877178558,
    price_change_percentage_7d_in_currency: -15.196432781377684,
  },
  {
    id: "dogelon-mars",
    symbol: "elon",
    name: "Dogelon Mars",
    image:
      "https://assets.coingecko.com/coins/images/14962/large/6GxcPRo3_400x400.jpg?1619157413",
    current_price: 3.23742e-7,
    market_cap: 177927538,
    market_cap_rank: 200,
    fully_diluted_valuation: 323710629,
    total_volume: 3069504,
    high_24h: 3.46992e-7,
    low_24h: 3.14671e-7,
    price_change_24h: -2.3097140551e-8,
    price_change_percentage_24h: -6.65933,
    market_cap_change_24h: -12686117.684953779,
    market_cap_change_percentage_24h: -6.65541,
    circulating_supply: 549649971723242.3,
    total_supply: 1000000000000000,
    max_supply: 1000000000000000,
    ath: 0.00000259,
    ath_change_percentage: -87.52228,
    ath_date: "2021-10-30T20:39:32.727Z",
    atl: 1.7563e-8,
    atl_change_percentage: 1742.67508,
    atl_date: "2021-04-23T06:09:26.872Z",
    roi: null,
    last_updated: "2023-03-27T23:31:46.483Z",
    price_change_percentage_14d_in_currency: -9.02428586190005,
    price_change_percentage_1h_in_currency: 0.11925593505588875,
    price_change_percentage_1y_in_currency: -61.03874310461759,
    price_change_percentage_200d_in_currency: 15.503235555550393,
    price_change_percentage_24h_in_currency: -6.659329183159633,
    price_change_percentage_30d_in_currency: -22.940495386808678,
    price_change_percentage_7d_in_currency: -12.373041657778812,
  },
  {
    id: "ecoin-2",
    symbol: "ecoin",
    name: "Ecoin",
    image:
      "https://assets.coingecko.com/coins/images/10849/large/IMG_4307.jpg?1585628922",
    current_price: 0.00038268,
    market_cap: 176460620,
    market_cap_rank: 201,
    fully_diluted_valuation: null,
    total_volume: 24.72,
    high_24h: 0.00040289,
    low_24h: 0.00038137,
    price_change_24h: -0.000019138127488147,
    price_change_percentage_24h: -4.76292,
    market_cap_change_24h: -8826140.11378634,
    market_cap_change_percentage_24h: -4.7635,
    circulating_supply: 461121735617,
    total_supply: 1000000000000,
    max_supply: null,
    ath: 0.01276469,
    ath_change_percentage: -97.00329,
    ath_date: "2021-09-15T01:40:25.808Z",
    atl: 0.00000497,
    atl_change_percentage: 7603.6548,
    atl_date: "2022-10-24T03:23:34.581Z",
    roi: null,
    last_updated: "2023-03-27T23:31:15.467Z",
    price_change_percentage_14d_in_currency: 0.39703656825905864,
    price_change_percentage_1h_in_currency: 0.010648146289360236,
    price_change_percentage_1y_in_currency: -66.10803895524249,
    price_change_percentage_200d_in_currency: 53.040365462380535,
    price_change_percentage_24h_in_currency: -4.762920214314262,
    price_change_percentage_30d_in_currency: -35.99349384018481,
    price_change_percentage_7d_in_currency: -4.878333952267388,
  },
  {
    id: "livepeer",
    symbol: "lpt",
    name: "Livepeer",
    image:
      "https://assets.coingecko.com/coins/images/7137/large/logo-circle-green.png?1619593365",
    current_price: 6.4,
    market_cap: 175828269,
    market_cap_rank: 202,
    fully_diluted_valuation: 175828269,
    total_volume: 13029953,
    high_24h: 7.12,
    low_24h: 6.3,
    price_change_24h: -0.699543569095062,
    price_change_percentage_24h: -9.84968,
    market_cap_change_24h: -19346593.183979064,
    market_cap_change_percentage_24h: -9.91244,
    circulating_supply: 27529786.7607641,
    total_supply: 27529786.7607641,
    max_supply: 27529786.7607641,
    ath: 99.03,
    ath_change_percentage: -93.55046,
    ath_date: "2021-11-09T16:58:44.554Z",
    atl: 0.354051,
    atl_change_percentage: 1703.93319,
    atl_date: "2019-10-26T22:59:09.500Z",
    roi: null,
    last_updated: "2023-03-27T23:31:49.858Z",
    price_change_percentage_14d_in_currency: 15.120153481050794,
    price_change_percentage_1h_in_currency: -0.35805329342172554,
    price_change_percentage_1y_in_currency: -76.6550451719879,
    price_change_percentage_200d_in_currency: -37.16752397593349,
    price_change_percentage_24h_in_currency: -9.8496832788765,
    price_change_percentage_30d_in_currency: -16.041201902639653,
    price_change_percentage_7d_in_currency: 0.281843429172202,
  },
  {
    id: "multichain",
    symbol: "multi",
    name: "Multichain",
    image:
      "https://assets.coingecko.com/coins/images/22087/large/1_Wyot-SDGZuxbjdkaOeT2-A.png?1640764238",
    current_price: 8.95,
    market_cap: 173208385,
    market_cap_rank: 203,
    fully_diluted_valuation: null,
    total_volume: 1660586,
    high_24h: 9.44,
    low_24h: 8.87,
    price_change_24h: -0.481977293730365,
    price_change_percentage_24h: -5.11011,
    market_cap_change_24h: -9608707.173195004,
    market_cap_change_percentage_24h: -5.25591,
    circulating_supply: 19363292.6,
    total_supply: 100000000,
    max_supply: null,
    ath: 33.64,
    ath_change_percentage: -73.41249,
    ath_date: "2022-01-14T12:30:34.074Z",
    atl: 2.91,
    atl_change_percentage: 207.44425,
    atl_date: "2022-06-19T02:34:57.530Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.395Z",
    price_change_percentage_14d_in_currency: -1.2275670770087366,
    price_change_percentage_1h_in_currency: 0.1779097149308103,
    price_change_percentage_1y_in_currency: -28.620501414253702,
    price_change_percentage_200d_in_currency: 84.25421924450431,
    price_change_percentage_24h_in_currency: -5.110110859799583,
    price_change_percentage_30d_in_currency: -15.306952682825168,
    price_change_percentage_7d_in_currency: -12.213128697510832,
  },
  {
    id: "alchemix-usd",
    symbol: "alusd",
    name: "Alchemix USD",
    image:
      "https://assets.coingecko.com/coins/images/14114/large/Alchemix_USD.png?1614410406",
    current_price: 0.993335,
    market_cap: 170574318,
    market_cap_rank: 204,
    fully_diluted_valuation: null,
    total_volume: 12190.37,
    high_24h: 0.997923,
    low_24h: 0.987936,
    price_change_24h: -0.001591789740776895,
    price_change_percentage_24h: -0.15999,
    market_cap_change_24h: -285899.945579499,
    market_cap_change_percentage_24h: -0.16733,
    circulating_supply: 171684819.160042,
    total_supply: 171684819.160042,
    max_supply: null,
    ath: 2.13,
    ath_change_percentage: -53.32986,
    ath_date: "2021-03-21T19:53:32.860Z",
    atl: 0.060239,
    atl_change_percentage: 1548.15593,
    atl_date: "2021-03-19T22:40:28.697Z",
    roi: null,
    last_updated: "2023-03-27T23:30:35.950Z",
    price_change_percentage_14d_in_currency: 0.502429280351004,
    price_change_percentage_1h_in_currency: -0.05764863424938139,
    price_change_percentage_1y_in_currency: -0.2754013341589504,
    price_change_percentage_200d_in_currency: 1.61799487107805,
    price_change_percentage_24h_in_currency: -0.15999066236718532,
    price_change_percentage_30d_in_currency: -0.19529491950682804,
    price_change_percentage_7d_in_currency: 0.01058690261599002,
  },
  {
    id: "reserve-rights-token",
    symbol: "rsr",
    name: "Reserve Rights",
    image:
      "https://assets.coingecko.com/coins/images/8365/large/rsr.png?1637983320",
    current_price: 0.00370734,
    market_cap: 169044676,
    market_cap_rank: 205,
    fully_diluted_valuation: 370615297,
    total_volume: 8958350,
    high_24h: 0.00391957,
    low_24h: 0.00363445,
    price_change_24h: -0.000198836509871866,
    price_change_percentage_24h: -5.09031,
    market_cap_change_24h: -9847886.109959394,
    market_cap_change_percentage_24h: -5.50492,
    circulating_supply: 45611899305,
    total_supply: 100000000000,
    max_supply: 100000000000,
    ath: 0.117424,
    ath_change_percentage: -96.84378,
    ath_date: "2021-04-16T17:45:02.062Z",
    atl: 0.00121354,
    atl_change_percentage: 205.39917,
    atl_date: "2020-03-16T11:09:08.151Z",
    roi: {
      times: 2.370310198024668,
      currency: "usd",
      percentage: 237.03101980246683,
    },
    last_updated: "2023-03-27T23:31:58.456Z",
    price_change_percentage_14d_in_currency: -6.865135276319852,
    price_change_percentage_1h_in_currency: -0.04148047437210155,
    price_change_percentage_1y_in_currency: -75.15338559926711,
    price_change_percentage_200d_in_currency: -37.94969689624586,
    price_change_percentage_24h_in_currency: -5.090308832132787,
    price_change_percentage_30d_in_currency: -27.407089691351764,
    price_change_percentage_7d_in_currency: -10.616343179825442,
  },
  {
    id: "swissborg",
    symbol: "chsb",
    name: "SwissBorg",
    image:
      "https://assets.coingecko.com/coins/images/2117/large/YJUrRy7r_400x400.png?1589794215",
    current_price: 0.174142,
    market_cap: 165599558,
    market_cap_rank: 206,
    fully_diluted_valuation: null,
    total_volume: 413471,
    high_24h: 0.186305,
    low_24h: 0.172359,
    price_change_24h: -0.004889369537983191,
    price_change_percentage_24h: -2.73101,
    market_cap_change_24h: -5698867.921351165,
    market_cap_change_percentage_24h: -3.32687,
    circulating_supply: 951754603.4742761,
    total_supply: 1000000000,
    max_supply: null,
    ath: 1.64,
    ath_change_percentage: -89.37957,
    ath_date: "2021-05-04T17:14:50.120Z",
    atl: 0.00502687,
    atl_change_percentage: 3364.62182,
    atl_date: "2019-07-28T00:00:00.000Z",
    roi: {
      times: 0.741421953131934,
      currency: "usd",
      percentage: 74.1421953131934,
    },
    last_updated: "2023-03-27T23:31:40.084Z",
    price_change_percentage_14d_in_currency: -12.691545212740651,
    price_change_percentage_1h_in_currency: -0.3084371047056061,
    price_change_percentage_1y_in_currency: -60.14082380361933,
    price_change_percentage_200d_in_currency: -2.815378543773365,
    price_change_percentage_24h_in_currency: -2.731009775872524,
    price_change_percentage_30d_in_currency: -20.861686572479442,
    price_change_percentage_7d_in_currency: -10.038869945433053,
  },
  {
    id: "bora",
    symbol: "bora",
    name: "BORA",
    image:
      "https://assets.coingecko.com/coins/images/7646/large/mqFw8hxm_400x400.jpeg?1656657343",
    current_price: 0.17713,
    market_cap: 164287871,
    market_cap_rank: 207,
    fully_diluted_valuation: 213574233,
    total_volume: 3943850,
    high_24h: 0.186472,
    low_24h: 0.172383,
    price_change_24h: -0.007974931719160305,
    price_change_percentage_24h: -4.30834,
    market_cap_change_24h: -8031775.64325276,
    market_cap_change_percentage_24h: -4.66097,
    circulating_supply: 927500000,
    total_supply: 1205750000,
    max_supply: 1205750000,
    ath: 1.61,
    ath_change_percentage: -89.03145,
    ath_date: "2021-11-25T00:10:02.143Z",
    atl: 0.00482732,
    atl_change_percentage: 3557.43502,
    atl_date: "2020-02-15T17:49:05.317Z",
    roi: null,
    last_updated: "2023-03-27T23:31:33.959Z",
    price_change_percentage_14d_in_currency: 5.50480653438296,
    price_change_percentage_1h_in_currency: 0.3853227368900596,
    price_change_percentage_1y_in_currency: -80.44545100313358,
    price_change_percentage_200d_in_currency: -36.10531315703009,
    price_change_percentage_24h_in_currency: -4.308335332398112,
    price_change_percentage_30d_in_currency: -20.725060340857212,
    price_change_percentage_7d_in_currency: -9.794064179747988,
  },
  {
    id: "synapse-2",
    symbol: "syn",
    name: "Synapse",
    image:
      "https://assets.coingecko.com/coins/images/18024/large/synapse_social_icon.png?1663921797",
    current_price: 0.856704,
    market_cap: 162647865,
    market_cap_rank: 208,
    fully_diluted_valuation: 213877982,
    total_volume: 18147128,
    high_24h: 0.927321,
    low_24h: 0.854429,
    price_change_24h: -0.012579876503981404,
    price_change_percentage_24h: -1.44715,
    market_cap_change_24h: -2629764.1477585137,
    market_cap_change_percentage_24h: -1.59112,
    circulating_supply: 190117588.881215,
    total_supply: 184907850,
    max_supply: 250000000,
    ath: 4.92,
    ath_change_percentage: -82.60499,
    ath_date: "2021-10-24T00:24:41.805Z",
    atl: 0.3896,
    atl_change_percentage: 119.46538,
    atl_date: "2021-09-21T21:19:58.123Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.781Z",
    price_change_percentage_14d_in_currency: -13.374353545325905,
    price_change_percentage_1h_in_currency: -0.7201222225447773,
    price_change_percentage_1y_in_currency: -59.197461613472946,
    price_change_percentage_200d_in_currency: -43.41599936142983,
    price_change_percentage_24h_in_currency: -1.447153666024227,
    price_change_percentage_30d_in_currency: -35.846552955822006,
    price_change_percentage_7d_in_currency: -22.56023252159047,
  },
  {
    id: "nervos-network",
    symbol: "ckb",
    name: "Nervos Network",
    image:
      "https://assets.coingecko.com/coins/images/9566/large/Nervos_White.png?1608280856",
    current_price: 0.00477214,
    market_cap: 159352124,
    market_cap_rank: 209,
    fully_diluted_valuation: null,
    total_volume: 17484210,
    high_24h: 0.00517392,
    low_24h: 0.00471284,
    price_change_24h: -0.000387183783102344,
    price_change_percentage_24h: -7.50455,
    market_cap_change_24h: -12764990.61643365,
    market_cap_change_percentage_24h: -7.41646,
    circulating_supply: 33340636263.0312,
    total_supply: null,
    max_supply: null,
    ath: 0.04370633,
    ath_change_percentage: -89.08272,
    ath_date: "2021-03-31T17:08:59.155Z",
    atl: 0.00197892,
    atl_change_percentage: 141.11836,
    atl_date: "2022-12-17T14:25:57.243Z",
    roi: {
      times: -0.5227861268629446,
      currency: "usd",
      percentage: -52.27861268629446,
    },
    last_updated: "2023-03-27T23:31:52.008Z",
    price_change_percentage_14d_in_currency: 24.322402607548202,
    price_change_percentage_1h_in_currency: 0.6835838039475983,
    price_change_percentage_1y_in_currency: -59.483425864968595,
    price_change_percentage_200d_in_currency: 33.73195974058575,
    price_change_percentage_24h_in_currency: -7.504547002367426,
    price_change_percentage_30d_in_currency: 4.593075104516572,
    price_change_percentage_7d_in_currency: 1.8841038788291595,
  },
  {
    id: "wax",
    symbol: "waxp",
    name: "WAX",
    image:
      "https://assets.coingecko.com/coins/images/1372/large/WAX_Coin_Tickers_P_512px.png?1602812260",
    current_price: 0.065576,
    market_cap: 158874017,
    market_cap_rank: 210,
    fully_diluted_valuation: 247061185,
    total_volume: 6338876,
    high_24h: 0.069612,
    low_24h: 0.064292,
    price_change_24h: -0.004013304060773937,
    price_change_percentage_24h: -5.7671,
    market_cap_change_24h: -9734862.383928776,
    market_cap_change_percentage_24h: -5.77364,
    circulating_supply: 2424513723.80462,
    total_supply: 3770303327,
    max_supply: 3770303327,
    ath: 2.77,
    ath_change_percentage: -97.63586,
    ath_date: "2018-01-09T00:00:00.000Z",
    atl: 0.01594711,
    atl_change_percentage: 310.89817,
    atl_date: "2019-12-30T16:39:58.981Z",
    roi: {
      times: -0.7950739465872472,
      currency: "usd",
      percentage: -79.5073946587247,
    },
    last_updated: "2023-03-27T23:31:53.408Z",
    price_change_percentage_14d_in_currency: 1.3994356111341075,
    price_change_percentage_1h_in_currency: 0.212517067246736,
    price_change_percentage_1y_in_currency: -79.99641294551083,
    price_change_percentage_200d_in_currency: -28.322683887798465,
    price_change_percentage_24h_in_currency: -5.76709980722367,
    price_change_percentage_30d_in_currency: -25.655420806852312,
    price_change_percentage_7d_in_currency: -10.433993201725194,
  },
  {
    id: "bolide",
    symbol: "blid",
    name: "Bolide",
    image:
      "https://assets.coingecko.com/coins/images/25548/large/BLID_token_logo_200x200.png?1652334831",
    current_price: 0.0253374,
    market_cap: 158219675,
    market_cap_rank: 213,
    fully_diluted_valuation: 253365157,
    total_volume: 36642,
    high_24h: 0.02553072,
    low_24h: 0.02433425,
    price_change_24h: 0.00057745,
    price_change_percentage_24h: 2.33221,
    market_cap_change_24h: 3675559,
    market_cap_change_percentage_24h: 2.37832,
    circulating_supply: 6244729014.07338,
    total_supply: 9996820984.00977,
    max_supply: 10000000000,
    ath: 0.100051,
    ath_change_percentage: -74.61692,
    ath_date: "2022-10-07T10:22:40.547Z",
    atl: 0.01690004,
    atl_change_percentage: 50.27253,
    atl_date: "2023-01-27T09:28:48.256Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.321Z",
    price_change_percentage_14d_in_currency: 8.478752041223764,
    price_change_percentage_1h_in_currency: 0.3597541542333105,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: 8.466548323243376,
    price_change_percentage_24h_in_currency: 2.332211511647073,
    price_change_percentage_30d_in_currency: 15.605187455819062,
    price_change_percentage_7d_in_currency: 6.714299952701297,
  },
  {
    id: "skale",
    symbol: "skl",
    name: "SKALE",
    image:
      "https://assets.coingecko.com/coins/images/13245/large/SKALE_token_300x300.png?1606789574",
    current_price: 0.03762383,
    market_cap: 158053206,
    market_cap_rank: 211,
    fully_diluted_valuation: 263180594,
    total_volume: 19599862,
    high_24h: 0.04057881,
    low_24h: 0.03671633,
    price_change_24h: -0.002824660291296175,
    price_change_percentage_24h: -6.98335,
    market_cap_change_24h: -12136100.797423601,
    market_cap_change_percentage_24h: -7.13094,
    circulating_supply: 4203852671,
    total_supply: 5003528160.21248,
    max_supply: 7000000000,
    ath: 1.22,
    ath_change_percentage: -96.90936,
    ath_date: "2021-03-12T05:14:18.439Z",
    atl: 0.0196692,
    atl_change_percentage: 91.11359,
    atl_date: "2022-12-31T07:01:52.837Z",
    roi: null,
    last_updated: "2023-03-27T23:31:49.625Z",
    price_change_percentage_14d_in_currency: -5.436395488884243,
    price_change_percentage_1h_in_currency: 0.2918762696190473,
    price_change_percentage_1y_in_currency: -78.44779661320824,
    price_change_percentage_200d_in_currency: -21.191993986419245,
    price_change_percentage_24h_in_currency: -6.983351484436386,
    price_change_percentage_30d_in_currency: -21.915435169173215,
    price_change_percentage_7d_in_currency: -16.20660723205028,
  },
  {
    id: "energy-web-token",
    symbol: "ewt",
    name: "Energy Web",
    image:
      "https://assets.coingecko.com/coins/images/10886/large/R9gQTJV__400x400.png?1585604557",
    current_price: 3.42,
    market_cap: 157897568,
    market_cap_rank: 212,
    fully_diluted_valuation: 341859673,
    total_volume: 1593416,
    high_24h: 3.55,
    low_24h: 3.4,
    price_change_24h: -0.08671734308352665,
    price_change_percentage_24h: -2.47388,
    market_cap_change_24h: -3893844.4860008955,
    market_cap_change_percentage_24h: -2.40671,
    circulating_supply: 46187831.1600745,
    total_supply: 69017450.9455633,
    max_supply: 100000000,
    ath: 22.67,
    ath_change_percentage: -84.91455,
    ath_date: "2021-04-17T03:10:00.960Z",
    atl: 0.543628,
    atl_change_percentage: 529.16853,
    atl_date: "2020-04-03T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:29.452Z",
    price_change_percentage_14d_in_currency: -7.896192366441585,
    price_change_percentage_1h_in_currency: 0.1947008682033927,
    price_change_percentage_1y_in_currency: -44.049508815869714,
    price_change_percentage_200d_in_currency: -13.184508228291552,
    price_change_percentage_24h_in_currency: -2.4738822645970076,
    price_change_percentage_30d_in_currency: -21.908042526172462,
    price_change_percentage_7d_in_currency: -11.609315595284478,
  },
  {
    id: "safepal",
    symbol: "sfp",
    name: "SafePal",
    image:
      "https://assets.coingecko.com/coins/images/13905/large/sfp.png?1660381192",
    current_price: 0.423969,
    market_cap: 156946026,
    market_cap_rank: 214,
    fully_diluted_valuation: 212208709,
    total_volume: 3981085,
    high_24h: 0.449745,
    low_24h: 0.417373,
    price_change_24h: -0.025040345456999624,
    price_change_percentage_24h: -5.5768,
    market_cap_change_24h: -9186341.823851168,
    market_cap_change_percentage_24h: -5.52953,
    circulating_supply: 369791669,
    total_supply: 500000000,
    max_supply: 500000000,
    ath: 4.19,
    ath_change_percentage: -89.86614,
    ath_date: "2021-02-09T18:30:34.250Z",
    atl: 0.269235,
    atl_change_percentage: 57.61484,
    atl_date: "2022-06-14T02:06:50.102Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.142Z",
    price_change_percentage_14d_in_currency: -5.9980937838514725,
    price_change_percentage_1h_in_currency: 0.042892382640792225,
    price_change_percentage_1y_in_currency: -49.332579430510314,
    price_change_percentage_200d_in_currency: 13.591901467969347,
    price_change_percentage_24h_in_currency: -5.576798682431422,
    price_change_percentage_30d_in_currency: -18.84115243074638,
    price_change_percentage_7d_in_currency: -12.553252714797686,
  },
  {
    id: "alchemy-pay",
    symbol: "ach",
    name: "Alchemy Pay",
    image:
      "https://assets.coingecko.com/coins/images/12390/large/ACH_%281%29.png?1599691266",
    current_price: 0.03141941,
    market_cap: 155327159,
    market_cap_rank: 215,
    fully_diluted_valuation: 314192690,
    total_volume: 41662301,
    high_24h: 0.03386672,
    low_24h: 0.03065877,
    price_change_24h: -0.002348066865314067,
    price_change_percentage_24h: -6.95363,
    market_cap_change_24h: -11739677.12429732,
    market_cap_change_percentage_24h: -7.02693,
    circulating_supply: 4943691067.145604,
    total_supply: 10000000000,
    max_supply: 10000000000,
    ath: 0.198666,
    ath_change_percentage: -84.17088,
    ath_date: "2021-08-06T16:39:58.934Z",
    atl: 0.00135537,
    atl_change_percentage: 2220.1873,
    atl_date: "2021-07-21T00:39:36.177Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.797Z",
    price_change_percentage_14d_in_currency: 9.540484253409495,
    price_change_percentage_1h_in_currency: 0.9608505186617874,
    price_change_percentage_1y_in_currency: -25.403604418443752,
    price_change_percentage_200d_in_currency: 150.39757437745897,
    price_change_percentage_24h_in_currency: -6.953633547429357,
    price_change_percentage_30d_in_currency: -18.20332723173962,
    price_change_percentage_7d_in_currency: -24.34730291803004,
  },
  {
    id: "coredaoorg",
    symbol: "core",
    name: "Core",
    image:
      "https://assets.coingecko.com/coins/images/28938/large/coredao.png?1675503751",
    current_price: 2.02,
    market_cap: 153523439,
    market_cap_rank: 216,
    fully_diluted_valuation: 4230430430,
    total_volume: 22033073,
    high_24h: 2.02,
    low_24h: 1.96,
    price_change_24h: 0.00613821,
    price_change_percentage_24h: 0.30547,
    market_cap_change_24h: 3033463,
    market_cap_change_percentage_24h: 2.01572,
    circulating_supply: 76209555.4259866,
    total_supply: 2100000000,
    max_supply: 2100000000,
    ath: 6.14,
    ath_change_percentage: -67.1936,
    ath_date: "2023-02-08T12:55:39.828Z",
    atl: 1.82,
    atl_change_percentage: 10.81298,
    atl_date: "2023-03-11T17:22:03.833Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.608Z",
    price_change_percentage_14d_in_currency: -4.734210901556786,
    price_change_percentage_1h_in_currency: 0.30998648439693,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: 0.3054661635060663,
    price_change_percentage_30d_in_currency: -28.036988396024555,
    price_change_percentage_7d_in_currency: 0.6732136428824339,
  },
  {
    id: "celer-network",
    symbol: "celr",
    name: "Celer Network",
    image:
      "https://assets.coingecko.com/coins/images/4379/large/Celr.png?1554705437",
    current_price: 0.02713555,
    market_cap: 153246028,
    market_cap_rank: 217,
    fully_diluted_valuation: 271450272,
    total_volume: 47606372,
    high_24h: 0.02887763,
    low_24h: 0.02652903,
    price_change_24h: -0.000315779463110826,
    price_change_percentage_24h: -1.15032,
    market_cap_change_24h: -1696470.04494676,
    market_cap_change_percentage_24h: -1.0949,
    circulating_supply: 5645454935.82688,
    total_supply: 10000000000,
    max_supply: 10000000000,
    ath: 0.194843,
    ath_change_percentage: -86.05201,
    ath_date: "2021-09-26T06:49:04.741Z",
    atl: 0.00095575,
    atl_change_percentage: 2743.50982,
    atl_date: "2020-03-13T02:24:17.287Z",
    roi: {
      times: 3.050082074805846,
      currency: "usd",
      percentage: 305.00820748058464,
    },
    last_updated: "2023-03-27T23:31:58.013Z",
    price_change_percentage_14d_in_currency: 61.16786353162582,
    price_change_percentage_1h_in_currency: 0.41592941011940504,
    price_change_percentage_1y_in_currency: -48.05472072265755,
    price_change_percentage_200d_in_currency: 55.54648250316306,
    price_change_percentage_24h_in_currency: -1.1503248491906446,
    price_change_percentage_30d_in_currency: 27.34472666417009,
    price_change_percentage_7d_in_currency: 21.9520638161864,
  },
  {
    id: "evmos",
    symbol: "evmos",
    name: "Evmos",
    image:
      "https://assets.coingecko.com/coins/images/24023/large/evmos.png?1653958927",
    current_price: 0.332533,
    market_cap: 153198376,
    market_cap_rank: 219,
    fully_diluted_valuation: 332533355,
    total_volume: 1683617,
    high_24h: 0.345696,
    low_24h: 0.317985,
    price_change_24h: -0.01034804822212354,
    price_change_percentage_24h: -3.01797,
    market_cap_change_24h: -4231993.755562812,
    market_cap_change_percentage_24h: -2.68817,
    circulating_supply: 460700780.649561,
    total_supply: 1000000000,
    max_supply: null,
    ath: 6.84,
    ath_change_percentage: -95.14763,
    ath_date: "2022-04-28T21:20:31.780Z",
    atl: 0.277762,
    atl_change_percentage: 19.45422,
    atl_date: "2023-03-11T17:30:10.876Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.054Z",
    price_change_percentage_14d_in_currency: 10.743977656298892,
    price_change_percentage_1h_in_currency: 0.24704347868545842,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: -86.81873270889876,
    price_change_percentage_24h_in_currency: -3.0179671859900563,
    price_change_percentage_30d_in_currency: -9.09191343614539,
    price_change_percentage_7d_in_currency: 8.282061531138298,
  },
  {
    id: "uma",
    symbol: "uma",
    name: "UMA",
    image:
      "https://assets.coingecko.com/coins/images/10951/large/UMA.png?1586307916",
    current_price: 2.17,
    market_cap: 153053857,
    market_cap_rank: 218,
    fully_diluted_valuation: 245773597,
    total_volume: 58093577,
    high_24h: 2.37,
    low_24h: 2.02,
    price_change_24h: 0.127417,
    price_change_percentage_24h: 6.22899,
    market_cap_change_24h: 8990901,
    market_cap_change_percentage_24h: 6.24095,
    circulating_supply: 70491890.45207384,
    total_supply: 113195745.288641,
    max_supply: 113195745.288641,
    ath: 41.56,
    ath_change_percentage: -94.7653,
    ath_date: "2021-02-04T11:27:11.433Z",
    atl: 0.303625,
    atl_change_percentage: 616.4513,
    atl_date: "2020-04-29T17:00:41.760Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.645Z",
    price_change_percentage_14d_in_currency: 13.376026707757404,
    price_change_percentage_1h_in_currency: 0.4199585193534984,
    price_change_percentage_1y_in_currency: -71.79584296874485,
    price_change_percentage_200d_in_currency: -17.260436513221293,
    price_change_percentage_24h_in_currency: 6.228987730456263,
    price_change_percentage_30d_in_currency: -1.7917783167625645,
    price_change_percentage_7d_in_currency: 3.3181690515237783,
  },
  {
    id: "polymath",
    symbol: "poly",
    name: "Polymath",
    image:
      "https://assets.coingecko.com/coins/images/2784/large/inKkF01.png?1605007034",
    current_price: 0.170032,
    market_cap: 152087076,
    market_cap_rank: 220,
    fully_diluted_valuation: null,
    total_volume: 457448,
    high_24h: 0.183587,
    low_24h: 0.169187,
    price_change_24h: -0.007955165610077225,
    price_change_percentage_24h: -4.46952,
    market_cap_change_24h: -7836838.559018254,
    market_cap_change_percentage_24h: -4.90035,
    circulating_supply: 898550829.6745886,
    total_supply: 1000000000,
    max_supply: null,
    ath: 1.59,
    ath_change_percentage: -89.36772,
    ath_date: "2018-02-20T00:00:00.000Z",
    atl: 0.01100606,
    atl_change_percentage: 1437.74959,
    atl_date: "2020-03-13T02:22:30.088Z",
    roi: null,
    last_updated: "2023-03-27T23:31:47.443Z",
    price_change_percentage_14d_in_currency: -3.1052200734100257,
    price_change_percentage_1h_in_currency: 0.2640103395815174,
    price_change_percentage_1y_in_currency: -62.11935970988955,
    price_change_percentage_200d_in_currency: -6.705590922131931,
    price_change_percentage_24h_in_currency: -4.469520462442737,
    price_change_percentage_30d_in_currency: -16.604349090796873,
    price_change_percentage_7d_in_currency: -8.628565451406946,
  },
  {
    id: "compound-usdt",
    symbol: "cusdt",
    name: "cUSDT",
    image:
      "https://assets.coingecko.com/coins/images/11621/large/cUSDT.png?1592113270",
    current_price: 0.02030482,
    market_cap: 152042542,
    market_cap_rank: 221,
    fully_diluted_valuation: null,
    total_volume: 1.76,
    high_24h: 0.02035673,
    low_24h: 0.01112932,
    price_change_24h: 0.0091622,
    price_change_percentage_24h: 82.22663,
    market_cap_change_24h: 68271436,
    market_cap_change_percentage_24h: 81.49759,
    circulating_supply: 7488003171.74543,
    total_supply: 7488003171.74543,
    max_supply: null,
    ath: 0.02468599,
    ath_change_percentage: -17.7476,
    ath_date: "2022-11-10T12:22:53.410Z",
    atl: 0.00209672,
    atl_change_percentage: 868.40805,
    atl_date: "2022-11-21T00:54:17.922Z",
    roi: null,
    last_updated: "2023-03-27T10:17:44.354Z",
    price_change_percentage_14d_in_currency: 754.6385045468219,
    price_change_percentage_1h_in_currency: null,
    price_change_percentage_1y_in_currency: -6.723443885789791,
    price_change_percentage_200d_in_currency: -7.5558057639568785,
    price_change_percentage_24h_in_currency: 82.22663434660583,
    price_change_percentage_30d_in_currency: null,
    price_change_percentage_7d_in_currency: null,
  },
  {
    id: "digibyte",
    symbol: "dgb",
    name: "DigiByte",
    image:
      "https://assets.coingecko.com/coins/images/63/large/digibyte.png?1547033717",
    current_price: 0.00931582,
    market_cap: 150131031,
    market_cap_rank: 222,
    fully_diluted_valuation: null,
    total_volume: 3109909,
    high_24h: 0.00969861,
    low_24h: 0.00921155,
    price_change_24h: -0.000332031500020801,
    price_change_percentage_24h: -3.44151,
    market_cap_change_24h: -5334802.097471923,
    market_cap_change_percentage_24h: -3.43149,
    circulating_supply: 16115714732.8816,
    total_supply: 21000000000,
    max_supply: null,
    ath: 0.178084,
    ath_change_percentage: -94.77461,
    ath_date: "2021-05-01T00:19:01.967Z",
    atl: 0.00003099,
    atl_change_percentage: 29931.03048,
    atl_date: "2015-01-14T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.567Z",
    price_change_percentage_14d_in_currency: -3.506011884063663,
    price_change_percentage_1h_in_currency: 0.12754321989929746,
    price_change_percentage_1y_in_currency: -61.6975968696991,
    price_change_percentage_200d_in_currency: -5.991174429804237,
    price_change_percentage_24h_in_currency: -3.44150873463678,
    price_change_percentage_30d_in_currency: -18.46370306927641,
    price_change_percentage_7d_in_currency: -7.177633378059321,
  },
  {
    id: "bitkub-coin",
    symbol: "kub",
    name: "Bitkub Coin",
    image:
      "https://assets.coingecko.com/coins/images/15760/large/KUB.png?1621825161",
    current_price: 1.67,
    market_cap: 148656008,
    market_cap_rank: 223,
    fully_diluted_valuation: 184042328,
    total_volume: 530559,
    high_24h: 1.72,
    low_24h: 1.66,
    price_change_24h: -0.051511524931430186,
    price_change_percentage_24h: -2.98683,
    market_cap_change_24h: -4435741.653472096,
    market_cap_change_percentage_24h: -2.89744,
    circulating_supply: 88850000,
    total_supply: 110000000,
    max_supply: 110000000,
    ath: 17.24,
    ath_change_percentage: -90.29741,
    ath_date: "2021-12-28T01:16:46.693Z",
    atl: 0.381968,
    atl_change_percentage: 337.91634,
    atl_date: "2021-07-20T14:22:47.966Z",
    roi: null,
    last_updated: "2023-03-27T23:31:09.236Z",
    price_change_percentage_14d_in_currency: 3.4408947047788456,
    price_change_percentage_1h_in_currency: -0.045598737606557076,
    price_change_percentage_1y_in_currency: -78.53324510652709,
    price_change_percentage_200d_in_currency: 12.562384874866542,
    price_change_percentage_24h_in_currency: -2.986827095355237,
    price_change_percentage_30d_in_currency: -7.314532387959193,
    price_change_percentage_7d_in_currency: -6.948123185353079,
  },
  {
    id: "everscale",
    symbol: "ever",
    name: "Everscale",
    image:
      "https://assets.coingecko.com/coins/images/12783/large/everscale_badge_main_round_1x.png?1640050196",
    current_price: 0.085387,
    market_cap: 148494808,
    market_cap_rank: 224,
    fully_diluted_valuation: null,
    total_volume: 7631037,
    high_24h: 0.087296,
    low_24h: 0.084074,
    price_change_24h: -0.001805245992251695,
    price_change_percentage_24h: -2.07041,
    market_cap_change_24h: -3108180.247787267,
    market_cap_change_percentage_24h: -2.05021,
    circulating_supply: 1739034833,
    total_supply: 2078871650,
    max_supply: null,
    ath: 2.56,
    ath_change_percentage: -96.67365,
    ath_date: "2020-10-13T21:23:14.299Z",
    atl: 0.02451169,
    atl_change_percentage: 247.72998,
    atl_date: "2022-12-29T07:05:05.994Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.974Z",
    price_change_percentage_14d_in_currency: -8.70333176033909,
    price_change_percentage_1h_in_currency: 0.13943470854956352,
    price_change_percentage_1y_in_currency: -63.63744503122758,
    price_change_percentage_200d_in_currency: -1.516024169245442,
    price_change_percentage_24h_in_currency: -2.0704097304792843,
    price_change_percentage_30d_in_currency: -16.131519233399843,
    price_change_percentage_7d_in_currency: -4.174317679374971,
  },
  {
    id: "origintrail",
    symbol: "trac",
    name: "OriginTrail",
    image:
      "https://assets.coingecko.com/coins/images/1877/large/TRAC.jpg?1635134367",
    current_price: 0.380148,
    market_cap: 146067246,
    market_cap_rank: 225,
    fully_diluted_valuation: 190788687,
    total_volume: 1254613,
    high_24h: 0.388185,
    low_24h: 0.359915,
    price_change_24h: -0.007502462649016385,
    price_change_percentage_24h: -1.93537,
    market_cap_change_24h: -2178940.3949413,
    market_cap_change_percentage_24h: -1.46981,
    circulating_supply: 382798499.36395836,
    total_supply: 500000000,
    max_supply: 500000000,
    ath: 3.5,
    ath_change_percentage: -89.10669,
    ath_date: "2021-11-03T18:09:57.627Z",
    atl: 0.00385262,
    atl_change_percentage: 9810.24416,
    atl_date: "2020-03-13T02:24:12.031Z",
    roi: {
      times: 2.801479625767168,
      currency: "usd",
      percentage: 280.1479625767168,
    },
    last_updated: "2023-03-27T23:31:54.718Z",
    price_change_percentage_14d_in_currency: 22.869682086303243,
    price_change_percentage_1h_in_currency: -0.48400192078693444,
    price_change_percentage_1y_in_currency: -44.05937250872471,
    price_change_percentage_200d_in_currency: 89.01048763165574,
    price_change_percentage_24h_in_currency: -1.9353680947589869,
    price_change_percentage_30d_in_currency: 1.9279259432682974,
    price_change_percentage_7d_in_currency: -0.273346545270667,
  },
  {
    id: "lisk",
    symbol: "lsk",
    name: "Lisk",
    image:
      "https://assets.coingecko.com/coins/images/385/large/Lisk_Symbol_-_Blue.png?1573444104",
    current_price: 1.004,
    market_cap: 145464129,
    market_cap_rank: 226,
    fully_diluted_valuation: null,
    total_volume: 1518869,
    high_24h: 1.082,
    low_24h: 0.992764,
    price_change_24h: -0.07597312630443787,
    price_change_percentage_24h: -7.0338,
    market_cap_change_24h: -10965904.398961246,
    market_cap_change_percentage_24h: -7.0101,
    circulating_supply: 144818773,
    total_supply: null,
    max_supply: null,
    ath: 34.92,
    ath_change_percentage: -97.1227,
    ath_date: "2018-01-07T00:00:00.000Z",
    atl: 0.101672,
    atl_change_percentage: 888.34392,
    atl_date: "2017-03-01T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:55.866Z",
    price_change_percentage_14d_in_currency: 4.01103013830047,
    price_change_percentage_1h_in_currency: 0.1352429064461883,
    price_change_percentage_1y_in_currency: -57.2493120467059,
    price_change_percentage_200d_in_currency: -0.46882824387604854,
    price_change_percentage_24h_in_currency: -7.033803898753309,
    price_change_percentage_30d_in_currency: -16.035828546353436,
    price_change_percentage_7d_in_currency: -12.931703765082245,
  },
  {
    id: "swipe",
    symbol: "sxp",
    name: "SXP",
    image:
      "https://assets.coingecko.com/coins/images/9368/large/swipe.png?1566792311",
    current_price: 0.258086,
    market_cap: 143904836,
    market_cap_rank: 227,
    fully_diluted_valuation: 143904284,
    total_volume: 11617652,
    high_24h: 0.270989,
    low_24h: 0.251829,
    price_change_24h: -0.012564796628063092,
    price_change_percentage_24h: -4.64243,
    market_cap_change_24h: -7764673.2634494305,
    market_cap_change_percentage_24h: -5.11947,
    circulating_supply: 559240099.314731,
    total_supply: 559237952.997501,
    max_supply: null,
    ath: 5.79,
    ath_change_percentage: -95.55559,
    ath_date: "2021-05-03T15:29:39.372Z",
    atl: 0.161303,
    atl_change_percentage: 59.53194,
    atl_date: "2020-03-18T13:24:48.021Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.252Z",
    price_change_percentage_14d_in_currency: 1.2921509400959732,
    price_change_percentage_1h_in_currency: 0.14132796295469405,
    price_change_percentage_1y_in_currency: -84.20477535975249,
    price_change_percentage_200d_in_currency: -27.649404782472985,
    price_change_percentage_24h_in_currency: -4.6424328061150435,
    price_change_percentage_30d_in_currency: -20.574848278420088,
    price_change_percentage_7d_in_currency: -13.940762199829576,
  },
  {
    id: "ocean-protocol",
    symbol: "ocean",
    name: "Ocean Protocol",
    image:
      "https://assets.coingecko.com/coins/images/3687/large/ocean-protocol-logo.jpg?1547038686",
    current_price: 0.329675,
    market_cap: 142895813,
    market_cap_rank: 228,
    fully_diluted_valuation: 464218060,
    total_volume: 19173222,
    high_24h: 0.358282,
    low_24h: 0.324328,
    price_change_24h: -0.02820047549971444,
    price_change_percentage_24h: -7.87997,
    market_cap_change_24h: -12605577.66941765,
    market_cap_change_percentage_24h: -8.10641,
    circulating_supply: 434026836.76781356,
    total_supply: 613099141,
    max_supply: 1410000000,
    ath: 1.93,
    ath_change_percentage: -82.93904,
    ath_date: "2021-04-10T09:24:58.915Z",
    atl: 0.01284832,
    atl_change_percentage: 2462.75668,
    atl_date: "2019-08-11T00:00:00.000Z",
    roi: {
      times: 1.7472926866122842,
      currency: "usd",
      percentage: 174.72926866122842,
    },
    last_updated: "2023-03-27T23:31:59.563Z",
    price_change_percentage_14d_in_currency: -11.043180560232335,
    price_change_percentage_1h_in_currency: 0.26311676244782806,
    price_change_percentage_1y_in_currency: -45.18747976938174,
    price_change_percentage_200d_in_currency: 74.77181254054668,
    price_change_percentage_24h_in_currency: -7.879966017725283,
    price_change_percentage_30d_in_currency: -21.814939996541398,
    price_change_percentage_7d_in_currency: -17.728077971682698,
  },
  {
    id: "hive",
    symbol: "hive",
    name: "Hive",
    image:
      "https://assets.coingecko.com/coins/images/10840/large/logo_transparent_4x.png?1584623184",
    current_price: 0.383412,
    market_cap: 142345929,
    market_cap_rank: 229,
    fully_diluted_valuation: null,
    total_volume: 4206397,
    high_24h: 0.401946,
    low_24h: 0.3702,
    price_change_24h: -0.018516239628040276,
    price_change_percentage_24h: -4.60686,
    market_cap_change_24h: -7020689.081514478,
    market_cap_change_percentage_24h: -4.70031,
    circulating_supply: 371261453.714,
    total_supply: null,
    max_supply: null,
    ath: 3.41,
    ath_change_percentage: -88.7597,
    ath_date: "2021-11-26T01:46:11.175Z",
    atl: 0.087309,
    atl_change_percentage: 338.72406,
    atl_date: "2020-04-06T07:35:48.099Z",
    roi: null,
    last_updated: "2023-03-27T23:31:53.348Z",
    price_change_percentage_14d_in_currency: 4.511768899042779,
    price_change_percentage_1h_in_currency: 0.574766523599417,
    price_change_percentage_1y_in_currency: -63.417441818005116,
    price_change_percentage_200d_in_currency: -28.270359005221312,
    price_change_percentage_24h_in_currency: -4.606857286575753,
    price_change_percentage_30d_in_currency: -22.958820036549756,
    price_change_percentage_7d_in_currency: -12.602329298309673,
  },
  {
    id: "staked-frax-ether",
    symbol: "sfrxeth",
    name: "Staked Frax Ether",
    image:
      "https://assets.coingecko.com/coins/images/28285/large/sfrxETH_icon.png?1679886768",
    current_price: 1850.48,
    market_cap: 139834143,
    market_cap_rank: 230,
    fully_diluted_valuation: 139834143,
    total_volume: 3.56,
    high_24h: null,
    low_24h: null,
    price_change_24h: null,
    price_change_percentage_24h: null,
    market_cap_change_24h: null,
    market_cap_change_percentage_24h: null,
    circulating_supply: 75566.2408545241,
    total_supply: 75566.2408545241,
    max_supply: null,
    ath: 7545.09,
    ath_change_percentage: -75.47434,
    ath_date: "2023-02-16T07:51:36.849Z",
    atl: 1147.58,
    atl_change_percentage: 61.25042,
    atl_date: "2022-12-23T11:50:57.675Z",
    roi: null,
    last_updated: "2023-03-24T14:00:53.060Z",
    price_change_percentage_14d_in_currency: null,
    price_change_percentage_1h_in_currency: null,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: null,
    price_change_percentage_30d_in_currency: 12.656193940187588,
    price_change_percentage_7d_in_currency: 0.11435307201245135,
  },
  {
    id: "celsius-degree-token",
    symbol: "cel",
    name: "Celsius Network",
    image:
      "https://assets.coingecko.com/coins/images/3263/large/CEL_logo.png?1609598753",
    current_price: 0.328876,
    market_cap: 139252716,
    market_cap_rank: 231,
    fully_diluted_valuation: null,
    total_volume: 1062626,
    high_24h: 0.348229,
    low_24h: 0.317646,
    price_change_24h: -0.018226756459683247,
    price_change_percentage_24h: -5.25111,
    market_cap_change_24h: -7743788.453211963,
    market_cap_change_percentage_24h: -5.26801,
    circulating_supply: 423415980.3475,
    total_supply: 692753441.4971,
    max_supply: null,
    ath: 8.05,
    ath_change_percentage: -95.91775,
    ath_date: "2021-06-04T00:04:12.584Z",
    atl: 0.02620268,
    atl_change_percentage: 1153.68295,
    atl_date: "2018-12-07T00:00:00.000Z",
    roi: {
      times: 0.09625405248254466,
      currency: "usd",
      percentage: 9.625405248254467,
    },
    last_updated: "2023-03-27T23:31:52.019Z",
    price_change_percentage_14d_in_currency: -15.902311875303846,
    price_change_percentage_1h_in_currency: 0.4046874743892399,
    price_change_percentage_1y_in_currency: -89.97912233204408,
    price_change_percentage_200d_in_currency: -75.59189875224041,
    price_change_percentage_24h_in_currency: -5.251109301636152,
    price_change_percentage_30d_in_currency: -35.29758890868269,
    price_change_percentage_7d_in_currency: -13.007021804701822,
  },
  {
    id: "safemoon-2",
    symbol: "sfm",
    name: "SafeMoon",
    image:
      "https://assets.coingecko.com/coins/images/21863/large/photo_2021-12-22_14.43.36.jpeg?1640155440",
    current_price: 0.00024919,
    market_cap: 138327702,
    market_cap_rank: 232,
    fully_diluted_valuation: null,
    total_volume: 969480,
    high_24h: 0.00025246,
    low_24h: 0.00023023,
    price_change_24h: -6.7774018849e-8,
    price_change_percentage_24h: -0.02719,
    market_cap_change_24h: 2214865,
    market_cap_change_percentage_24h: 1.62723,
    circulating_supply: 559714983957.7458,
    total_supply: 1000000000000,
    max_supply: null,
    ath: 0.00338272,
    ath_change_percentage: -92.66636,
    ath_date: "2022-01-05T17:56:02.772Z",
    atl: 0.000159,
    atl_change_percentage: 56.02474,
    atl_date: "2023-03-12T07:19:25.287Z",
    roi: null,
    last_updated: "2023-03-27T23:30:57.567Z",
    price_change_percentage_14d_in_currency: 21.4486574132119,
    price_change_percentage_1h_in_currency: 6.507341192190951,
    price_change_percentage_1y_in_currency: -75.2671466446294,
    price_change_percentage_200d_in_currency: -28.66864534192084,
    price_change_percentage_24h_in_currency: -0.027190501975744685,
    price_change_percentage_30d_in_currency: -8.18004391298362,
    price_change_percentage_7d_in_currency: 8.49541012762237,
  },
  {
    id: "aelf",
    symbol: "elf",
    name: "aelf",
    image:
      "https://assets.coingecko.com/coins/images/1371/large/aelf-logo.png?1547035397",
    current_price: 0.299113,
    market_cap: 138084800,
    market_cap_rank: 233,
    fully_diluted_valuation: null,
    total_volume: 9107941,
    high_24h: 0.309205,
    low_24h: 0.296356,
    price_change_24h: -0.010092093273799452,
    price_change_percentage_24h: -3.26389,
    market_cap_change_24h: -4694732.703844428,
    market_cap_change_percentage_24h: -3.2881,
    circulating_supply: 461329999,
    total_supply: 879999999.986466,
    max_supply: null,
    ath: 2.6,
    ath_change_percentage: -88.51917,
    ath_date: "2018-01-09T00:00:00.000Z",
    atl: 0.03545756,
    atl_change_percentage: 743.18767,
    atl_date: "2020-03-13T02:22:35.431Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.406Z",
    price_change_percentage_14d_in_currency: -6.76069251674282,
    price_change_percentage_1h_in_currency: -0.08288511231229778,
    price_change_percentage_1y_in_currency: -18.67017077682423,
    price_change_percentage_200d_in_currency: 120.22778246391297,
    price_change_percentage_24h_in_currency: -3.2638853391985654,
    price_change_percentage_30d_in_currency: 8.220205848736938,
    price_change_percentage_7d_in_currency: -4.430701085978244,
  },
  {
    id: "fuc",
    symbol: "fuc",
    name: "FUBT Token",
    image:
      "https://assets.coingecko.com/coins/images/8132/large/FUC_fubt_token.png?1555325050",
    current_price: 1.56,
    market_cap: 137737131,
    market_cap_rank: 234,
    fully_diluted_valuation: 156025990,
    total_volume: 179923,
    high_24h: 1.57,
    low_24h: 1.54,
    price_change_24h: 0.00489734,
    price_change_percentage_24h: 0.31487,
    market_cap_change_24h: 561085,
    market_cap_change_percentage_24h: 0.40903,
    circulating_supply: 88278325.001,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 1.63,
    ath_change_percentage: -4.45756,
    ath_date: "2023-03-23T14:52:39.563Z",
    atl: 0.02685038,
    atl_change_percentage: 5710.94081,
    atl_date: "2023-02-08T09:11:05.886Z",
    roi: null,
    last_updated: "2023-03-27T23:16:52.417Z",
    price_change_percentage_14d_in_currency: 3721.711040577204,
    price_change_percentage_1h_in_currency: 0.47839401298115813,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: 0.3148682828254462,
    price_change_percentage_30d_in_currency: 5081.212164279513,
    price_change_percentage_7d_in_currency: 85.76632659045866,
  },
  {
    id: "illuvium",
    symbol: "ilv",
    name: "Illuvium",
    image:
      "https://assets.coingecko.com/coins/images/14468/large/ILV.JPG?1617182121",
    current_price: 55.98,
    market_cap: 137334054,
    market_cap_rank: 235,
    fully_diluted_valuation: 559839905,
    total_volume: 11991801,
    high_24h: 61.79,
    low_24h: 55.35,
    price_change_24h: -5.692572386435032,
    price_change_percentage_24h: -9.22972,
    market_cap_change_24h: -13350998.171139747,
    market_cap_change_percentage_24h: -8.8602,
    circulating_supply: 2453095.1313470444,
    total_supply: 7580680.30068259,
    max_supply: 10000000,
    ath: 1911.26,
    ath_change_percentage: -97.07067,
    ath_date: "2021-11-30T15:18:57.382Z",
    atl: 29.23,
    atl_change_percentage: 91.56466,
    atl_date: "2021-06-22T14:11:59.151Z",
    roi: null,
    last_updated: "2023-03-27T23:31:54.209Z",
    price_change_percentage_14d_in_currency: -15.889283278565152,
    price_change_percentage_1h_in_currency: 0.18687904513295162,
    price_change_percentage_1y_in_currency: -90.52820278366181,
    price_change_percentage_200d_in_currency: -24.101421462042456,
    price_change_percentage_24h_in_currency: -9.229717289475094,
    price_change_percentage_30d_in_currency: -23.729856039201742,
    price_change_percentage_7d_in_currency: -23.891176275825483,
  },
  {
    id: "telcoin",
    symbol: "tel",
    name: "Telcoin",
    image:
      "https://assets.coingecko.com/coins/images/1899/large/tel.png?1547036203",
    current_price: 0.00200215,
    market_cap: 136608043,
    market_cap_rank: 236,
    fully_diluted_valuation: null,
    total_volume: 957695,
    high_24h: 0.00210021,
    low_24h: 0.0019884,
    price_change_24h: -0.000094646441787519,
    price_change_percentage_24h: -4.51386,
    market_cap_change_24h: -6479307.429896891,
    market_cap_change_percentage_24h: -4.52822,
    circulating_supply: 68421497266.73,
    total_supply: 100000000000,
    max_supply: null,
    ath: 0.064483,
    ath_change_percentage: -96.90289,
    ath_date: "2021-05-11T00:32:24.043Z",
    atl: 0.00006474,
    atl_change_percentage: 2984.98116,
    atl_date: "2020-03-13T02:24:47.992Z",
    roi: {
      times: 1.002150298274745,
      currency: "usd",
      percentage: 100.2150298274745,
    },
    last_updated: "2023-03-27T23:31:58.891Z",
    price_change_percentage_14d_in_currency: -15.423491228771471,
    price_change_percentage_1h_in_currency: 0.18828551391973153,
    price_change_percentage_1y_in_currency: -76.0504943399415,
    price_change_percentage_200d_in_currency: 33.24430844530365,
    price_change_percentage_24h_in_currency: -4.513858686403179,
    price_change_percentage_30d_in_currency: -17.90455831560189,
    price_change_percentage_7d_in_currency: -13.242050740731132,
  },
  {
    id: "ribbon-finance",
    symbol: "rbn",
    name: "Ribbon Finance",
    image:
      "https://assets.coingecko.com/coins/images/15823/large/RBN_64x64.png?1633529723",
    current_price: 0.202554,
    market_cap: 133997262,
    market_cap_rank: 237,
    fully_diluted_valuation: 202104037,
    total_volume: 597261,
    high_24h: 0.210765,
    low_24h: 0.201939,
    price_change_24h: -0.003540812893209705,
    price_change_percentage_24h: -1.71805,
    market_cap_change_24h: -2423482.769199148,
    market_cap_change_percentage_24h: -1.77648,
    circulating_supply: 663011307.384619,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 5.54,
    ath_change_percentage: -96.352,
    ath_date: "2021-10-07T22:30:49.258Z",
    atl: 0.153983,
    atl_change_percentage: 31.29078,
    atl_date: "2022-11-22T02:23:19.787Z",
    roi: null,
    last_updated: "2023-03-27T23:31:49.052Z",
    price_change_percentage_14d_in_currency: -0.9526413916533873,
    price_change_percentage_1h_in_currency: 0.14891415174610317,
    price_change_percentage_1y_in_currency: -85.5309779127202,
    price_change_percentage_200d_in_currency: -4.27658835606929,
    price_change_percentage_24h_in_currency: -1.718053717236233,
    price_change_percentage_30d_in_currency: -13.972932966983256,
    price_change_percentage_7d_in_currency: -18.959189323883948,
  },
  {
    id: "stasis-eurs",
    symbol: "eurs",
    name: "STASIS EURO",
    image:
      "https://assets.coingecko.com/coins/images/5164/large/EURS_300x300.png?1550571779",
    current_price: 1.078,
    market_cap: 133771423,
    market_cap_rank: 238,
    fully_diluted_valuation: 133771423,
    total_volume: 327980,
    high_24h: 1.092,
    low_24h: 1.061,
    price_change_24h: -0.000592013166229588,
    price_change_percentage_24h: -0.05487,
    market_cap_change_24h: -372660.65542551875,
    market_cap_change_percentage_24h: -0.27781,
    circulating_supply: 124125940,
    total_supply: 124125940,
    max_supply: 124125940,
    ath: 1.79,
    ath_change_percentage: -39.90493,
    ath_date: "2023-03-14T12:00:06.279Z",
    atl: 0.929636,
    atl_change_percentage: 15.91736,
    atl_date: "2022-11-10T13:44:54.149Z",
    roi: null,
    last_updated: "2023-03-27T23:31:40.065Z",
    price_change_percentage_14d_in_currency: 0.707440911640878,
    price_change_percentage_1h_in_currency: 0.09289447907572577,
    price_change_percentage_1y_in_currency: -1.7089223522433337,
    price_change_percentage_200d_in_currency: 8.264255984860512,
    price_change_percentage_24h_in_currency: -0.05486870328306368,
    price_change_percentage_30d_in_currency: 2.885519126475029,
    price_change_percentage_7d_in_currency: 0.7816523143052244,
  },
  {
    id: "constellation-labs",
    symbol: "dag",
    name: "Constellation",
    image:
      "https://assets.coingecko.com/coins/images/4645/large/Constellation_Network_Logo.png?1662543939",
    current_price: 0.050791,
    market_cap: 133017806,
    market_cap_rank: 239,
    fully_diluted_valuation: null,
    total_volume: 547683,
    high_24h: 0.054746,
    low_24h: 0.04949259,
    price_change_24h: -0.002810607677029419,
    price_change_percentage_24h: -5.2435,
    market_cap_change_24h: -7417330.365036279,
    market_cap_change_percentage_24h: -5.28168,
    circulating_supply: 2619017377.29443,
    total_supply: 3550000000,
    max_supply: null,
    ath: 0.451761,
    ath_change_percentage: -88.74823,
    ath_date: "2021-08-25T23:30:00.311Z",
    atl: 0.00110189,
    atl_change_percentage: 4513.08552,
    atl_date: "2019-03-09T00:00:00.000Z",
    roi: {
      times: -0.5561844985166006,
      currency: "eth",
      percentage: -55.61844985166006,
    },
    last_updated: "2023-03-27T23:31:50.737Z",
    price_change_percentage_14d_in_currency: 11.939144050999325,
    price_change_percentage_1h_in_currency: 0.2348278249921383,
    price_change_percentage_1y_in_currency: -70.43057590773884,
    price_change_percentage_200d_in_currency: -32.12710830332844,
    price_change_percentage_24h_in_currency: -5.243503849681893,
    price_change_percentage_30d_in_currency: 0.30957287856869886,
    price_change_percentage_7d_in_currency: 8.17756265034652,
  },
  {
    id: "zencash",
    symbol: "zen",
    name: "Horizen",
    image:
      "https://assets.coingecko.com/coins/images/691/large/horizen.png?1555052241",
    current_price: 9.76,
    market_cap: 131609213,
    market_cap_rank: 240,
    fully_diluted_valuation: 204503991,
    total_volume: 9873433,
    high_24h: 10.38,
    low_24h: 9.6,
    price_change_24h: -0.6138545161665725,
    price_change_percentage_24h: -5.91961,
    market_cap_change_24h: -8813298.02216795,
    market_cap_change_percentage_24h: -6.27627,
    circulating_supply: 13514618.75,
    total_supply: 13514568.75,
    max_supply: 21000000,
    ath: 165.92,
    ath_change_percentage: -94.12793,
    ath_date: "2021-05-08T06:00:30.087Z",
    atl: 3.26,
    atl_change_percentage: 198.44567,
    atl_date: "2019-10-17T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:56.965Z",
    price_change_percentage_14d_in_currency: -1.2802027968111123,
    price_change_percentage_1h_in_currency: 0.11151602641485986,
    price_change_percentage_1y_in_currency: -79.19591506497075,
    price_change_percentage_200d_in_currency: -34.568893639510144,
    price_change_percentage_24h_in_currency: -5.91960696717061,
    price_change_percentage_30d_in_currency: -21.332321196031337,
    price_change_percentage_7d_in_currency: -10.007249337475573,
  },
  {
    id: "rif-token",
    symbol: "rif",
    name: "RSK Infrastructure Framework",
    image:
      "https://assets.coingecko.com/coins/images/7460/large/RIF.png?1558011767",
    current_price: 0.137047,
    market_cap: 130465666,
    market_cap_rank: 241,
    fully_diluted_valuation: null,
    total_volume: 10774817,
    high_24h: 0.154007,
    low_24h: 0.13176,
    price_change_24h: -0.0163418865571886,
    price_change_percentage_24h: -10.6539,
    market_cap_change_24h: -15521787.428900093,
    market_cap_change_percentage_24h: -10.63227,
    circulating_supply: 953380002.20993,
    total_supply: 1000000000,
    max_supply: null,
    ath: 0.455938,
    ath_change_percentage: -69.98595,
    ath_date: "2021-04-12T21:44:18.713Z",
    atl: 0.0091475,
    atl_change_percentage: 1395.98688,
    atl_date: "2019-06-12T00:00:00.000Z",
    roi: null,
    last_updated: "2023-03-27T23:31:46.517Z",
    price_change_percentage_14d_in_currency: 17.683288897557652,
    price_change_percentage_1h_in_currency: -0.3375384699338137,
    price_change_percentage_1y_in_currency: -14.63543251264683,
    price_change_percentage_200d_in_currency: 125.98954847176584,
    price_change_percentage_24h_in_currency: -10.653898907411504,
    price_change_percentage_30d_in_currency: 12.037991990686777,
    price_change_percentage_7d_in_currency: -25.639871399132698,
  },
  {
    id: "alethea-artificial-liquid-intelligence-token",
    symbol: "ali",
    name: "Artificial Liquid Intelligence",
    image:
      "https://assets.coingecko.com/coins/images/22062/large/alethea-logo-transparent-colored.png?1642748848",
    current_price: 0.03616277,
    market_cap: 129765715,
    market_cap_rank: 242,
    fully_diluted_valuation: 361649375,
    total_volume: 3050962,
    high_24h: 0.03876766,
    low_24h: 0.03506582,
    price_change_24h: -0.002326517352321499,
    price_change_percentage_24h: -6.04458,
    market_cap_change_24h: -8490957.894860744,
    market_cap_change_percentage_24h: -6.14145,
    circulating_supply: 3588163659.734976,
    total_supply: 10000000000,
    max_supply: 10000000000,
    ath: 0.201312,
    ath_change_percentage: -82.07554,
    ath_date: "2022-04-02T01:23:27.379Z",
    atl: 0.00565078,
    atl_change_percentage: 538.56835,
    atl_date: "2022-11-13T21:26:06.429Z",
    roi: null,
    last_updated: "2023-03-27T23:31:47.644Z",
    price_change_percentage_14d_in_currency: -26.868941969033035,
    price_change_percentage_1h_in_currency: 0.33211729305362525,
    price_change_percentage_1y_in_currency: 34.3259933057897,
    price_change_percentage_200d_in_currency: 213.06676521979702,
    price_change_percentage_24h_in_currency: -6.044583666928132,
    price_change_percentage_30d_in_currency: -32.850353781820075,
    price_change_percentage_7d_in_currency: -15.536727713689741,
  },
  {
    id: "space-id",
    symbol: "id",
    name: "SPACE ID",
    image:
      "https://assets.coingecko.com/coins/images/29468/large/sid_token_logo_%28green2%29.png?1679454702",
    current_price: 0.450001,
    market_cap: 128493949,
    market_cap_rank: 243,
    fully_diluted_valuation: 898559082,
    total_volume: 119450984,
    high_24h: 0.512614,
    low_24h: 0.436216,
    price_change_24h: -0.04482044545783692,
    price_change_percentage_24h: -9.05791,
    market_cap_change_24h: -13055053.731864437,
    market_cap_change_percentage_24h: -9.22299,
    circulating_supply: 286000000,
    total_supply: 2000000000,
    max_supply: 2000000000,
    ath: 0.91512,
    ath_change_percentage: -50.93435,
    ath_date: "2023-03-22T11:26:11.677Z",
    atl: 0.388601,
    atl_change_percentage: 15.54522,
    atl_date: "2023-03-22T20:01:11.674Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.034Z",
    price_change_percentage_14d_in_currency: null,
    price_change_percentage_1h_in_currency: 1.2282183626314427,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: -9.057910392540325,
    price_change_percentage_30d_in_currency: null,
    price_change_percentage_7d_in_currency: null,
  },
  {
    id: "seth2",
    symbol: "seth2",
    name: "sETH2",
    image:
      "https://assets.coingecko.com/coins/images/16569/large/emerald256.png?1624494960",
    current_price: 1704.06,
    market_cap: 127666787,
    market_cap_rank: 244,
    fully_diluted_valuation: null,
    total_volume: 221880,
    high_24h: 1782.27,
    low_24h: 1698.75,
    price_change_24h: -76.70842992675603,
    price_change_percentage_24h: -4.3076,
    market_cap_change_24h: -5803790.604968652,
    market_cap_change_percentage_24h: -4.34837,
    circulating_supply: 74956.3516273359,
    total_supply: 74956.4376273359,
    max_supply: null,
    ath: 4821.87,
    ath_change_percentage: -64.68748,
    ath_date: "2021-11-10T14:23:55.647Z",
    atl: 887.7,
    atl_change_percentage: 91.81338,
    atl_date: "2022-06-18T20:57:32.629Z",
    roi: null,
    last_updated: "2023-03-27T23:31:47.669Z",
    price_change_percentage_14d_in_currency: 8.212433730928993,
    price_change_percentage_1h_in_currency: 0.07926172954352734,
    price_change_percentage_1y_in_currency: -45.56767881036089,
    price_change_percentage_200d_in_currency: 5.593286214132977,
    price_change_percentage_24h_in_currency: -4.307601577350004,
    price_change_percentage_30d_in_currency: 6.741441473438209,
    price_change_percentage_7d_in_currency: -4.919569114027779,
  },
  {
    id: "lukso-token",
    symbol: "lyxe",
    name: "LUKSO",
    image:
      "https://assets.coingecko.com/coins/images/11423/large/1_QAHTciwVhD7SqVmfRW70Pw.png?1590110612",
    current_price: 8.19,
    market_cap: 126723113,
    market_cap_rank: 245,
    fully_diluted_valuation: 818840808,
    total_volume: 1029491,
    high_24h: 8.45,
    low_24h: 7.81,
    price_change_24h: -0.2576398008437497,
    price_change_percentage_24h: -3.05137,
    market_cap_change_24h: -2018733.953222394,
    market_cap_change_percentage_24h: -1.56805,
    circulating_supply: 15475915.708856644,
    total_supply: 100000000,
    max_supply: 100000000,
    ath: 41.18,
    ath_change_percentage: -80.11424,
    ath_date: "2021-11-04T07:31:04.430Z",
    atl: 0.203056,
    atl_change_percentage: 3932.68229,
    atl_date: "2020-07-18T10:14:36.612Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.849Z",
    price_change_percentage_14d_in_currency: -7.567876946196971,
    price_change_percentage_1h_in_currency: -0.06400615145539088,
    price_change_percentage_1y_in_currency: -50.420055922331045,
    price_change_percentage_200d_in_currency: 68.90184735887239,
    price_change_percentage_24h_in_currency: -3.051372050733695,
    price_change_percentage_30d_in_currency: -20.944426285658356,
    price_change_percentage_7d_in_currency: -6.512679690298924,
  },
  {
    id: "secret",
    symbol: "scrt",
    name: "Secret",
    image:
      "https://assets.coingecko.com/coins/images/11871/large/secret_logo.png?1677312924",
    current_price: 0.620088,
    market_cap: 124224817,
    market_cap_rank: 246,
    fully_diluted_valuation: null,
    total_volume: 1465614,
    high_24h: 0.644573,
    low_24h: 0.613195,
    price_change_24h: -0.022214220003181184,
    price_change_percentage_24h: -3.45853,
    market_cap_change_24h: -4640272.349927172,
    market_cap_change_percentage_24h: -3.60088,
    circulating_supply: 200355268,
    total_supply: 190198234,
    max_supply: null,
    ath: 10.38,
    ath_change_percentage: -94.0292,
    ath_date: "2021-10-28T12:44:49.785Z",
    atl: 0.255219,
    atl_change_percentage: 142.95031,
    atl_date: "2020-11-03T06:12:33.048Z",
    roi: null,
    last_updated: "2023-03-27T23:31:54.306Z",
    price_change_percentage_14d_in_currency: -5.613515026748347,
    price_change_percentage_1h_in_currency: -0.21049649814680826,
    price_change_percentage_1y_in_currency: -87.22118127604149,
    price_change_percentage_200d_in_currency: -42.141310552755215,
    price_change_percentage_24h_in_currency: -3.458528821396219,
    price_change_percentage_30d_in_currency: -21.43680136888183,
    price_change_percentage_7d_in_currency: -11.52846652070765,
  },
  {
    id: "marblex",
    symbol: "mbx",
    name: "Marblex",
    image:
      "https://assets.coingecko.com/coins/images/24423/large/AgYzKzLt_400x400.jpg?1647654911",
    current_price: 2.88,
    market_cap: 124108332,
    market_cap_rank: 247,
    fully_diluted_valuation: 2828891455,
    total_volume: 3362498,
    high_24h: 3.06,
    low_24h: 2.73,
    price_change_24h: 0.117656,
    price_change_percentage_24h: 4.25474,
    market_cap_change_24h: 2519775,
    market_cap_change_percentage_24h: 2.07238,
    circulating_supply: 43871719.2638769,
    total_supply: 999991774,
    max_supply: 1000000000,
    ath: 20.74,
    ath_change_percentage: -86.3454,
    ath_date: "2022-06-30T23:43:10.298Z",
    atl: 1.013,
    atl_change_percentage: 179.61479,
    atl_date: "2023-01-06T17:51:05.909Z",
    roi: null,
    last_updated: "2023-03-27T23:31:58.864Z",
    price_change_percentage_14d_in_currency: 76.44248774059899,
    price_change_percentage_1h_in_currency: 0.8134619799652166,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: -42.87839375271284,
    price_change_percentage_24h_in_currency: 4.254743527353197,
    price_change_percentage_30d_in_currency: 80.32422544689585,
    price_change_percentage_7d_in_currency: 33.614322400668584,
  },
  {
    id: "axelar",
    symbol: "axl",
    name: "Axelar",
    image:
      "https://assets.coingecko.com/coins/images/27277/large/V-65_xQ1_400x400.jpeg?1663121730",
    current_price: 0.601748,
    market_cap: 123866232,
    market_cap_rank: 248,
    fully_diluted_valuation: 631338816,
    total_volume: 955617,
    high_24h: 0.61538,
    low_24h: 0.594491,
    price_change_24h: -0.010057972449795671,
    price_change_percentage_24h: -1.64398,
    market_cap_change_24h: -1338011.7955488116,
    market_cap_change_percentage_24h: -1.06866,
    circulating_supply: 205790883.097682,
    total_supply: 1048903887.10016,
    max_supply: null,
    ath: 1.15,
    ath_change_percentage: -47.95075,
    ath_date: "2022-09-27T22:19:02.643Z",
    atl: 0.387962,
    atl_change_percentage: 54.94922,
    atl_date: "2022-12-13T13:51:07.242Z",
    roi: null,
    last_updated: "2023-03-27T23:31:59.624Z",
    price_change_percentage_14d_in_currency: -6.024087570870303,
    price_change_percentage_1h_in_currency: 0.32590540785930616,
    price_change_percentage_1y_in_currency: null,
    price_change_percentage_200d_in_currency: null,
    price_change_percentage_24h_in_currency: -1.6439813246585069,
    price_change_percentage_30d_in_currency: -17.050293685537333,
    price_change_percentage_7d_in_currency: -6.242200178157096,
  },
  {
    id: "tribe-2",
    symbol: "tribe",
    name: "Tribe",
    image:
      "https://assets.coingecko.com/coins/images/14575/large/tribe.PNG?1617487954",
    current_price: 0.268032,
    market_cap: 121913589,
    market_cap_rank: 249,
    fully_diluted_valuation: 267932808,
    total_volume: 557047,
    high_24h: 0.27693,
    low_24h: 0.266351,
    price_change_24h: -0.005490242950925595,
    price_change_percentage_24h: -2.00724,
    market_cap_change_24h: -2802193.300293207,
    market_cap_change_percentage_24h: -2.24686,
    circulating_supply: 455015530.80485964,
    total_supply: 1000000000,
    max_supply: 1000000000,
    ath: 2.45,
    ath_change_percentage: -89.04778,
    ath_date: "2021-04-03T23:33:40.147Z",
    atl: 0.14412,
    atl_change_percentage: 86.16882,
    atl_date: "2022-08-19T07:45:15.996Z",
    roi: null,
    last_updated: "2023-03-27T23:31:52.060Z",
    price_change_percentage_14d_in_currency: 7.782821819638761,
    price_change_percentage_1h_in_currency: 0.01161026815427227,
    price_change_percentage_1y_in_currency: -52.60278250538747,
    price_change_percentage_200d_in_currency: 3.5862814157310607,
    price_change_percentage_24h_in_currency: -2.007239197692986,
    price_change_percentage_30d_in_currency: 3.25537394771472,
    price_change_percentage_7d_in_currency: -4.951057672655299,
  },
  {
    id: "api3",
    symbol: "api3",
    name: "API3",
    image:
      "https://assets.coingecko.com/coins/images/13256/large/api3.jpg?1606751424",
    current_price: 1.48,
    market_cap: 121320985,
    market_cap_rank: 250,
    fully_diluted_valuation: 181547244,
    total_volume: 5810428,
    high_24h: 1.56,
    low_24h: 1.45,
    price_change_24h: -0.07745949195440295,
    price_change_percentage_24h: -4.9772,
    market_cap_change_24h: -6354754.162854612,
    market_cap_change_percentage_24h: -4.97726,
    circulating_supply: 82072388.6734021,
    total_supply: 122814828.882039,
    max_supply: 122814828.882039,
    ath: 10.3,
    ath_change_percentage: -85.66066,
    ath_date: "2021-04-07T06:54:35.507Z",
    atl: 0.999416,
    atl_change_percentage: 47.74253,
    atl_date: "2023-01-01T05:11:51.404Z",
    roi: null,
    last_updated: "2023-03-27T23:31:48.257Z",
    price_change_percentage_14d_in_currency: 7.833443709078656,
    price_change_percentage_1h_in_currency: 0.7400405281691603,
    price_change_percentage_1y_in_currency: -75.57353411362934,
    price_change_percentage_200d_in_currency: -17.706720907733754,
    price_change_percentage_24h_in_currency: -4.97719917607585,
    price_change_percentage_30d_in_currency: -12.774301631730781,
    price_change_percentage_7d_in_currency: -21.31720338789853,
  },
];
